webpackJsonp([40],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(371)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(237),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(424),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(363)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(387)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(473),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(423),
  /* scopeId */
  "data-v-1883b718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(242),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TOGGLE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXPAND_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SWITCH_EFFECT; });
var TOGGLE_DEVICE = 'TOGGLE_DEVICE';

var TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

var EXPAND_MENU = 'EXPAND_MENU';

var SWITCH_EFFECT = 'SWITCH_EFFECT';

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(384)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(467),
  /* scopeId */
  "data-v-8757686c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(367)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(386)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(472),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(421),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(375)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(457),
  /* scopeId */
  "data-v-6753cc00",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lazyLoading__ = __webpack_require__(223);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// import charts from './charts'
// import uifeatures from './uifeatures'
// import components from './components'
// import tables from './tables'

// show: meta.label -> name
// name: component name
// meta.label: display label

var state = {
  items: [{
    name: 'Сценарии',
    path: '/scenarios',
    meta: {
      label: 'Сценарии',
      icon: 'fa-comments',
      link: 'scenarios/Scenarios.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('scenario/Scenarios')
  }, {
    name: 'Рассылки',
    path: '/campaigns',
    meta: {
      label: 'Рассылки',
      icon: 'fa-phone-square',
      link: 'campaigns/Campaigns.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('campaigns/Campaigns')
  }, {
    name: 'Архив рассылок',
    path: '/archive',
    meta: {
      label: 'Архив рассылок',
      icon: 'fas fa-archive',
      link: 'campaigns/Archive.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('campaigns/Archive')
  }, {
    name: 'Пользователи',
    path: '/users',
    meta: {
      label: 'Пользователи',
      icon: 'fa-user',
      link: 'users/Users.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('users/Users')
  }, {
    name: 'Клиенты',
    path: '/clients',
    meta: {
      label: 'Клиенты',
      icon: 'fa-building',
      link: 'clients/Clients.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('clients/Clients')
  }, {
    name: 'Настройка прав',
    path: '/permissions',
    meta: {
      label: 'Настройка прав',
      icon: 'fa-tasks',
      link: 'settings/Permissions.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('settings/Permissions')
  }, {
    name: 'Настройка приложения',
    path: '/appconfig',
    meta: {
      label: 'Настройка приложения',
      icon: 'fa-cogs',
      link: 'settings/AppConfig.vue'
    },
    component: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lazyLoading__["a" /* default */])('settings/AppConfig')
  }]
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], function (state, menuItem) {
  if (menuItem.index > -1) {
    if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
      state.items[menuItem.index].meta.expanded = menuItem.expanded;
    }
  } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
    menuItem.item.meta.expanded = menuItem.expanded;
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(379)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(462),
  /* scopeId */
  "data-v-71adb06e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(428),
  /* scopeId */
  "data-v-24d5b040",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(365)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  "data-v-5075c840",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(435),
  /* scopeId */
  "data-v-369d3951",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(427),
  /* scopeId */
  "data-v-2095a2c9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(468),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(425),
  /* scopeId */
  "data-v-1ce8085e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(362)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(475),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(368)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(471),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(382)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(465),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(364)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  "data-v-4a58c152",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(388)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(474),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(380)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(463),
  /* scopeId */
  "data-v-73698c7f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  "data-v-42f0ea42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(430),
  /* scopeId */
  "data-v-28ad3141",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(420),
  /* scopeId */
  "data-v-0fb9eb12",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(431),
  /* scopeId */
  "data-v-2cd61748",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(385)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(261),
  /* template */
  __webpack_require__(469),
  /* scopeId */
  "data-v-a6d3fa54",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(434),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(436),
  /* scopeId */
  "data-v-38b3bfa5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(377)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(459),
  /* scopeId */
  "data-v-6deb9466",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(383)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(466),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(215);


__WEBPACK_IMPORTED_MODULE_0__app__["a" /* app */].$mount('#app');

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(419),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Home.vue": [
		487,
		14
	],
	"./applications/Application.vue": [
		488,
		27
	],
	"./applications/Applications.vue": [
		489,
		37
	],
	"./audiorecording/audioRecorder.vue": [
		167
	],
	"./audiorecording/icon-button.vue": [
		168
	],
	"./authentication/CheckPermission.vue": [
		8
	],
	"./authentication/CheckToken.vue": [
		5
	],
	"./authentication/Login.vue": [
		169
	],
	"./authentication/SignUp.vue": [
		170
	],
	"./axios/index.vue": [
		490,
		26
	],
	"./billing/Billing.vue": [
		171
	],
	"./calltasks/Calltasks.vue": [
		491,
		36
	],
	"./calltasks/CalltasksCampaign.vue": [
		172
	],
	"./calltasks/GetCalltaskState.vue": [
		16
	],
	"./calltasks/Modal.vue": [
		492,
		25
	],
	"./calltasks/TestCallTasksResult.vue": [
		173
	],
	"./calltasks/TestCalltasksCampaign.vue": [
		174
	],
	"./campaigns/Archive.vue": [
		175
	],
	"./campaigns/Campaign.vue": [
		19
	],
	"./campaigns/CampaignMonitoring.vue": [
		176
	],
	"./campaigns/Campaigns.vue": [
		177
	],
	"./campaigns/Modal.vue": [
		25
	],
	"./charts/Chartist.vue": [
		493,
		7
	],
	"./charts/Chartjs.vue": [
		494,
		24
	],
	"./charts/Peity.vue": [
		495,
		30
	],
	"./charts/Plotly.vue": [
		496,
		13
	],
	"./charts/index.vue": [
		497,
		35
	],
	"./clientes/ClientParameters.vue": [
		178
	],
	"./clientes/Clientes.vue": [
		179
	],
	"./components/BackToTop.vue": [
		498,
		34
	],
	"./components/Brace.vue": [
		499,
		0
	],
	"./components/Collapse.vue": [
		500,
		23
	],
	"./components/Datepicker.vue": [
		501,
		22
	],
	"./components/Default.vue": [
		502,
		11
	],
	"./components/Emoji.vue": [
		503,
		5
	],
	"./components/Lory.vue": [
		504,
		1
	],
	"./components/Message.vue": [
		505,
		21
	],
	"./components/Modal.vue": [
		506,
		2
	],
	"./components/Notification.vue": [
		507,
		20
	],
	"./components/ProgressBar.vue": [
		508,
		10
	],
	"./components/ProgressTracker.vue": [
		509,
		4
	],
	"./components/Quill.vue": [
		510,
		6
	],
	"./components/Rating.vue": [
		511,
		3
	],
	"./components/Slider.vue": [
		512,
		19
	],
	"./components/Switch.vue": [
		513,
		9
	],
	"./components/Tabs.vue": [
		514,
		18
	],
	"./components/Tooltip.vue": [
		515,
		17
	],
	"./components/index.vue": [
		516,
		38
	],
	"./components/modals/CardModal.vue": [
		484,
		29
	],
	"./components/modals/ImageModal.vue": [
		485,
		33
	],
	"./components/modals/Modal.vue": [
		486,
		32
	],
	"./dashboard/index.vue": [
		517,
		16
	],
	"./profiles/Profile.vue": [
		180
	],
	"./scenarios/Modal.vue": [
		181
	],
	"./scenarios/ModalAudio.vue": [
		10
	],
	"./scenarios/Scenario.vue": [
		26
	],
	"./scenarios/ScenarioInterviewAFewQuestions.vue": [
		182
	],
	"./scenarios/ScenarioNotice.vue": [
		183
	],
	"./scenarios/ScenarioQuestionInterview.vue": [
		184
	],
	"./scenarios/ScenarioQuestionRecognition.vue": [
		185
	],
	"./scenarios/ScenarioQuestionYesNo.vue": [
		186
	],
	"./scenarios/ScenarioTwoLevelYesNo.vue": [
		187
	],
	"./scenarios/Scenarios.vue": [
		188
	],
	"./settings/AppConfig.vue": [
		189
	],
	"./settings/Permissions.vue": [
		190
	],
	"./tables/Basic.vue": [
		518,
		28
	],
	"./ui/Buttons.vue": [
		519,
		15
	],
	"./ui/Form.vue": [
		520,
		12
	],
	"./ui/Icons.vue": [
		521,
		8
	],
	"./ui/Typography.vue": [
		522,
		31
	],
	"./users/User.vue": [
		27
	],
	"./users/Users.vue": [
		191
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 196;

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_store_mutation_types__ = __webpack_require__(17);
/* unused harmony reexport router */
/* unused harmony reexport store */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




// import VueAuth from '@websanova/vue-auth'









// const ROUTE_ROLES = {
//   'Administrator': 1,
//   'Client': 2,
//   'Anonymous': 3
// }

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].router = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
// Vue.use(VueAuth, {
//   auth: {
//     request: function (req, token) {
//       this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
//     },
//     response: function (res) {
//       // Get Token from response body
//       return res.data.auth.token
//     }
//   },
//   http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
//   router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
//   loginData: { url: 'http://localhost:8093/api/auth/sign-in', fetchUser: false },
//   refreshData: { enabled: false }
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a);
// Enable devtools
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */]);

var nprogress = new __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a({ parent: '.nprogress-container' });

var state = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state;

// Roles (binary)
//  000001 - SuperAdmin  (1)
//  000010 - Admin  (2)
//  000100 - Partner (4)
//  001000 - Referrer (8)
//  010000 - Client (16)
//  100000 - Anonymous (32)

var PAGE_MAPPER = {
  'Пользователь': 31,
  'Данные пользователя': 31,
  'Пользователи': 15,
  'Новый пользователь': 3,
  'Клиенты': 7,
  'Параметры клиента': 7,
  'Архив рассылок': 23,
  'Рассылки': 31,
  'Новая рассылка': 23,
  'Копия рассылки': 23,
  'Рассылка': 23,
  'Сценарии': 23,
  'Сценарий': 23,
  'Новый сценарий': 23,
  'Номера на прозвон': 23,
  'Мониторинг рассылки': 23,
  'Тестовые номера': 23,
  'Лицевой счет клиента': 31,
  'Результат теста': 23,
  'Авторизация': 63,
  'Регистрация': 63,
  'Настройка прав': 1,
  'Настройка приложения': 1
};

__WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (state.app.device.isMobile && state.app.sidebar.opened) {
    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_10_vuex_store_mutation_types__["a" /* TOGGLE_SIDEBAR */], false);
  }
  // next()
  var role = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.loggedRole;
  var toPathRoleGate = PAGE_MAPPER[to.name];
  console.log(role + '-' + toPathRoleGate);
  if ((role & toPathRoleGate) > 0) {
    next();
  } else if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.isLogged) {
    next('/campaigns');
  } else {
    next('/login');
  }
});

Object.keys(__WEBPACK_IMPORTED_MODULE_8__filters__).forEach(function (key) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter(key, __WEBPACK_IMPORTED_MODULE_8__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](_extends({
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  nprogress: nprogress
}, __WEBPACK_IMPORTED_MODULE_5__App_vue___default.a));



/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Sidebar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Sidebar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppMain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppMain__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__AppMain___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__FooterBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar___default.a; });









/***/ }),
/* 217 */
/***/ (function(module, exports) {



/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'is-active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    name: 'Рассылки',
    path: '/campaigns',
    component: __webpack_require__(177)
  }, {
    name: 'Архив рассылок',
    path: '/archive',
    component: __webpack_require__(175)
  }, {
    name: 'Новая рассылка',
    path: '/campaigns/new',
    component: __webpack_require__(19)
  }, {
    name: 'Копия рассылки',
    path: '/campaigns/copy/:idcopy',
    component: __webpack_require__(19),
    props: true
  }, {
    name: 'Рассылка',
    path: '/campaigns/:id',
    component: __webpack_require__(19),
    props: true
  }, {
    name: 'Сценарии',
    path: '/scenarios',
    component: __webpack_require__(188)
  }, {
    path: '/scenarios/:campaignid/new',
    component: __WEBPACK_IMPORTED_MODULE_3__views_scenarios_Scenario___default.a,
    name: 'Новый сценарий',
    props: true
  }, {
    name: 'Сценарий',
    path: '/scenarios/:campaignid/:id',
    component: __webpack_require__(26),
    props: true
  }, {
    name: 'Пользователи',
    path: '/users',
    component: __webpack_require__(191)
  }, {
    name: 'Пользователь',
    path: '/users/:id',
    component: __webpack_require__(27),
    props: true
  }, {
    name: 'Новый пользователь',
    path: '/users/new',
    component: __webpack_require__(27)
  }, {
    name: 'Данные пользователя',
    path: '/profiles/:id',
    component: __webpack_require__(180),
    props: true
  }, {
    name: 'Клиенты',
    path: '/clients',
    component: __webpack_require__(179)
  }, {
    name: 'Параметры клиента',
    path: '/users/client/:id',
    component: __webpack_require__(178),
    props: true
  }, {
    name: 'Номера на прозвон',
    path: '/callTasks/:id',
    component: __webpack_require__(172),
    props: true
  }, {
    name: 'Мониторинг рассылки',
    path: '/monitoring/:id',
    component: __webpack_require__(176),
    props: true
  }, {
    name: 'Тестовые номера',
    path: '/callTasksTest/:id',
    component: __webpack_require__(174),
    props: true
  }, {
    name: 'Результат теста',
    path: '/callTasksTestResult/:campaignid/:id',
    component: __webpack_require__(173),
    props: true
  }, {
    name: 'Лицевой счет клиента',
    path: '/billing/client/:id',
    component: __webpack_require__(171),
    props: true
  }, {
    name: 'Авторизация',
    path: '/login',
    component: __webpack_require__(169)
  }, {
    name: 'Регистрация',
    path: '/sign-up',
    component: __webpack_require__(170)
  }, {
    name: 'Настройка прав',
    path: '/permissions',
    component: __webpack_require__(190)
  }, {
    name: 'Настройка приложения',
    path: '/appconfig',
    component: __webpack_require__(189)
  }].concat(_toConsumableArray(generateRoutesFromMenu(__WEBPACK_IMPORTED_MODULE_2_vuex_store_modules_menu__["a" /* default */].state.items)), [{
    path: '*',
    redirect: '/campaigns'
  }])
}));
// Menu should have 2 levels.
function generateRoutesFromMenu() {
  var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var routes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0, l = menu.length; i < l; i++) {
    var item = menu[i];
    if (item.path) {
      routes.push(item);
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes);
    }
  }
  return routes;
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSidebar", function() { return toggleSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleDevice", function() { return toggleDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandMenu", function() { return expandMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "switchEffect", function() { return switchEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAuthenticationToken", function() { return setAuthenticationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeToken", function() { return removeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedRole", function() { return setLoggedRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedUser", function() { return setLoggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedUser", function() { return removeLoggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedUserState", function() { return setLoggedUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedUserState", function() { return removeLoggedUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedStatus", function() { return setLoggedStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedStatus", function() { return removeLoggedStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoggedId", function() { return setLoggedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLoggedId", function() { return removeLoggedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPermissionMap", function() { return setPermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removePermissionMap", function() { return removePermissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setClientId", function() { return setClientId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeClientId", function() { return removeClientId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(17);


// Roles (binary)
//  000001 - SuperAdmin  (1)
//  000010 - Admin  (2)
//  000100 - Partner (4)
//  001000 - Referrer (8)
//  010000 - Client (16)
//  100000 - Anonymous (32)

var ROLE_MAPPER = {
  'SuperAdministrator': 1,
  'Administrator': 2,
  'Partner': 4,
  'Referrer': 8,
  'Client': 16,
  'Anonymous': 32
};

var toggleSidebar = function toggleSidebar(_ref, config) {
  var commit = _ref.commit;

  if (config instanceof Object) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], config);
  }
};

var toggleDevice = function toggleDevice(_ref2, device) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], device);
};

var expandMenu = function expandMenu(_ref3, menuItem) {
  var commit = _ref3.commit;

  if (menuItem) {
    menuItem.expanded = menuItem.expanded || false;
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* EXPAND_MENU */], menuItem);
  }
};

var switchEffect = function switchEffect(_ref4, effectItem) {
  var commit = _ref4.commit;

  if (effectItem) {
    commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], effectItem);
  }
};

var setAuthenticationToken = function setAuthenticationToken(_ref5, token) {
  var commit = _ref5.commit;

  localStorage.setItem('authenticationToken', token);
  commit('SET_AUTHENTICATION_TOKEN', token);
};

var removeToken = function removeToken(_ref6) {
  var commit = _ref6.commit;

  localStorage.removeItem('authenticationToken');
  commit('SET_AUTHENTICATION_TOKEN');
};

var setLoggedRole = function setLoggedRole(_ref7, role) {
  var commit = _ref7.commit;

  localStorage.setItem('loggedRole', ROLE_MAPPER[role]);
  commit('SET_LOGGED_ROLE', ROLE_MAPPER[role]);
};

var setLoggedUser = function setLoggedUser(_ref8, user) {
  var commit = _ref8.commit;

  localStorage.setItem('loggedUser', user);
  commit('SET_LOGGED_USER', user);
};

var removeLoggedUser = function removeLoggedUser(_ref9) {
  var commit = _ref9.commit;

  localStorage.removeItem('loggedUser');
  commit('SET_LOGGED_USER');
};

var setLoggedUserState = function setLoggedUserState(_ref10, userstate) {
  var commit = _ref10.commit;

  localStorage.setItem('loggedUserState', userstate);
  commit('SET_LOGGED_USER_STATE', userstate);
};

var removeLoggedUserState = function removeLoggedUserState(_ref11) {
  var commit = _ref11.commit;

  localStorage.removeItem('loggedUserState');
  commit('SET_LOGGED_USER_STATE');
};

var setLoggedStatus = function setLoggedStatus(_ref12, status) {
  var commit = _ref12.commit;

  localStorage.setItem('loggedStatus', status);
  commit('SET_LOGGED_STATUS', status);
};

var removeLoggedStatus = function removeLoggedStatus(_ref13) {
  var commit = _ref13.commit;

  localStorage.removeItem('loggedStatus');
  commit('SET_LOGGED_STATUS');
};

var setLoggedId = function setLoggedId(_ref14, id) {
  var commit = _ref14.commit;

  localStorage.setItem('loggedId', id);
  commit('SET_LOGGED_ID', id);
};

var removeLoggedId = function removeLoggedId(_ref15) {
  var commit = _ref15.commit;

  localStorage.removeItem('loggedId');
  commit('SET_LOGGED_ID');
};

var setPermissionMap = function setPermissionMap(_ref16, map) {
  var commit = _ref16.commit;

  localStorage.setItem('permissionMap', map);
  commit('SET_PERMISSION_MAP', map);
};
var removePermissionMap = function removePermissionMap(_ref17) {
  var commit = _ref17.commit;

  localStorage.removeItem('permissionMap');
  commit('SET_PERMISSION_MAP');
};

var setClientId = function setClientId(_ref18, clientid) {
  var commit = _ref18.commit;

  localStorage.setItem('clientId', clientid);
  commit('SET_CLIENT_ID', clientid);
};

var removeClientId = function removeClientId(_ref19) {
  var commit = _ref19.commit;

  localStorage.removeItem('clientId');
  commit('SET_CLIENT_ID');
};

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pkg", function() { return pkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "app", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "device", function() { return device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sidebar", function() { return sidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effect", function() { return effect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "menuitems", function() { return menuitems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componententry", function() { return componententry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadedScenario", function() { return loadedScenario; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "authenticationToken", function() { return authenticationToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedRole", function() { return loggedRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedUser", function() { return loggedUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedUserState", function() { return loggedUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLogged", function() { return isLogged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loggedId", function() { return loggedId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissionMap", function() { return permissionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clientId", function() { return clientId; });
var pkg = function pkg(state) {
  return state.pkg;
};
var app = function app(state) {
  return state.app;
};
var device = function device(state) {
  return state.app.device;
};
var sidebar = function sidebar(state) {
  return state.app.sidebar;
};
var effect = function effect(state) {
  return state.app.effect;
};
var menuitems = function menuitems(state) {
  return state.menu.items;
};

var componententry = function componententry(state) {
  return state.menu.items.filter(function (c) {
    return c.meta && c.meta.label === 'Components';
  })[0];
};
var loadedScenario = function loadedScenario(state) {
  return state.loadedScenario;
};

var loggedRole = function loggedRole(state) {
  return state.loggedRole;
};

var loggedUser = function loggedUser(state) {
  return state.loggedUser;
};

var loggedUserState = function loggedUserState(state) {
  return state.loggedUserState;
};

var isLogged = function isLogged(state) {
  return state.isLogged;
};

var loggedId = function loggedId(state) {
  return state.loggedId;
};

var permissionMap = function permissionMap(state) {
  return state.permissionMap;
};

var clientId = function clientId(state) {
  return state.clientId;
};

var authenticationToken = function authenticationToken(state) {
  return state.authenticationToken;
};



/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_app__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_menu__ = __webpack_require__(36);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_4__getters__,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_5__modules_app__["a" /* default */],
    menu: __WEBPACK_IMPORTED_MODULE_6__modules_menu__["a" /* default */]
  },
  mutations: {
    setLoadedScenario: function setLoadedScenario(state, payload) {
      state.loadedScenario = payload;
    },
    SET_AUTHENTICATION_TOKEN: function SET_AUTHENTICATION_TOKEN(state, token) {
      state.authenticationToken = token;
    },
    SET_LOGGED_ROLE: function SET_LOGGED_ROLE(state, role) {
      state.loggedRole = role;
    },
    SET_LOGGED_USER: function SET_LOGGED_USER(state, user) {
      state.loggedUser = user;
    },
    SET_LOGGED_USER_STATE: function SET_LOGGED_USER_STATE(state, userstate) {
      state.loggedUserState = userstate;
    },
    SET_LOGGED_STATUS: function SET_LOGGED_STATUS(state, status) {
      state.isLogged = status;
    },
    SET_LOGGED_ID: function SET_LOGGED_ID(state, id) {
      state.loggedId = id;
    },
    SET_PERMISSION_MAP: function SET_PERMISSION_MAP(state, map) {
      state.permissionMap = map;
    },
    SET_CLIENT_ID: function SET_CLIENT_ID(state, clientid) {
      state.clientId = clientid;
    }
  },
  state: {
    isLogged: localStorage.getItem('authenticationToken') !== null,
    authenticationToken: localStorage.getItem('authenticationToken'),
    loggedUser: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedUser') : '',
    loggedUserState: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedUserState') : '',
    loggedRole: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedRole') : 16,
    loggedId: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('loggedId') : null,
    loadedScenario: {},
    permissionMap: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('permissionMap') : null,
    clientId: localStorage.getItem('authenticationToken') !== null ? localStorage.getItem('clientId') : null,
    pkg: __WEBPACK_IMPORTED_MODULE_2_package___default.a
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(17);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var state = {
  device: {
    isMobile: false,
    isTablet: false
  },
  sidebar: {
    opened: false,
    hidden: false
  },
  effect: {
    translate3d: true
  }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* TOGGLE_DEVICE */], function (state, device) {
  state.device.isMobile = device === 'mobile';
  state.device.isTablet = device === 'tablet';
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["a" /* TOGGLE_SIDEBAR */], function (state, config) {
  if (state.device.isMobile && config.hasOwnProperty('opened')) {
    state.sidebar.opened = config.opened;
  } else {
    state.sidebar.opened = true;
  }

  if (config.hasOwnProperty('hidden')) {
    state.sidebar.hidden = config.hidden;
  }
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__mutation_types__["d" /* SWITCH_EFFECT */], function (state, effectItem) {
  for (var name in effectItem) {
    state.effect[name] = effectItem[name];
  }
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
/* harmony default export */ __webpack_exports__["a"] = (function (name) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    return __webpack_require__(196)("./" + name + (index ? '/index' : '') + '.vue');
  };
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wav_encoder__ = __webpack_require__(225);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var _class = function () {
  function _class() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _class);

    this.afterStop = options.afterStop;
    this.micFailed = options.micFailed;

    this.bufferSize = 4096;
    this.records = [];
    this.samples = [];

    this.isPause = false;
    this.isRecording = false;

    this.duration = 0;
    this.volume = 0;

    this._duration = 0;
  }

  _createClass(_class, [{
    key: 'start',
    value: function start() {
      navigator.mediaDevices.getUserMedia({ audio: true }).then(this._micCaptured.bind(this)).catch(this._micError.bind(this));
      this.isPause = false;
      this.isRecording = true;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.stream.getTracks().forEach(function (track) {
        return track.stop();
      });
      this.input.disconnect();
      this.processor.disconnect();
      this.context.close();

      var encoder = new __WEBPACK_IMPORTED_MODULE_0__wav_encoder__["a" /* default */]({
        bufferSize: this.bufferSize,
        sampleRate: this.context.sampleRate,
        samples: this.samples
      });

      var audioBlob = encoder.getData();
      var audioUrl = URL.createObjectURL(audioBlob);

      this.samples = [];

      this.records.push({
        id: Date.now(),
        blob: audioBlob,
        duration: this.convertTimeMMSS(this.duration),
        url: audioUrl
      });

      this._duration = 0;
      this.duration = 0;

      this.isPause = false;
      this.isRecording = false;

      if (this.afterStop) {
        this.afterStop();
      }
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.stream.getTracks().forEach(function (track) {
        return track.stop();
      });
      this.input.disconnect();
      this.processor.disconnect();
      this.context.close();

      this._duration = this.duration;
      this.isPause = true;
    }
  }, {
    key: 'recordList',
    value: function recordList() {
      return this.records;
    }
  }, {
    key: 'lastRecord',
    value: function lastRecord() {
      return this.records.slice(-1);
    }
  }, {
    key: '_micCaptured',
    value: function _micCaptured(stream) {
      var _this = this;

      this.context = new (window.AudioContext || window.webkitAudioContext)();
      this.duration = this._duration;
      this.input = this.context.createMediaStreamSource(stream);
      this.processor = this.context.createScriptProcessor(this.bufferSize, 1, 1);
      this.stream = stream;

      this.processor.onaudioprocess = function (ev) {
        var sample = ev.inputBuffer.getChannelData(0);
        var sum = 0.0;

        for (var i = 0; i < sample.length; ++i) {
          sum += sample[i] * sample[i];
        }

        _this.duration = parseFloat(_this._duration) + parseFloat(_this.context.currentTime.toFixed(2));
        _this.volume = Math.sqrt(sum / sample.length).toFixed(2);
        _this.samples.push(new Float32Array(sample));
      };

      this.input.connect(this.processor);
      this.processor.connect(this.context.destination);
    }
  }, {
    key: '_micError',
    value: function _micError(error) {
      if (this.micFailed) {
        this.micFailed(error);
      }
    }
  }, {
    key: 'convertTimeMMSS',
    value: function convertTimeMMSS(seconds) {
      return new Date(seconds * 1000).toISOString().substr(14, 5);
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(options) {
    _classCallCheck(this, _class);

    this.bufferSize = options.bufferSize || 4096;
    this.sampleRate = options.sampleRate;
    this.samples = options.samples;
  }

  _createClass(_class, [{
    key: 'getData',
    value: function getData() {
      this._joinSamples();

      var buffer = new ArrayBuffer(44 + this.samples.length * 2);
      var view = new DataView(buffer);

      this._writeString(view, 0, 'RIFF'); // RIFF identifier
      view.setUint32(4, 36 + this.samples.length * 2, true); // RIFF chunk length
      this._writeString(view, 8, 'WAVE'); // RIFF type
      this._writeString(view, 12, 'fmt '); // format chunk identifier
      view.setUint32(16, 16, true); // format chunk length
      view.setUint16(20, 1, true); // sample format (raw)
      view.setUint16(22, 1, true); // channel count
      view.setUint32(24, this.sampleRate, true); // sample rate
      view.setUint32(28, this.sampleRate * 4, true); // byte rate (sample rate * block align)
      view.setUint16(32, 4, true); // block align (channel count * bytes per sample)
      view.setUint16(34, 16, true); // bits per sample
      this._writeString(view, 36, 'data'); // data chunk identifier
      view.setUint32(40, this.samples.length * 2, true); // data chunk length

      this._floatTo16BitPCM(view, 44, this.samples);

      return new Blob([view], { type: 'audio/wav' });
    }
  }, {
    key: '_floatTo16BitPCM',
    value: function _floatTo16BitPCM(output, offset, input) {
      for (var i = 0; i < input.length; i++, offset += 2) {
        var s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
      }
    }
  }, {
    key: '_joinSamples',
    value: function _joinSamples() {
      var recordLength = this.samples.length * this.bufferSize;
      var joinedSamples = new Float64Array(recordLength);
      var offset = 0;

      for (var i = 0; i < this.samples.length; i++) {
        var sample = this.samples[i];
        joinedSamples.set(sample, offset);
        offset += sample.length;
      }

      this.samples = joinedSamples;
    }
  }, {
    key: '_writeString',
    value: function _writeString(view, offset, string) {
      for (var i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_layout___ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["a" /* Navbar */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["b" /* Sidebar */],
    AppMain: __WEBPACK_IMPORTED_MODULE_1_components_layout___["c" /* AppMain */],
    FooterBar: __WEBPACK_IMPORTED_MODULE_1_components_layout___["d" /* FooterBar */],
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_0_vue_nprogress_src_NprogressContainer___default.a
  },

  data: function data() {
    return {
      monitor: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    var _document = document,
        body = _document.body;

    var WIDTH = 768;
    var RATIO = 3;

    var handler = function handler() {
      if (!document.hidden) {
        var rect = body.getBoundingClientRect();
        var isMobile = rect.width - RATIO < WIDTH;
        _this.toggleDevice(isMobile ? 'mobile' : 'other');
        _this.toggleSidebar({
          opened: !isMobile
        });
      }
    };

    document.addEventListener('visibilitychange', handler);
    window.addEventListener('DOMContentLoaded', handler);
    window.addEventListener('resize', handler);
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    sidebar: 'sidebar',
    isLogged: 'isLogged'
  }),

  methods: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapActions"])(['toggleDevice', 'toggleSidebar'])
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    file: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      durationSeconds_: 0,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100
    };
  },
  computed: {
    currentTime: function currentTime() {
      return new Date(this.currentSeconds * 1000).toISOString().substr(14, 5);
    },
    durationTime: function durationTime() {
      return new Date(this.durationSeconds_ * 1000).toISOString().substr(14, 5);
    },
    percentComplete: function percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted: function muted() {
      return this.volume / 100 === 0;
    }
  },
  watch: {
    playing: function playing(value) {
      if (value) {
        return this.audio.play();
      }
      this.audio.pause();
    },
    volume: function volume(value) {
      this.showVolume = false;
      this.audio.volume = this.volume / 100;
    }
  },
  methods: {
    download: function download() {
      this.stop();
      window.location.href = this.audio.currentSrc;
    },
    load: function load() {
      if (this.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.audio.duration);
        this.durationSeconds_ = Math.ceil(this.audio.duration);
        // this.playing = this.autoPlay
      }

      throw new Error('Failed to load sound file.');
    },
    mute: function mute() {
      if (this.muted) {
        this.volume = this.previousVolume;
      } else {
        this.previousVolume = this.volume;
        this.volume = 0;
      }
    },
    seek: function seek(e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }

      var el = e.target.getBoundingClientRect();
      var seekPos = (e.clientX - el.left) / el.width;

      this.audio.currentTime = parseInt(this.audio.duration * seekPos);
    },
    stop: function stop() {
      this.playing = false;
      this.audio.currentTime = 0;
    },
    update: function update(e) {
      this.currentSeconds = parseInt(this.audio.currentTime);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.audio = null;
    var len = document.querySelectorAll('audio').length;
    for (var i = 0; i < len; i++) {
      if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src').nodeValue == this.file) {
          this.audio = document.querySelectorAll('audio')[i];
        }
      }
    }
    this.audio.addEventListener('timeupdate', this.update);
    this.audio.addEventListener('loadeddata', this.load);
    this.audio.addEventListener('pause', function () {
      _this.playing = false;
    });
    this.audio.addEventListener('play', function () {
      _this.playing = true;
    });
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Levelbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Levelbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    sidebar: 'sidebar'
  }), {
    hiddenSidebarStyle: function hiddenSidebarStyle() {
      return this.sidebar.hidden ? { 'margin-left': 0 } : null;
    }
  }),

  components: {
    Levelbar: __WEBPACK_IMPORTED_MODULE_0__Levelbar___default.a
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return this.$store.state.pkg;
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_breadcrumb___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      list: null
    };
  },
  created: function created() {
    this.getList();
  },


  computed: {
    codelink: function codelink() {
      if (this.$route.meta && this.$route.meta.link) {
        return 'https://github.com/vue-bulma/vue-admin/blob/master/client/views/' + this.$route.meta.link;
      } else {
        return null;
      }
    },
    name: function name() {
      return this.$route.name;
    }
  },

  methods: {
    getList: function getList() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      });
      var first = matched[0];
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched);
      }
      this.list = matched;
    }
  },

  watch: {
    $route: function $route() {
      this.getList();
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_tooltip__["a" /* default */]
  },

  props: {
    show: Boolean
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    pkginfo: 'pkg',
    sidebar: 'sidebar',
    loggedUser: 'loggedUser',
    loggedUserState: 'loggedUserState',
    loggedId: 'loggedId',
    isLogged: 'isLogged'
  }),

  data: function data() {
    return {
      appconfig: {},
      appTitle: ''
    };
  },


  created: function created() {
    this.loadAppConfig();
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['toggleSidebar', 'removeToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId', 'setLoggedUser', 'setLoggedUserState', 'setPermissionMap', 'setClientId']), {
    logout: function logout() {
      clearInterval(this.$root.monitor);
      this.removeToken();
      this.setLoggedId(null);
      this.setLoggedUser('');
      this.setLoggedUserState('');
      this.setLoggedStatus(false);
      this.setLoggedRole('Anonymous');
      this.setPermissionMap('');
      this.setClientId(null);
      this.$router.push('/login');
    },
    prepareSecurityHeader: function prepareSecurityHeader() {
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    loadAppConfig: function loadAppConfig() {
      var _this = this;

      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.appconfig = response.data;
        _this.appTitle = _this.appconfig.defaultAppTitle;
        document.title = _this.appTitle + ' - Личный Кабинет';
      }).catch(function (error) {
        console.log(error);
      });
    }
  })
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

  components: {
    Expanding: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_expanding___default.a
  },

  props: {
    show: Boolean
  },

  data: function data() {
    return {
      isReady: false,
      menuRoles: [{
        name: 'Сценарии',
        role: 23
      }, {
        name: 'Рассылки',
        role: 31
      }, {
        name: 'Архив рассылок',
        role: 23
      }, {
        name: 'Пользователи',
        role: 15
      }, {
        name: 'Клиенты',
        role: 7
      }, {
        name: 'Настройка прав',
        role: 1
      }, {
        name: 'Настройка приложения',
        role: 1
      }]
    };
  },
  mounted: function mounted() {
    var route = this.$route;
    if (route.name) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    menu: 'menuitems',
    loggedRole: 'loggedRole'
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapActions"])(['expandMenu']), {
    getLoggedUserRole: function getLoggedUserRole() {
      console.log(this.loggedRole);
      return this.loggedRole;
    },
    isExpanded: function isExpanded(item) {
      return item.meta.expanded;
    },
    toggle: function toggle(index, item) {
      this.expandMenu({
        index: index,
        expanded: !item.meta.expanded
      });
    },
    shouldExpandMatchItem: function shouldExpandMatchItem(route) {
      var matched = route.matched;
      var lastMatched = matched[matched.length - 1];
      var parent = lastMatched.parent || lastMatched;
      var isParent = parent === lastMatched;

      if (isParent) {
        var p = this.findParentFromMenu(route);
        if (p) {
          parent = p;
        }
      }

      if ('expanded' in parent.meta && !isParent) {
        this.expandMenu({
          item: parent,
          expanded: true
        });
      }
    },
    generatePath: function generatePath(item, subItem) {
      return '' + (item.component ? item.path + '/' : '') + subItem.path;
    },
    findParentFromMenu: function findParentFromMenu(route) {
      var menu = this.menu;
      for (var i = 0, l = menu.length; i < l; i++) {
        var item = menu[i];
        var k = item.children && item.children.length;
        if (k) {
          for (var j = 0; j < k; j++) {
            if (item.children[j].name === route.name) {
              return item;
            }
          }
        }
      }
    }
  }),

  watch: {
    $route: function $route(route) {
      this.isReady = true;
      this.shouldExpandMatchItem(route);
    }
  }

});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_button__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recorder__ = __webpack_require__(224);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'audioRecorder',
  props: {
    attempts: { type: Number },
    compact: { type: Boolean, default: false },
    time: { type: Number },
    attemptsLimit: { type: Function },
    micFailed: { type: Function },
    startRecord: { type: Function },
    stopRecord: { type: Function },
    failedUpload: { type: Function },
    headers: { type: Object },
    startUpload: { type: Function },
    successfulUpload: { type: Function },
    uploadUrl: { type: String },
    successfulUploadMsg: { type: String, default: 'Upload successful' },
    failedUploadMsg: { type: String, default: 'Upload fail' }
  },
  data: function data() {
    var _this = this;

    return {
      isUploading: false,
      recorder: new __WEBPACK_IMPORTED_MODULE_1__recorder__["a" /* default */]({
        afterStop: function afterStop() {
          _this.recordList = _this.recorder.recordList();
          if (_this.stopRecord) {
            _this.stopRecord('stop record');
          }
        },
        attempts: this.attempts,
        time: this.time
      }),
      recordList: [],
      selected: {},
      uploadStatus: null,
      uploaderOptions: {},
      audioSource: {}
    };
  },

  components: {
    IconButton: __WEBPACK_IMPORTED_MODULE_0__icon_button___default.a
  },
  created: function created() {
    this.uploaderOptions = {
      failedUpload: this.failedUpload,
      headers: this.headers,
      startUpload: this.startUpload,
      successfulUpload: this.successfulUpload,
      uploadUrl: this.uploadUrl
    };
    this.$watch('audioSource', function () {
      this.$refs.questionPlayer.load();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.stopRecorder();
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    toggleRecorder: function toggleRecorder() {
      if (this.attempts && this.recorder.records.length >= this.attempts) {
        return;
      }
      if (!this.isRecording || this.isRecording && this.isPause) {
        this.recorder.start();
        if (this.startRecord) {
          this.startRecord('start record');
        }
      } else {
        this.recorder.pause();
        if (this.startRecord) {
          this.startRecord('pause record');
        }
      }
    },
    stopRecorder: function stopRecorder() {
      if (!this.isRecording) {
        return;
      }
      this.recorder.stop();
      this.audioSource = this.recordList[0];
    },
    retry: function retry() {
      this.recordList.splice(0, 1);
      this.audioSource.url = null;
    }
  },
  computed: {
    iconButtonType: function iconButtonType() {
      return this.isRecording && this.isPause ? 'mic' : this.isRecording ? 'pause' : 'mic';
    },
    isPause: function isPause() {
      return this.recorder.isPause;
    },
    isRecording: function isRecording() {
      return this.recorder.isRecording;
    },
    message: function message() {
      return this.uploadStatus === 'success' ? this.successfulUploadMsg : this.failedUploadMsg;
    },
    recordedTime: function recordedTime() {
      if (this.time && this.recorder.duration >= this.time * 60) {
        this.stopRecorder();
      }
      return new Date(this.recorder.duration * 1000).toISOString().substr(14, 5);
    },
    uploadStatusClasses: function uploadStatusClasses() {
      var classes = ['ar__upload-status'];
      classes.push(this.uploadStatus === 'success' ? 'ar__upload-status--success' : 'ar__upload-status--fail');
      return classes.join(' ');
    },
    volume: function volume() {
      return parseFloat(this.recorder.volume);
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'icon-button',
    props: {
        name: { type: String }
    },
    data: function data() {
        return {
            icons: {
                download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"/><path fill="none" d="M0 0h24v24H0z"/></svg>',
                mic: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                pause: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                play: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
                save: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/></svg>',
                stop: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M6 6h12v12H6z"/></svg>',
                volume: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/><path d="M0 0h24v24H0z" fill="none"/></svg>'
            }
        };
    }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['permissionMap'])),
  methods: {
    // general
    canCreate: function canCreate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 1) === 1;
    },
    canRead: function canRead(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 2) === 2;
    },
    canUpdate: function canUpdate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 4) === 4;
    },
    canDelete: function canDelete(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 8) === 8;
    },

    // key = 'campaign' only
    canModerate: function canModerate(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 16) === 16;
    },
    canUpdateAfterModerating: function canUpdateAfterModerating(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 32) === 32;
    },
    canAccessAdditionalParameters: function canAccessAdditionalParameters(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 64) === 64;
    },

    // key = 'user' only
    canSelectUser: function canSelectUser(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 16) === 16;
    },
    canUpdateUserTypeAndState: function canUpdateUserTypeAndState(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 32) === 32;
    },
    canUpdateUserPayment: function canUpdateUserPayment(key) {
      var pMap = new Map(JSON.parse(this.permissionMap));
      return (pMap.get(key) & 64) === 64;
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var AUTH_API = '/api/auth';

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['removeToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId', 'setLoggedUser', 'setLoggedUserState', 'setPermissionMap', 'setClientId']), {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    checkToken: function checkToken() {
      var _this = this;

      clearInterval(this.$root.monitor);
      this.$http.get(AUTH_API + '/isTokenValid/' + this.authenticationToken, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (!response.data) {
          _this.logout();
        }
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка проверки токена. ');
      });
    },
    logout: function logout() {
      this.removeToken();
      this.setLoggedId(null);
      this.setLoggedUser('');
      this.setLoggedUserState('');
      this.setLoggedStatus(false);
      this.setLoggedRole('Anonymous');
      this.setPermissionMap('');
      this.setClientId(null);
      this.$router.push('/login');
    }
  })
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var AUTH_API = '/api/auth';
var APPCONFIG_API = '/api/appConfig';

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },

  data: function data() {
    return {
      data: {
        body: {
          username: null,
          password: null
        },
        rememberMe: false
      },
      canSignUp: true
    };
  },

  created: function created() {
    this.loadAppConfig();
  },
  mounted: function mounted() {
    // if (this.$auth.redirect()) {
    //   console.log('Redirect from: ' + this.$auth.redirect().from.name)
    // }
    // Can set query parameter here for auth redirect or just do it silently in login redirect.
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['setAuthenticationToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId', 'setLoggedUser', 'setLoggedUserState', 'setPermissionMap', 'setClientId']), {
    login: function login() {
      var _this = this;

      this.$http.post(AUTH_API + '/sign-in', this.data.body).then(function (response) {
        _this.setAuthenticationToken(response.data.auth.token);
        _this.setLoggedRole(response.data.role);
        _this.setLoggedId(response.data.id);
        _this.setLoggedUser(response.data.username);
        _this.setLoggedUserState(response.data.state);
        _this.setLoggedStatus(true);
        _this.setPermission(response.data.role);
        _this.setClientId(response.data.clientid);
        _this.openNotificationWithType('success', 'Осуществлен вход ' + _this.data.body.username);
        _this.$router.push('/campaigns');
      }).catch(function (error) {
        _this.openNotificationWithType('danger', 'Ошибка авторизации');
        console.log(error);
      });
    },
    setPermission: function setPermission(role) {
      var _this2 = this;

      this.$http.get(AUTH_API + '/getPermissions/' + role, { headers: this.prepareSecurityHeader() }).then(function (response) {
        var pMap = JSON.stringify(Object.entries(response.data));
        _this2.setPermissionMap(pMap);
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка установки разрешений. ');
      });
    },
    loadAppConfig: function loadAppConfig() {
      var _this3 = this;

      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.appconfig = response.data;
        _this3.canSignUp = _this3.appconfig.userCanSignUp;
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }

    // login() {
    //   // var redirect = this.$auth.redirect()
    //   // console.log(redirect)
    //   this.$auth.login({
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data: this.data.body,
    //     rememberMe: this.data.rememberMe,
    //     // redirect: {name: redirect ? redirect.from.name : 'Заявки'},
    //     success(res) {
    //       console.log('Auth Success')
    //       console.log('Token: ' + this.$auth.token())
    //       console.log(res)
    //     },
    //     error(err) {
    //       if (err.response) {
    //         // The request was made, but the server responded with a status code
    //         // that falls out of the range of 2xx
    //         // console.log(err.response.status)
    //         // console.log(err.response.data)
    //         // console.log(err.response.headers)
    //         this.error = err.response.data
    //       } else {
    //         // Something happened in setting up the request that triggered an Error
    //         console.log('Error', err.message)
    //       }
    //       console.log(err.config)
    //     }
    //   })
    // }

  })
  // }
  // filters: {
  //   json: function (value) {
  //     console.log(value)
  //     return value
  //   }
  // }

});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var APPCONFIG_API = '/api/appConfig';

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },

  data: function data() {
    return {
      data: {
        body: {
          username: null,
          password: null,
          role: 16,
          mainUserId: null,
          recaptchaResponse: null
        },
        matchPassword: null,
        rememberMe: false
      },
      rcapt_sig_key: "6Lc41nsUAAAAAHnkjZWH9mSV44CSugUJ58jN_zSq",
      rcapt_id: 0,
      canSignUp: true,
      reg: /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
    };
  },
  mounted: function mounted() {
    if (window.grecaptcha) {
      this.rcapt_id = grecaptcha.render(document.getElementById('g-recaptcha'), { sitekey: this.rcapt_sig_key });
    }
  },

  created: function created() {
    this.loadAppConfig();
  },
  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapActions"])(['setAuthenticationToken', 'setLoggedRole', 'setLoggedStatus', 'setLoggedId']), {
    login: function login() {
      var _this = this;

      if (this.data.body.username != '') {
        if (this.reg.test(this.data.body.username)) {
          if (this.data.matchPassword === this.data.body.password) {
            this.data.body.recaptchaResponse = grecaptcha.getResponse(this.rcapt_id);
            if (this.data.body.recaptchaResponse.length == 0) {
              this.openNotificationWithType('danger', 'Необходимо пройти капчу!');
            } else {
              this.$http.post('/api/auth/sign-up', this.data.body).then(function (response) {
                _this.openNotificationWithType('success', 'Успешная регистрация пользователя ' + _this.data.body.username);
                _this.$router.push('/login');
              }).catch(function (error) {
                _this.openNotificationWithType('danger', 'Ошибка регистрации');
                console.log(error);
              });
            }
          } else {
            this.openNotificationWithType('danger', 'Пароли не совпадают');
          }
        } else {
          this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты');
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты');
      }
    },
    loadAppConfig: function loadAppConfig() {
      var _this2 = this;

      this.$http.get(APPCONFIG_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.appconfig = response.data;
        _this2.canSignUp = _this2.appconfig.userCanSignUp;
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  })
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var BILLING_API = '/api/billing';
var USERS_API = '/api/users';
var PAYMENTS_API = '/api/payments';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loggedId', 'authenticationToken']), {
    l10n: function l10n() {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
          longhand: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']
        },
        months: {
          shorthand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        }
      };
    },
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.billings.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    loadBilling: function loadBilling() {
      var _this = this;

      this.$http({
        url: BILLING_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening campaign ' + response.data.id);
        _this.billings = response.data;
        _this.sortedBillings = _this.sortedBilling();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки информации об оплате. ');
      });
    },
    loadClient: function loadClient() {
      var _this2 = this;

      this.$http.get(USERS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.client = response.data;
      });
    },
    cancel: function cancel() {
      //      this.$router.push('/users/' + this.$props.id)
      this.$router.push('/users/');
    },
    addPayment: function addPayment() {
      var _this3 = this;

      if (this.newbilling.date) {
        if (this.reg.test(this.newbilling.sumPay)) {
          if (this.newbilling.sumPay != 0) {
            this.newbilling.client = this.client.id;
            this.newbilling.sumConsume = 0;
            this.$http.post(BILLING_API, this.newbilling, { headers: this.prepareSecurityHeader() }).then(function (response) {
              _this3.openNotificationWithType('success', 'Оплата добавлена');
              _this3.billings = response.data;
              _this3.sortedBillings = _this3.sortedBilling();
              _this3.getBalance();
              _this3.getSumPayment();
              _this3.getSumConsume();
              _this3.newbilling.date = '';
              _this3.newbilling.sumPay = '';
            }).catch(function (error) {
              console.log(error);
              _this3.openNotificationWithType('danger', 'Ошибка добавления оплаты. ');
            });
          } else {
            this.openNotificationWithType('danger', 'Укажите ненулевую сумму');
          }
        } else {
          this.openNotificationWithType('danger', 'Некорректный формат числа');
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо выбрать дату');
      }
    },
    getBalance: function getBalance() {
      var _this4 = this;

      this.$http.get(BILLING_API + '/balance/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this4.balance = response.data;
      });
    },
    getSumPayment: function getSumPayment() {
      var _this5 = this;

      this.$http.get(BILLING_API + '/sumpayment/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this5.sumPay = response.data;
      });
    },
    getSumConsume: function getSumConsume() {
      var _this6 = this;

      this.$http.get(BILLING_API + '/sumconsume/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this6.sumConsume = response.data;
      });
    },
    makePayment: function makePayment() {
      var _this7 = this;

      if (this.reg.test(this.sumPayment)) {
        if (this.sumPayment > 0) {
          this.$http.post(PAYMENTS_API + '/yandex', this.preparePaymentParameters(this.loggedId, this.sumPayment), { headers: this.prepareSecurityHeader() }).then(function (response) {
            console.log(response);
            console.log(response.data);
            window.location.href = response.data;
          }).catch(function (error) {
            console.log(error);
            _this7.openNotificationWithType('danger', 'Ошибка платежа. ');
          });
        } else {
          this.openNotificationWithType('danger', 'Укажите сумму больше нуля');
        }
      } else {
        this.openNotificationWithType('danger', 'Некорректный формат числа');
      }
    },
    preparePaymentParameters: function preparePaymentParameters(id, sum) {
      var paymentFormData = new FormData();
      var currentUrl = window.location;
      paymentFormData.append('id', id);
      paymentFormData.append('sum', sum);
      paymentFormData.append('returnUrl', currentUrl);
      return paymentFormData;
    },
    sortedBilling: function sortedBilling() {
      var _this8 = this;

      return this.billings.sort(function (a, b) {
        var modifier = 1;
        if (_this8.currentSortDir === 'desc') modifier = -1;
        if (a[_this8.currentSort] < b[_this8.currentSort]) return -1 * modifier;
        if (a[_this8.currentSort] > b[_this8.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this8.currentPage - 1) * _this8.perPage;
        var end = _this8.currentPage * _this8.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedBillings = this.sortedBilling();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedBillings = this.sortedBilling();
    },
    viewBilling: function viewBilling(id) {
      this.$router.push('/billing/client/' + id);
    },
    viewProfile: function viewProfile(id) {
      this.$router.push('/profiles/' + id);
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      billings: [],
      sortedBillings: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'date',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      newbilling: {},
      client: '',
      balance: 0,
      sumPay: 0,
      sumConsume: 0,
      sumPayment: 0,
      permissionKey: 'billing',
      reg: /^[-]?[0-9]+[.]?[0-9]{0,2}$/
    };
  },

  created: function created() {
    if (!this.$props.id) {
      this.$router.push('/users');
    } else {
      console.log('loading billing: ' + this.name);
      this.loadBilling();
      this.loadClient();
      this.getBalance();
      this.getSumPayment();
      this.getSumConsume();
    }
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default.a);

var CALLTASKS_API = '/outgoing-cpg';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__["a" /* BackToTop */]
  },
  data: function data() {
    return {
      calltasks: [],
      campaign: ''
    };
  },

  created: function created() {
    this.checkToken();
    this.calltasks = this.loadData();
    this.loadCampaign();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(CALLTASKS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.calltasks = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки телефонных номеров. ');
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.campaign = response.data;
      });
    },
    cancel: function cancel() {
      this.$router.push('/campaigns/' + this.$props.id);
    }
  }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    getCallTaskState: function getCallTaskState(state) {
      switch (state) {
        case 'FAILED':
          return 'Недозвон';
        case 'DIALING':
          return 'Вызов';
        case 'ONGOING':
          return 'Идет разговор';
        case 'PERFORMED':
          return 'Выполнена';
        case 'POSTPONED':
          return 'Отложена';
        case 'READY':
          return 'В очереди';
        case 'TELEPHONY_ERROR_SUSPEND':
          return 'Отложена';
        case 'CANCELLED':
          return 'Отменена';
        default:
          return state;
      }
    }
  }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GetCalltaskState__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GetCalltaskState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__GetCalltaskState__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_7__GetCalltaskState___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var CALLTASKTESTING_API = '/outgoing-cpg/callTasksTesting';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['campaignid', 'id'],
  data: function data() {
    return {
      callTask: {},
      callTaskState: '',
      callTaskParameters: '',
      callTaskReportParameters: '',
      campaign: '',
      title: '',
      results: {},
      permissionKey: 'campaign'
    };
  },

  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_collapse__["Item"]
  },
  created: function created() {
    this.checkToken();
    this.handlePhone();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    handlePhone: function handlePhone() {
      this.loadCampaign();
      this.loadCallTask();
    },
    loadCallTask: function loadCallTask() {
      var _this = this;

      this.$http({
        url: CALLTASKTESTING_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening testing call task ' + response.data.phone);
        _this.callTask = response.data;
        _this.callTaskState = _this.getCallTaskState(_this.callTask.state);
        _this.callTaskParameters = JSON.stringify(_this.callTask.parameters);
        _this.callTaskReportParameters = JSON.stringify(_this.callTask.reportParameters);
        _this.results = Object.entries(_this.callTask.scenarioResult.items[0]);
        for (var i = 1; i < _this.callTask.scenarioResult.items.length; i++) {
          _this.results = _this.results.concat(['', '']);
          _this.results = _this.results.concat(Object.entries(_this.callTask.scenarioResult.items[i]));
        }
        // this.results = this.callTask.scenarioResult.items
        // this.results = Object.entries(this.callTask.scenarioResult)
        _this.isSaved = true;
      }).catch(function (error) {
        console.log(error);
        // this.openNotificationWithType('danger', 'Ошибка загрузки информации о тестовом звонке. ')
        _this.callTask.campaign = _this.$props.id;
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.campaignid, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.campaign = response.data;
        // this.callTask.campaign = this.campaign
      });
    },
    cancel: function cancel() {
      this.$router.push('/callTasksTest/' + this.$props.campaignid);
    },
    getDateTime: function getDateTime(time) {
      var d = new Date(time);
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      var hour = d.getUTCHours();
      var minute = d.getUTCMinutes();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      if (hour < 10) hour = '0' + hour;
      if (minute < 10) minute = '0' + minute;
      return day + '.' + month + '.' + year + ' ' + hour + ':' + minute + ' UTC';
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__GetCalltaskState___default.a);

var CALLTASKS_API = '/outgoing-cpg';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    BackToTop: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_jump__["a" /* BackToTop */]
  },
  data: function data() {
    return {
      calltasks: [],
      campaign: ''
    };
  },

  created: function created() {
    this.checkToken();
    this.calltasks = this.loadData();
    this.loadCampaign();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(CALLTASKS_API + '/test/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.calltasks = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки тестовых телефонных номеров. ');
      });
    },
    loadCampaign: function loadCampaign() {
      var _this2 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.campaign = response.data;
      });
    },
    cancel: function cancel() {
      this.$router.push('/campaigns/' + this.$props.id);
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default.a);

var MessageComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var GET_ARCHIVE_LIST_API = '/api/campaigns/archive';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      campaigns: [],
      sortedCampaigns: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'dateCreated',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      isActive: false,
      permissionKey: 'campaign'
    };
  },


  created: function created() {
    this.checkToken();
    this.loadState();
    this.loadData();
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['loggedId', 'authenticationToken']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.campaigns.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(GET_ARCHIVE_LIST_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.campaigns = response.data;
        _this.sortedCampaigns = _this.sortedCamp();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка архивных рассылок. ');
      });
    },
    loadState: function loadState() {
      var _this2 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this2.isActive = response.data;
        if (!_this2.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    getReportCSV: function getReportCSV(campaign) {
      var _this3 = this;

      this.$http.get('/report/reportByCampaignId.csv?campaignId=' + campaign.id).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'ReportByCampaign_' + campaign.name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this3.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    getDate: function getDate(date) {
      var d = new Date(Number(date));
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      return day + '.' + month + '.' + year;
    },
    sortedCamp: function sortedCamp() {
      var _this4 = this;

      return this.campaigns.sort(function (a, b) {
        var modifier = 1;
        if (_this4.currentSortDir === 'desc') modifier = -1;
        if (a[_this4.currentSort] < b[_this4.currentSort]) return -1 * modifier;
        if (a[_this4.currentSort] > b[_this4.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this4.currentPage - 1) * _this4.perPage;
        var end = _this4.currentPage * _this4.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedCampaigns = this.sortedCamp();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedCampaigns = this.sortedCamp();
    },
    toggleDropdown: function toggleDropdown(event) {
      event.currentTarget.classList.toggle('is-active');
    }
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tabs__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_4_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_9__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_10__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var CAMPAIGNS_API = '/api/campaigns';
var SCENARIOS_API = '/api/scenarios';
var PHONEBASEUPLOADING_API = '/outgoing-cpg';
var CALLTASKS_API = '/outgoing-cpg';
var PAYMENTS_API = '/api/payments';
var APPCONFIG_API = '/api/appConfig';
var FSGATEWAY_API = 'api/fsgateways';
var PROFILES_API = '/api/profiles';
var CALLTASKTESTING_API = '/outgoing-cpg/callTasksTesting';
var REPORTS_API = '/calls';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id', 'idcopy'],
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_datepicker___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_1_vue_cleave___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_2__Modal___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_notification___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_message___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tabs__["b" /* TabPane */],
    Collapse: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_collapse__["Item"]
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])(['loggedUser', 'loggedId', 'loggedRole', 'clientId', 'authenticationToken']), {
    l10n: function l10n() {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
        },
        months: {
          shorthand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        }
      };
    }
  }),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    prepareSecurityHeaderYandex: function prepareSecurityHeaderYandex(uuid) {
      return {
        'Content-Type': 'application/json',
        'Idempotence-Key': uuid
      };
    },
    transformTimeStart: function transformTimeStart() {
      this.campaign.timeStart = this.transform(this.campaign.timeStart);
    },
    transformTimeEnd: function transformTimeEnd() {
      this.campaign.timeEnd = this.transform(this.campaign.timeEnd);
    },
    transform: function transform(tt) {
      var t = tt;
      if (t != null) {
        if (t.length === 3) {
          var part1 = t.substr(0, 2);
          var part2 = t.substr(2);
          if (part2 !== ':') {
            t = part1 + ':' + part2;
          }
        }
        if (t.length > 5) {
          t = t.substr(0, 5);
        }
      } else {
        t = '12:00';
      }
      return t;
    },
    save: function save(showMessage) {
      if (this.checkTime()) {
        this.campaign.phonePreprocessingParameters = {};
        for (var i = 0; i < this.phonePreprocessingParametersArray.length; i++) {
          var item = this.phonePreprocessingParametersArray[i];
          this.campaign.phonePreprocessingParameters[item[0]] = item[1];
        }
        if (this.campaign.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('warning', 'Неверно указано время рассылки.');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new campaign: ' + JSON.stringify(this.campaign));
      this.$http.post(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() }).then(function (response) {
        console.log(response.data);
        _this.isSaved = true;
        _this.campaign = response.data;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Рассылка сохранена.');
        }
        //        this.$router.push('/campaigns/')
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating campaign: ' + JSON.stringify(this.campaign));
      this.$http.put(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() }).then(function (response) {
        console.log(response.data);
        _this2.isSaved = true;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Рассылка сохранена.');
        }
        //        this.$router.push('/campaigns/')
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения рассылки. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить рассылку');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    loadState: function loadState() {
      var _this3 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this3.isActive = response.data;
        if (!_this3.isActive && !_this3.campaign.archiveStatus) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    loadAppConfig: function loadAppConfig() {
      var _this4 = this;

      this.$http.get(APPCONFIG_API + '/' + this.clientId, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this4.appconfig = response.data;
        _this4.campaign.gateway = _this4.appconfig.defaultGateway;
        _this4.campaign.scheduleStrategy = _this4.appconfig.defaultScheduleStrategy;
        _this4.campaign.postponingStrategy = _this4.appconfig.defaultPostponingConfig.strategy;
        _this4.campaign.telErrorStrategy = _this4.appconfig.defaultTelErrorStrategy.strategy;
        _this4.campaign.postponingAttempts = _this4.appconfig.defaultPostponingConfig.parameters.attempts;
        _this4.campaign.postponingIntervalMin = _this4.appconfig.defaultPostponingConfig.parameters.waitMinutes;
        _this4.campaign.dialplanContext = _this4.appconfig.defaultDialplanContext;
        _this4.campaign.dialplanExtension = _this4.appconfig.defaultDialplanExtension;
        _this4.campaign.targetStrategy = _this4.appconfig.defaultTargetStrategy;
        _this4.campaign.phonePreprocessingStrategy = _this4.appconfig.defaultPhonePreprocessingStrategy.strategy;
        _this4.campaign.recordHost = _this4.appconfig.defaultRecordHost;
        _this4.phonePreprocessingParametersArray = Object.entries(_this4.appconfig.defaultPhonePreprocessingStrategy.parameters);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    loadCampaign: function loadCampaign() {
      var _this5 = this;

      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening campaign ' + response.data.id);
        _this5.campaign = response.data;
        _this5.phonePreprocessingParametersArray = Object.entries(_this5.campaign.phonePreprocessingParameters);
        _this5.loadTasksCount();
        _this5.loadTasksCountPerformed();
        _this5.isSaved = true;
        _this5.getScenarioReadyState();
        _this5.loadState();
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка загрузки рассылки. ');
      });
    },
    deletePhonePreprocessingParameter: function deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1);
    },
    addPhonePreprocessingParameter: function addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({});
    },
    deleteTestPhoneParameter: function deleteTestPhoneParameter(index) {
      this.testPhoneParametersArray.splice(index, 1);
    },
    addTestPhoneParameter: function addTestPhoneParameter() {
      this.testPhoneParametersArray.push({});
    },
    copyCampaign: function copyCampaign() {
      var _this6 = this;

      this.$http({
        url: CAMPAIGNS_API + '/' + this.$props.idcopy,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('copying campaign ' + response.data.id);
        _this6.campaign = response.data;
        _this6.campaign.id = undefined;
        _this6.notSaved();
        _this6.loadState();
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка создания копии рассылки. ');
      });
    },
    loadScenarios: function loadScenarios() {
      var _this7 = this;

      this.$http.get(SCENARIOS_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this7.scenarios = response.data;
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка загрузки сценариев. ');
      });
    },
    loadFsGateways: function loadFsGateways() {
      var _this8 = this;

      this.$http.get(FSGATEWAY_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this8.fsGateways = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadTasksCount: function loadTasksCount() {
      var _this9 = this;

      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/count', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this9.tasksCount = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadTasksCountPerformed: function loadTasksCountPerformed() {
      var _this10 = this;

      this.$http.get(CALLTASKS_API + '/' + this.campaign.id + '/countPerformed', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this10.tasksCountPerformed = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getScenarioReadyState: function getScenarioReadyState() {
      var _this11 = this;

      this.$http({
        url: SCENARIOS_API + '/isReady/' + this.campaign.scenario,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this11.isReadyScenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this11.openNotificationWithType('danger', 'Ошибка получения состояния сценария. ');
      });
    },
    openModalDelete: function openModalDelete() {
      console.log('Нажали удалить базу');
      this.title = 'Удалить базу?';
      this.confirmation = true;
      this.openModal();
    },
    openModalReady: function openModalReady() {
      this.title = 'Подтверждаете готовность рассылки?';
      this.confirmation = true;
      this.openModal();
    },
    openModalClipboard: function openModalClipboard() {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку');
      } else {
        this.title = 'Загрузка базы';
        this.confirmation = false;
        this.openModal();
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
    },
    openModal: function openModal() {
      this.showModal = true;
    },
    confirmAction: function confirmAction(value) {
      this.closeModal();
      if (this.title == 'Подтверждаете готовность рассылки?') {
        this.save(false);
        this.setReadyStatus();
      }
      if (this.title == 'Удалить базу?') {
        this.deletePhones();
      }
      if (this.title == 'Загрузка базы') {
        this.clipboard = value;
        this.uploadPhonesFromClipboard();
      }
    },
    uploadPhonesFromClipboard: function uploadPhonesFromClipboard() {
      this.handleUploadPhonesFromClipboardRequest();
    },
    handleUploadPhonesFromClipboardRequest: function handleUploadPhonesFromClipboardRequest() {
      var _this12 = this;

      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaignFromClipboard', this.prepareClipboardMultipartFile(this.clipboard, this.campaign.id), { headers: this.prepareSecurityHeader(), timeout: 180000 }).then(function (response) {
        if (response.status == 200) {
          if (response.data == '') {
            _this12.openNotificationWithType('info', 'База загружена.');
            _this12.loadTasksCount();
          } else {
            _this12.openNotificationWithType('danger', response.data, 0);
            _this12.loadTasksCount();
          }
        } else {
          _this12.openNotificationWithType('danger', 'Ошибка загрузки файла');
          _this12.loadTasksCount();
        }
      }).catch(function (error) {
        _this12.openNotificationWithType('danger', 'Ошибка загрузки файла');
        _this12.loadTasksCount();
        console.log(error);
      });
      this.loadTasksCountPerformed();
    },
    prepareClipboardMultipartFile: function prepareClipboardMultipartFile(phonesClipboard, phonesCampaign) {
      var phonesFormData = new FormData();
      phonesFormData.append('clipboard', phonesClipboard);
      phonesFormData.append('campaign', phonesCampaign);
      return phonesFormData;
    },
    uploadPhones: function uploadPhones(inputId) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой базы необходимо сохранить рассылку');
        } else {
          //          this.save(false)
          this.handleUploadPhonesRequest(input.files[0]);
        }
      }
    },
    handleUploadPhonesRequest: function handleUploadPhonesRequest(phonesFile) {
      var _this13 = this;

      this.$http.post(PHONEBASEUPLOADING_API + '/' + 'loadForCampaign', this.prepareMultipartFile(phonesFile, this.campaign.id), { headers: this.prepareSecurityHeader(), timeout: 180000 }).then(function (response) {
        if (response.status == 200) {
          if (response.data == '') {
            _this13.openNotificationWithType('info', 'База загружена.');
            _this13.loadTasksCount();
          } else {
            _this13.openNotificationWithType('danger', response.data, 0);
            _this13.loadTasksCount();
          }
        } else {
          _this13.openNotificationWithType('danger', 'Ошибка загрузки файла');
          _this13.loadTasksCount();
        }
      }).catch(function (error) {
        _this13.openNotificationWithType('danger', 'Ошибка загрузки файла');
        _this13.loadTasksCount();
        console.log(error);
      });
      this.loadTasksCountPerformed();
    },
    prepareMultipartFile: function prepareMultipartFile(phonesFile, phonesCampaign) {
      var phonesFormData = new FormData();
      phonesFormData.append('file', phonesFile);
      phonesFormData.append('campaign', phonesCampaign);
      return phonesFormData;
    },
    deletePhones: function deletePhones() {
      var _this14 = this;

      this.$http.delete(PHONEBASEUPLOADING_API + '/' + this.campaign.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this14.openNotificationWithType('info', 'База удалена.');
        _this14.tasksCount = 0;
        //          this.save(false)
      }).catch(function (error) {
        console.log(error);
        _this14.openNotificationWithType('danger', 'Ошибка удаления телефонной базы. ');
      });
    },
    cancel: function cancel() {
      if (this.campaign.archiveStatus) {
        this.$router.push('/archive/');
      } else {
        this.$router.push('/campaigns/');
      }
    },
    gotoScenario: function gotoScenario() {
      this.$router.push('/scenarios/' + this.campaign.id + '/' + this.campaign.scenario);
    },
    viewCallTasks: function viewCallTasks() {
      this.$router.push('/callTasks/' + this.campaign.id);
    },
    viewMonitor: function viewMonitor() {
      this.$router.push('/monitoring/' + this.campaign.id);
    },
    viewTestCallTasks: function viewTestCallTasks() {
      this.$router.push('/callTasksTest/' + this.campaign.id);
    },
    prepareReport: function prepareReport() {
      var _this15 = this;

      this.$http.get('/report/prepareReportByCampaignId?campaignId=' + this.campaign.id).then(function (response) {
        _this15.openNotificationWithType('info', 'Отчет подготовлен');
        _this15.loadCampaign();
        _this15.loadScenarios();
        _this15.loadFsGateways();
      }).catch(function (error) {
        _this15.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' + ' Необходимо будет обновить эту страницу, нажав Ctrl+F5');
        console.log(error);
      });
    },
    getReportCSV: function getReportCSV() {
      var _this16 = this;

      // this.$http.get('/report/reportByCampaignId.csv?campaignId=' + this.campaign.id)
      this.$http.get(REPORTS_API + '/id/' + this.campaign.id + '/win/csv?audioPath=' + (this.campaign.recordHost + '/' + this.campaign.clientId + '/' + this.campaign.id), { headers: this.prepareSecurityHeader() }).then(function (response) {
        var s = response.headers['content-disposition'];
        var res = s.split('filename="').pop();
        res = res.split('"')[0];
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        // a.download = 'ReportByCampaign_' + this.campaign.name + '.csv'
        a.download = res;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this16.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    getReadyCallTasksCSV: function getReadyCallTasksCSV() {
      var _this17 = this;

      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + this.campaign.id).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'readyCallTasksByCampaign_' + _this17.campaign.name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this17.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    makePayment: function makePayment() {
      var _this18 = this;

      if (this.reg.test(this.sumPayment)) {
        if (this.sumPayment > 0) {
          this.$http.post(PAYMENTS_API + '/yandex', this.preparePaymentParameters(this.loggedId, this.sumPayment), { headers: this.prepareSecurityHeader() }).then(function (response) {
            window.location.href = response.data;
          }).catch(function (error) {
            console.log(error);
            _this18.openNotificationWithType('danger', 'Ошибка платежа. ');
          });
        } else {
          this.openNotificationWithType('danger', 'Укажите сумму больше нуля');
        }
      } else {
        this.openNotificationWithType('danger', 'Некорректный формат числа');
      }
    },
    preparePaymentParameters: function preparePaymentParameters(id, sum) {
      var paymentFormData = new FormData();
      var currentUrl = window.location;
      paymentFormData.append('id', id);
      paymentFormData.append('sum', sum);
      paymentFormData.append('returnUrl', currentUrl);
      return paymentFormData;
    },
    setReadyStatus: function setReadyStatus() {
      var _this19 = this;

      this.campaign.state = 'Подготовлена';
      this.$http.put(CAMPAIGNS_API, this.campaign, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this19.openNotificationWithType('success', 'Рассылка подготовлена');
      }).catch(function (error) {
        console.log(error);
        _this19.openNotificationWithType('danger', 'Ошибка запуска рассылки. ');
      });
    },
    canSetReadyStatus: function canSetReadyStatus() {
      var result = (this.campaign.state == 'В разработке' || this.canContinue()) && this.canModerate(this.permissionKey) && this.campaign.client != null && this.campaign.date != null && this.campaign.scenario != null && this.campaign.zoneOffset != null && this.campaign.timeStart != null && this.campaign.timeEnd && this.isReadyScenario && (this.campaign.postponingIntervalMin == 0 && this.campaign.postponingAttempts == 0 || this.campaign.postponingIntervalMin != 0 && this.campaign.postponingAttempts != 0) || this.appconfig.campaignSetReadyButtonVisibleForAll;
      return result;
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    canEdit: function canEdit() {
      if (this.campaign.archiveStatus) {
        return false;
      }
      if (!this.isActive) {
        return false;
      } else {
        if (this.loggedRole == 1) {
          return this.campaign.state == 'В разработке' || this.campaign.state == 'Подготовлена' || this.campaign.id == undefined;
        } else {
          return this.campaign.state == 'В разработке' || this.campaign.id == undefined;
        }
      }
    },
    canContinue: function canContinue() {
      if (!this.isActive) {
        return false;
      } else {
        return this.campaign.state == 'Завершена' && this.campaign.hasReadyTasks;
      }
    },
    callTest: function callTest(showMessage) {
      var _this20 = this;

      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед тестом необходимо сохранить рассылку');
      } else {
        if (this.testPhone.trim() != '') {
          console.log('saving new testing call task: ' + JSON.stringify(this.testPhone));
          this.$http.post(CALLTASKTESTING_API, this.prepareTestPhone(this.campaign.id, this.testPhone, this.testPhoneParametersArray), { headers: this.prepareSecurityHeader() }).then(function (response) {
            _this20.testPhone = '';
            _this20.testPhoneParametersArray = [{
              key: '',
              value: ''
            }];
            // this.callTask = response.data
            _this20.loadTasksCount();
            if (showMessage) {
              _this20.openNotificationWithType('info', 'Номер тестового звонка сохранен.');
            }
          }).catch(function (error) {
            console.log(error);
            _this20.openNotificationWithType('danger', 'Ошибка создания тестового звонка. ');
          });
        }
      }
    },
    prepareTestPhoneForm: function prepareTestPhoneForm(campaignId, testPhone, testPhoneParametersArray) {
      var formData = new FormData();
      formData.append('campaignId', campaignId);
      formData.append('phone', testPhone);
      var testPhoneParameters = {};
      for (var i = 0; i < testPhoneParametersArray.length; i++) {
        var item = testPhoneParametersArray[i];
        testPhoneParameters[item[0]] = item[1];
      }
      formData.append('parameters', JSON.stringify(testPhoneParameters));
      return formData;
    },
    prepareTestPhone: function prepareTestPhone(campaignId, testPhone, testPhoneParametersArray) {
      var testCallTaskDto = {
        phone: '',
        campaign: '',
        parameters: {}
      };
      testCallTaskDto.campaign = campaignId;
      testCallTaskDto.phone = testPhone;
      var testPhoneParameters = {};
      for (var i = 0; i < testPhoneParametersArray.length; i++) {
        var item = testPhoneParametersArray[i];
        testPhoneParameters[item[0]] = item[1];
      }
      testCallTaskDto.parameters = testPhoneParameters;
      return testCallTaskDto;
    },
    checkTime: function checkTime() {
      return this.regTime.test(this.campaign.timeStart) && this.regTime.test(this.campaign.timeEnd) && this.campaign.timeEnd.localeCompare(this.campaign.timeStart) > 0;
    },
    openNotificationWithType: function openNotificationWithType(type, message, duration) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type,
        duration: duration
      });
    }
  },
  data: function data() {
    return {
      campaign: {
        timeStart: '10:00',
        timeEnd: '18:00'
      },
      scenarios: [],
      tasksCount: '',
      tasksCountPerformed: 0,
      sumPayment: 0,
      reg: /^[-]?[0-9]+[.]?[0-9]{0,2}$/,
      regTime: /^(([0,1][0-9])|(2[0-3])):[0-5][0-9]$/,
      showModal: null,
      title: '',
      confirmation: true,
      isSaved: false,
      fsGateways: [],
      appconfig: {},
      isActive: false,
      isReadyScenario: false,
      clipboard: '',
      testPhone: '',
      testPhoneParametersArray: [{
        key: '',
        value: ''
      }],
      permissionKey: 'campaign',
      phonePreprocessingParametersArray: [{
        key: '',
        value: ''
      }]
    };
  },

  created: function created() {
    this.checkToken();
    this.loadAppConfig();
    this.loadFsGateways();
    if (!this.$props.id) {
      if (!this.$props.idcopy) {
        console.log('creating new campaign');
        this.notSaved();
        this.loadState();
      } else {
        console.log('copying campaign: ' + this.name);
        this.copyCampaign();
      }
    } else {
      console.log('loading campaign: ' + this.name);
      this.loadCampaign();
    }
    this.loadScenarios();
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_2__authentication_CheckToken___default.a);

var MONITORING_API = '/monitoring';
var CAMPAIGNS_API = '/api/campaigns';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      campaignProgress: {},
      campaign: ''
    };
  },
  created: function created() {
    this.checkToken();
    this.calltasks = this.loadData();
    this.loadCampaign();
    this.monitoringCampaign();
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(MONITORING_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.campaignProgress = response.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    monitoringCampaign: function monitoringCampaign() {
      var _this2 = this;

      this.$root.monitor = setInterval(function () {
        _this2.calltasks = _this2.loadData();
      }, 60000);
    },
    loadCampaign: function loadCampaign() {
      var _this3 = this;

      this.$http.get(CAMPAIGNS_API + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.campaign = response.data;
      });
    },
    cancel: function cancel() {
      clearInterval(this.$root.monitor);
      this.$router.push('/campaigns/' + this.$props.id);
    }
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tooltip__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_7__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_8__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var CAMPAIGN_API = '/api/campaigns';
var REPORTS_API = '/calls';
var CALLTASKS_API = '/outgoing-cpg';
var APPCONFIG_API = '/api/appConfig';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Chart: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_chartjs___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_1__Modal___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Tooltip: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_tooltip__["a" /* default */]
  },

  data: function data() {
    return {
      campaigns: [],
      sortedCampaigns: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'dateCreated',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      searchName: '',
      campaignToDelete: null,
      campaignToArchive: null,
      campaignToReady: null,
      showModal: null,
      title: '',
      confirmation: true,
      appconfig: {},
      isActive: false,
      permissionKey: 'campaign'
    };
  },


  created: function created() {
    this.checkToken();
    this.loadState();
    this.loadAppConfig();
    this.loadData();
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loggedId', 'clientId', 'authenticationToken']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.campaigns.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(CAMPAIGN_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.campaigns = response.data;
        _this.sortedCampaigns = _this.sortedCamp();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка рассылок. ');
      });
    },
    loadState: function loadState() {
      var _this2 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this2.isActive = response.data;
        if (!_this2.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    loadAppConfig: function loadAppConfig() {
      var _this3 = this;

      this.$http.get(APPCONFIG_API + '/' + this.clientId, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.appconfig = response.data;
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    sortedCamp: function sortedCamp() {
      var _this4 = this;

      return this.campaigns.filter(this.filterByName).sort(function (a, b) {
        var modifier = 1;
        if (_this4.currentSortDir === 'desc') modifier = -1;
        if (a[_this4.currentSort] < b[_this4.currentSort]) return -1 * modifier;
        if (a[_this4.currentSort] > b[_this4.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this4.currentPage - 1) * _this4.perPage;
        var end = _this4.currentPage * _this4.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedCampaigns = this.sortedCamp();
    },

    filterByName: function filterByName(campaign) {
      if (this.searchName.length === 0) {
        return true;
      }
      return campaign.name.toLowerCase().indexOf(this.searchName.toLowerCase()) > -1;
    },
    searchByName: function searchByName() {
      this.sortedCampaigns = this.sortedCamp();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    closeModal: function closeModal() {
      this.campaignToDelete = null;
      this.campaignToArchive = null;
      this.campaignToReady = null;
      this.showModal = false;
    },
    openModal: function openModal(campaign, type) {
      if (type == 'archive') {
        this.campaignToArchive = campaign;
        this.campaignToDelete = null;
        this.campaignToReady = null;
        this.title = 'Перенести рассылку в архив?';
        this.confirmation = true;
      }
      if (type == 'delete') {
        this.campaignToDelete = campaign;
        this.campaignToArchive = null;
        this.campaignToReady = null;
        this.title = 'Удалить рассылку?';
        this.confirmation = true;
      }
      if (type == 'readyStatus') {
        this.campaignToDelete = null;
        this.campaignToArchive = null;
        this.campaignToReady = campaign;
        this.title = 'Подтверждаете готовность рассылки?';
        this.confirmation = true;
      }
      this.showModal = true;
    },
    confirmAction: function confirmAction() {
      if (this.campaignToDelete) {
        this.removeCampaign();
        this.campaignToDelete = null;
      }
      if (this.campaignToArchive) {
        this.addToArchive();
        this.campaignToArchive = null;
      }
      if (this.campaignToReady) {
        this.setReadyStatus();
        this.campaignToReady = null;
      }
      this.closeModal();
    },
    addToArchive: function addToArchive() {
      var _this5 = this;

      this.campaignToArchive.archiveStatus = true;
      this.$http.put(CAMPAIGN_API, this.campaignToArchive, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this5.openNotificationWithType('info', 'Рассылка помещена в архив.');
        _this5.campaigns = _this5.loadData();
        //          this.$router.push('/archive/')
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка переноса в архив. ');
      });
    },
    removeCampaign: function removeCampaign() {
      var _this6 = this;

      this.$http.delete(CAMPAIGN_API + '/' + this.campaignToDelete.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this6.openNotificationWithType('info', 'Рассылка удалена.');
        _this6.campaigns = _this6.loadData();
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка удаления рассылки. ');
      });
    },
    copyCampaign: function copyCampaign(campaign) {
      // <a href="#/campaigns/new" :disabled="!isActive" class="button is-success">
      this.$router.push('/copy/' + campaign.id);
      // <a :href="'#/campaigns/'+campaign.id">{{campaign.name}}</a>
    },
    isRemove: function isRemove(index) {
      // return (this.isDependentCallTask(index) || this.isReadyCallTask(index))
      // return this.isDependentCallTask(index)
      return !this.campaigns[index].hasPerformedTasks;
    },
    isDependentCallTask: function isDependentCallTask(index) {
      return this.campaigns[index].phones === 0;
    },
    isReadyCallTask: function isReadyCallTask(index) {
      var _this7 = this;

      this.$http.get(CALLTASKS_API + '/' + this.campaigns[index].id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        var readyArray = _this7.handleReadyState(response.data);
        return readyArray.length > 0;
      }).catch(function (error) {
        console.log(error);
      });
    },
    handleReadyState: function handleReadyState(callTaskList) {
      return callTaskList.filter(function (callTask) {
        return callTask.state === 'READY';
      });
    },
    canDeleteState: function canDeleteState(campaign) {
      return (campaign.state === 'Подготовлена' || campaign.state === 'В разработке') && !campaign.hasPerformedTasks;
    },
    setReadyStatus: function setReadyStatus() {
      var _this8 = this;

      this.campaignToReady.state = 'Подготовлена';
      this.$http.put(CAMPAIGN_API, this.campaignToReady, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this8.openNotificationWithType('info', 'Рассылка готова к запуску.');
        _this8.campaigns = _this8.loadData();
      }).catch(function (error) {
        console.log(error);
        _this8.openNotificationWithType('danger', 'Ошибка запуска рассылки. ');
      });
    },
    canSetReadyStatus: function canSetReadyStatus(campaign) {
      var result = (campaign.state == 'В разработке' || this.canContinue(campaign)) && this.canModerate(this.permissionKey) && campaign.client != null && campaign.date != null && campaign.scenario != null && campaign.zoneOffset != null && campaign.timeStart != null && campaign.timeEnd && (campaign.postponingIntervalMin == 0 && campaign.postponingAttempts == 0 || campaign.postponingIntervalMin != 0 && campaign.postponingAttempts != 0) || this.appconfig.campaignSetReadyButtonVisibleForAll;
      return result;
    },
    canContinue: function canContinue(campaign) {
      return campaign.state == 'Завершена' && campaign.hasReadyTasks;
    },
    prepareReport: function prepareReport(campaign) {
      var _this9 = this;

      this.$http.get('/report/prepareReportByCampaignId?campaignId=' + campaign.id).then(function (response) {
        _this9.openNotificationWithType('info', 'Отчет подготовлен');
        _this9.campaigns = _this9.loadData();
      }).catch(function (error) {
        _this9.openNotificationWithType('warning', 'Отчет формируется. Пожалуйста, загрузите его чуть позже.' + ' Необходимо будет обновить эту страницу, нажав Ctrl+F5');
        console.log(error);
      });
    },
    viewMonitor: function viewMonitor(campaign) {
      this.$router.push('/monitoring/' + campaign.id);
    },
    getReportCSV: function getReportCSV(campaign) {
      var _this10 = this;

      // this.$http.get('/report/reportByCampaignId.csv?campaignId=' + campaign.id)
      this.$http.get(REPORTS_API + '/id/' + campaign.id + '/win/csv?audioPath=' + (campaign.recordHost + '/' + campaign.clientId + '/' + campaign.id), { headers: this.prepareSecurityHeader() }).then(function (response) {
        var s = response.headers['content-disposition'];
        var res = s.split('filename="').pop();
        res = res.split('"')[0];
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        // a.download = 'ReportByCampaign_' + campaign.name + '.csv'
        a.download = res;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this10.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    getReadyCallTasksCSV: function getReadyCallTasksCSV(campaign) {
      var _this11 = this;

      this.$http.get(CALLTASKS_API + '/readyCallTasksByCampaignId.csv?campaignId=' + campaign.id).then(function (response) {
        var blob = new Blob([response.data], { type: 'text/csv' });
        var a = window.document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = 'readyCallTasksByCampaign_' + campaign.name + '.csv';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }).catch(function (error) {
        _this11.openNotificationWithType('danger', 'Ошибка загрузки отчета');
        console.log(error);
      });
    },
    getSumConsume: function getSumConsume(campaign) {
      var _this12 = this;

      console.log(campaign.id);
      this.$http.get(CAMPAIGN_API + '/sumConsume/' + campaign.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this12.openNotificationWithType('info', 'Сумма расчитана.');
        _this12.campaigns = _this12.loadData();
        //          this.$router.push('/archive/')
      }).catch(function (error) {
        console.log(error);
        _this12.openNotificationWithType('danger', 'Ошибка рассчета суммы. ');
      });
    },
    getDate: function getDate(date) {
      var d = new Date(Number(date));
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      return day + '.' + month + '.' + year;
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedCampaigns = this.sortedCamp();
    },
    toggleDropdown: function toggleDropdown(event) {
      event.currentTarget.classList.toggle('is-active');
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__["a" /* Modal */]
  },

  props: {
    visible: Boolean,
    title: String,
    confirmation: Boolean,
    clipboard: Boolean,
    clipboardArea: ''
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var USERS_API = '/api/users';
var CLIENTS_API = '/api/clients';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_1_vue_bulma_notification___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_tabs__["b" /* TabPane */]
  },
  data: function data() {
    return {
      users: [],
      client: '',
      permissionKey: 'client',
      clientConfigArray: [{
        key: '',
        value: ''
      }],
      activeScenarioTemplatesArray: [{
        key: '',
        value: ''
      }],
      phonePreprocessingParametersArray: [{
        key: '',
        value: ''
      }]
    };
  },

  created: function created() {
    this.checkToken();
    this.users = this.loadData();
    this.loadClient();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(USERS_API + '/getUsersByClient/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.users = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки информации о пользователях. ');
      });
    },
    loadClient: function loadClient() {
      var _this2 = this;

      this.$http.get(CLIENTS_API + '/getClient/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.client = response.data;
        _this2.clientConfigArray = Object.entries(_this2.client.clientConfig);
        _this2.activeScenarioTemplatesArray = [];
        for (var i = 0; i < _this2.clientConfigArray.length; i++) {
          if (_this2.clientConfigArray[i][0] === 'activeScenarioTemplates') {
            _this2.activeScenarioTemplatesArray = Object.entries(Object.entries(_this2.client.clientConfig)[i][1]);
          }
        }
        _this2.phonePreprocessingParametersArray = Object.entries(_this2.client.clientConfig.defaultPhonePreprocessingStrategyParameters);
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки данных клиента. ');
      });
    },
    save: function save(showMessage) {
      this.client.clientConfig = {};
      for (var i = 0; i < this.clientConfigArray.length; i++) {
        var item = this.clientConfigArray[i];
        this.client.clientConfig[item[0]] = item[1];
      }
      this.client.clientConfig.activeScenarioTemplates = {};
      for (var _i = 0; _i < this.activeScenarioTemplatesArray.length; _i++) {
        var _item = this.activeScenarioTemplatesArray[_i];
        this.client.clientConfig.activeScenarioTemplates[_item[0]] = _item[1];
      }
      this.client.clientConfig.defaultPhonePreprocessingStrategyParameters = {};
      for (var _i2 = 0; _i2 < this.phonePreprocessingParametersArray.length; _i2++) {
        var _item2 = this.phonePreprocessingParametersArray[_i2];
        this.client.clientConfig.defaultPhonePreprocessingStrategyParameters[_item2[0]] = _item2[1];
      }
      this.update(showMessage);
    },
    update: function update(showMessage) {
      var _this3 = this;

      console.log('updating client config: ' + JSON.stringify(this.client));
      this.$http.put(CLIENTS_API, this.client, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this3.openNotificationWithType('info', 'Параметры клиента сохранены.');
        }
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка сохранения данных клиента. ');
      });
    },
    canEdit: function canEdit() {
      return true;
    },
    cancel: function cancel() {
      // this.$router.push('/clients/' + this.$props.id)
      this.$router.push('/clients');
    },
    deletePhonePreprocessingParameter: function deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1);
    },
    addPhonePreprocessingParameter: function addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({});
    },
    openNotificationWithType: function openNotificationWithType(type, message, duration) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type,
        duration: duration
      });
    }
  }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4600,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var CLIENTS_API = '/api/clients';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      clients: [],
      sortedClients: [],
      newClient: {
        name: ''
      },
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'name',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      dependedUserId: null,
      permissionKey: 'client'
    };
  },

  created: function created() {
    this.checkToken();
    this.loadData();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.clients.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(CLIENTS_API + '/getClients/' + this.loggedId, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.clients = response.data;
        _this.sortedClients = _this.sortedClient();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка клиентов. ');
      });
    },
    sortedClient: function sortedClient() {
      var _this2 = this;

      return this.clients.sort(function (a, b) {
        var modifier = 1;
        if (_this2.currentSortDir === 'desc') modifier = -1;
        if (a[_this2.currentSort] < b[_this2.currentSort]) return -1 * modifier;
        if (a[_this2.currentSort] > b[_this2.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this2.currentPage - 1) * _this2.perPage;
        var end = _this2.currentPage * _this2.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedClients = this.sortedClient();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedClients = this.sortedClient();
    },
    addClient: function addClient() {
      var _this3 = this;

      if (this.newClient) {
        this.$http.post(CLIENTS_API, this.newClient, { headers: this.prepareSecurityHeader() }).then(function (response) {
          _this3.clients = _this3.loadData();
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка добавления клиента. ');
        });
      } else {
        this.openNotificationWithType('danger', 'Укажите название клиента');
      }
    },
    removeClient: function removeClient(client) {
      var _this4 = this;

      this.$http.delete(CLIENTS_API + '/' + client.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this4.openNotificationWithType('info', 'Клиент удален.');
        _this4.clients = _this4.loadData();
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка удаления клиента. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cleave__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      profile: {},
      isSaved: false
    };
  },

  created: function created() {
    this.handleProfile();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedRole', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    save: function save() {
      if (this.profile.id === undefined) {
        this.saveNew();
      } else {
        this.update();
      }
    },
    saveNew: function saveNew() {
      var _this = this;

      //      if (this.user.username != '') {
      //        if (this.reg.test(this.user.username)) {
      console.log('saving new profile: ' + JSON.stringify(this.profile));
      this.$http.post(PROFILES_API, this.profile, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (response.data != '') {
          console.log(response.data);
          _this.isSaved = true;
          _this.profile = response.data;
          _this.openNotificationWithType('info', 'Профиль сохранен.');
          //                this.$router.push('/users/')
        } else {
          console.log('Already exist');
          _this.openNotificationWithType('danger', 'Такой профиль уже существует.');
        }
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения данных');
      });
      //        } else {
      //          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
      //        }
      //      } else {
      //        errorMessage = 'Необходимо ввести адрес электронной почты'
      //      }
    },
    update: function update() {
      var _this2 = this;

      //      if (this.user.username != '') {
      //        if (this.reg.test(this.user.username)) {
      console.log('updating profile: ' + JSON.stringify(this.profile));
      this.$http.put(PROFILES_API, this.profile, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        console.log(response.data);
        _this2.openNotificationWithType('info', 'Профиль сохранен.');
        //              this.$router.push('/users/')
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения данных');
      });
      //        } else {
      //          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
      //        }
      //      } else {
      //        errorMessage = 'Необходимо ввести адрес электронной почты'
      //      }
    },
    handleProfile: function handleProfile() {
      if (this.$props.id) {
        console.log('loading profile: ' + this.profile.username);
        this.loadProfile();
      } else {
        console.log('creating new profile');
        this.notSaved();
        return {};
      }
    },
    loadProfile: function loadProfile() {
      var _this3 = this;

      this.$http({
        url: PROFILES_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this3.profile = response.data;
        _this3.isSaved = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    uploadContract: function uploadContract(inputId) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить профиль');
        } else {
          if (input.files[0].size > 10 * 1024 * 1024) {
            this.openNotificationWithType('danger', 'Слишком большой файл (> 10 Мб)');
          } else {
            this.handleUploadContractRequest(input.files[0]);
          }
        }
      }
    },
    handleUploadContractRequest: function handleUploadContractRequest(contractFile) {
      var _this4 = this;

      this.$http.post(PROFILES_API + '/' + 'loadContract', this.prepareMultipartFile(contractFile, this.$props.id), this.prepareSecurityHeader()).then(function (response) {
        console.log(response);
        if (response.status == 200) {
          _this4.openNotificationWithType('info', 'Файл загружен.');
          // this.loadTasksCount()
          _this4.loadProfile();
        } else {
          _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
          // this.loadTasksCount()
        }
      }).catch(function (error) {
        _this4.openNotificationWithType('danger', 'Ошибка загрузки файла');
        // this.loadTasksCount()
        console.log(error);
      });
      // this.loadTasksCountPerformed()
    },
    prepareMultipartFile: function prepareMultipartFile(contractFile, userId) {
      var contractFormData = new FormData();
      contractFormData.append('file', contractFile);
      contractFormData.append('id', userId);
      return contractFormData;
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    canEdit: function canEdit() {
      return this.loggedRole == 1;
    },
    cancel: function cancel() {
      this.$router.push('/users/' + this.$props.id);
    }
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__["a" /* Modal */]
  },

  props: {
    visible: Boolean,
    title: String
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0_vue_bulma_modal__["a" /* Modal */],
    audioRecorder: __WEBPACK_IMPORTED_MODULE_1__audiorecording_audioRecorder___default.a
  },

  props: {
    visible: Boolean,
    title: String,
    audioUrl: ''
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    confirmAction: function confirmAction(value) {
      this.$emit('confirm', value);
    }
  }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScenarioQuestionRecognition__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScenarioQuestionRecognition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ScenarioQuestionRecognition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScenarioQuestionYesNo__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScenarioQuestionYesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ScenarioQuestionYesNo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScenarioTwoLevelYesNo__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ScenarioTwoLevelYesNo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ScenarioTwoLevelYesNo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScenarioQuestionInterview__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScenarioQuestionInterview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ScenarioQuestionInterview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScenarioInterviewAFewQuestions__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScenarioInterviewAFewQuestions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ScenarioInterviewAFewQuestions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScenarioNotice__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ScenarioNotice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ScenarioNotice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__authentication_CheckToken__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// import {loadedScenario} from "../../store/getters";

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_8__authentication_CheckToken___default.a);

var api = '/api/scenarios';
var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['campaignid', 'id'],

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])(['authenticationToken'])),
  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapMutations"])(['setLoadedScenario']), {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadAppConfig: function loadAppConfig() {
      var _this = this;

      this.$http.get(APPCONFIG_API + '/templates', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.templates = response.data;
        for (var i = 0; i < _this.selectList.length; i++) {
          if (_this.templates[_this.selectList[i].name]) {
            _this.activeSelectList.push(_this.selectList[i]);
          }
        }
        _this.currentScenario = _this.activeSelectList[0].name;
        _this.loadedScenario = _this.loadScenario();
        console.log('loadedScenario ' + _this.loadedScenario);
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    loadScenario: function loadScenario() {
      var _this2 = this;

      if (this.$props.id) {
        this.$http.get(api + '/' + this.$props.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
          _this2.setLoadedScenario(response.data);
          _this2.currentScenario = response.data.template;
          _this2.setLoadedScenario(response.data);
          return response.data;
        }).catch(function (error) {
          console.log(error);
          _this2.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
        });
      } else {
        this.setLoadedScenario(null);
        return null;
      }
    },
    setScenario: function setScenario(value) {
      this.loadedScenario = value;
    }
  }),
  components: {
    ScenarioQuestionRecognition: __WEBPACK_IMPORTED_MODULE_0__ScenarioQuestionRecognition___default.a,
    ScenarioQuestionYesNo: __WEBPACK_IMPORTED_MODULE_1__ScenarioQuestionYesNo___default.a,
    ScenarioTwoLevelYesNo: __WEBPACK_IMPORTED_MODULE_2__ScenarioTwoLevelYesNo___default.a,
    ScenarioQuestionInterview: __WEBPACK_IMPORTED_MODULE_3__ScenarioQuestionInterview___default.a,
    ScenarioNotice: __WEBPACK_IMPORTED_MODULE_5__ScenarioNotice___default.a,
    ScenarioInterviewAFewQuestions: __WEBPACK_IMPORTED_MODULE_4__ScenarioInterviewAFewQuestions___default.a
  },
  created: function created() {
    this.checkToken();
    // this.currentScenario = this.selectList[0].name
    if (!this.$props.id) {
      console.log('creating new scenario');
      this.appconfig = this.loadAppConfig();
    } else {
      console.log('loading scenario: ' + this.name);
      this.appconfig = this.loadAppConfig();
    }
  },
  data: function data() {
    return {
      currentScenario: '',
      selectList: [{
        id: 1,
        name: 'recognition'
      }, {
        id: 2,
        name: 'yesnoonequestion'
      }, {
        id: 3,
        name: 'yesnotwoquestions'
      }, {
        id: 4,
        name: 'notification'
      }, {
        id: 5,
        name: 'poll'
      }],
      activeSelectList: [],
      loadedScenario: null,
      templates: {
        name: '',
        active: false
      }
    };
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    addNewParameter: function addNewParameter() {
      this.scenario.parameters.dynamicQuestions.push({ generationState: true, text: '', audio: '', id: undefined, key: Math.floor(Math.random() * 99999999) + 1 });
      this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: '', dynamicLoading: false, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
    },
    deleteParameter: function deleteParameter(i) {
      this.scenario.parameters.dynamicQuestions.splice(i, 1);
      this.tmp.dynamicTmp.splice(i, 1);
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      this.scenario.parameters.dynamicQuestions.forEach(function (dynamicQuestion) {
        if (!dynamicQuestion.generationState) {
          dynamicQuestion.text = '';
        }
      });
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed,
          'text': text
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return { 'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ' };
    },
    onChangeGenerationState: function onChangeGenerationState(state, index, key) {
      var parameter = this.scenario.parameters.dynamicQuestions[index];
      if (state) {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
        this.$refs['audio-' + key][0].load();
      } else {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
        this.$refs['audio-' + key][0].load();
      }
    },
    loadAudio: function loadAudio(index, key) {
      var input = this.$refs['load-audio-' + key][0];
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(index, key, input.files[0]);
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(index, key, audioFile) {
      var _this3 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders()).then(function (response) {
        _this3.setAudioValue(index, key, response);
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(index) {
      var _this4 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters.dynamicQuestions[index].id, { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this4.deleteAudioValue(index);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    setAudioValue: function setAudioValue(index, key, response) {
      this.scenario.parameters.dynamicQuestions[index].id = response.data;
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '/audios/' + response.data + '.wav';
      this.scenario.parameters.dynamicQuestions[index].audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
      this.$refs['audio-' + key][0].load();
    },
    deleteAudioValue: function deleteAudioValue(index) {
      this.scenario.parameters.dynamicQuestions[index].id = '';
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '';
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '';
      this.scenario.parameters.dynamicQuestions[index].audio = '';
    },
    genAudio: function genAudio(index) {
      var _this5 = this;

      var parameter = this.scenario.parameters.dynamicQuestions[index];
      var text = parameter.text,
          id = parameter.id;

      var requestData = this.genAudioRequest(id, 'audioname' + (index + 1), text, this.tmp.dynamicTmp[index].dynamicSpeaker, this.tmp.dynamicTmp[index].dynamicEmotion, this.tmp.dynamicTmp[index].dynamicSpeed);
      var config = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp.dynamicTmp[index].dynamicLoading = true;
        this.$http.post(audioGeneratorApi, requestData, config).then(function (response) {
          _this5.handleGenRequest(parameter, index, response.data);
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
          _this5.$refs['audio-' + parameter.key][0].load();
        }).catch(function (error) {
          console.log(error);
          _this5.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(parameter, index, data) {
      parameter.id = data;
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '/audios/' + data + '.wav';
      parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), value.blob);
      // var key = this.currentAudio.get('audioValue')
      // this.$refs[`audio-${key}`][0].load()
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    },
    clickLoadAudio: function clickLoadAudio(parameterkey) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        this.$refs['load-audio-' + parameterkey][0].click();
      }
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'poll',
        parameters: {
          dynamicQuestions: [{
            generationState: true,
            text: '',
            audio: '',
            id: undefined,
            key: 0
          }]
        },
        checkDuration: true
      },
      tmp: {
        dynamicTmp: [{
          dynamicGeneratedAudio: '',
          dynamicLoadedAudio: '',
          dynamicLoading: false,
          dynamicSpeaker: 'oksana',
          dynamicEmotion: 'neutral',
          dynamicSpeed: 1
        }]
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    // for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
    //  this.$watch('scenario.parameters.dynamicQuestions[dynamicIndex].audio', function () {
    //    const key = scenario.parameters.dynamicQuestions[dynamicIndex].key
    //    this.$refs[`audio-${key}`][0].load()
    //  })
    // }
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    insertPause: function insertPause(textareaId) {
      var textarea = document.getElementById(textareaId);
      var pausePattern = ' \\pause:1 ';
      if (document.selection) {
        textarea.focus();
        var sel = document.selection.createRange();
        sel.text = pausePattern;
      } else if (textarea.selectionStart || textarea.selectionStart == '0') {
        var startPos = textarea.selectionStart;
        var endPos = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, startPos) + pausePattern + textarea.value.substring(endPos, textarea.value.length);
        textarea.selectionStart = startPos + pausePattern.length;
        textarea.selectionEnd = startPos + pausePattern.length;
      } else {
        textarea.value += pausePattern;
        textarea.selectionStart = textarea.value.length;
      }
      textarea.focus();
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      if (!this.scenario.parameters.questionGenerationState) {
        this.scenario.parameters.questionText = '';
      }
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': this.currentSpeaker,
          'emotion': this.currentEmotion,
          'speed': this.currentSpeed,
          'text': text
        }
      };
      if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    prepareLoadAudioRequest: function prepareLoadAudioRequest(possibleId, uploadAudio) {
      var request = {
        'scenario': this.scenario.id,
        'client': this.scenario.client,
        'audioName': uploadAudio.filename,
        'audioBytes': uploadAudio
      };
      if (possibleId) {
        request.id = id;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(audioId, audioValue, generationType, questionText, loadingStatus, audioName) {
      var request = this.genAudioRequest(this.scenario.parameters[audioId], audioName, this.scenario.parameters[questionText]);
      this.handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request);
    },
    handleGenerateRequest: function handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request) {
      var _this3 = this;

      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.scenario.parameters[audioId] = response.data;
          _this3.tmp[generationType] = '/audios/' + _this3.scenario.parameters[audioId] + '.wav';
          _this3.scenario.parameters[audioValue] = _this3.tmp[generationType];
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
        });
      }
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
        _this6.question_audio = '/audios/' + _this6.scenario.parameters.questionId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'notification',
        parameters: {
          questionId: '',
          questionAudio: '',
          questionText: '',
          questionGenerationState: true
        },
        checkDuration: true
      },
      tmp: {
        generatedQuestionAudio: '',
        loadedQuestionAudio: '',
        questionLoading: false
      },
      question_audio: '',
      currentSpeaker: 'oksana',
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionAudio', function () {
      this.$refs.questionPlayer.load();
    });
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
    }
  },

  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    addNewParameter: function addNewParameter() {
      this.scenario.parameters.dynamicQuestions.push({ generationState: true, text: '', audio: '', id: undefined, key: Math.floor(Math.random() * 99999999) + 1 });
      this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: '', dynamicLoading: false, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
    },
    deleteParameter: function deleteParameter(i) {
      this.scenario.parameters.dynamicQuestions.splice(i, 1);
      this.tmp.dynamicTmp.splice(i, 1);
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      if (!this.scenario.parameters.questionFirstGenerationState) {
        this.scenario.parameters.questionFirstText = '';
      }
      if (!this.scenario.parameters.questionSecondGenerationState) {
        this.scenario.parameters.questionSecondText = '';
      }
      if (!this.scenario.parameters.questionSecondYesGenerationState) {
        this.scenario.parameters.questionSecondYesText = '';
      }
      if (!this.scenario.parameters.questionSecondNoGenerationState) {
        this.scenario.parameters.questionSecondNoText = '';
      }
      this.scenario.parameters.dynamicQuestions.forEach(function (dynamicQuestion) {
        if (!dynamicQuestion.generationState) {
          dynamicQuestion.text = '';
        }
      });
      this.scenario.parameters.questionSecondYesOptional = true;
      this.scenario.parameters.questionSecondNoOptional = true;
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      this.scenario.parameters.questionSecondYesOptional = true;
      this.scenario.parameters.questionSecondNoOptional = true;
      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed,
          'text': text
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return { 'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ' };
    },
    onChangeGenerationState: function onChangeGenerationState(state, index, key) {
      var parameter = this.scenario.parameters.dynamicQuestions[index];
      if (state) {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
        this.$refs['audio-' + key][0].load();
      } else {
        parameter.audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
        this.$refs['audio-' + key][0].load();
      }
    },
    loadAudio: function loadAudio(index, key) {
      var input = this.$refs['load-audio-' + key][0];
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(index, key, input.files[0]);
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(index, key, audioFile) {
      var _this3 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile), this.prepareUploadHeaders()).then(function (response) {
        _this3.setAudioValue(index, key, response);
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(index) {
      var _this4 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters.dynamicQuestions[index].id, { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this4.deleteAudioValue(index);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    setAudioValue: function setAudioValue(index, key, response) {
      this.scenario.parameters.dynamicQuestions[index].id = response.data;
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '/audios/' + response.data + '.wav';
      this.scenario.parameters.dynamicQuestions[index].audio = this.tmp.dynamicTmp[index].dynamicLoadedAudio;
      this.$refs['audio-' + key][0].load();
    },
    deleteAudioValue: function deleteAudioValue(index) {
      this.scenario.parameters.dynamicQuestions[index].id = '';
      this.tmp.dynamicTmp[index].dynamicLoadedAudio = '';
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '';
      this.scenario.parameters.dynamicQuestions[index].audio = '';
    },
    genAudio: function genAudio(index) {
      var _this5 = this;

      var parameter = this.scenario.parameters.dynamicQuestions[index];
      var text = parameter.text,
          id = parameter.id;

      var requestData = this.genAudioRequest(id, 'audioname' + (index + 1), text, this.tmp.dynamicTmp[index].dynamicSpeaker, this.tmp.dynamicTmp[index].dynamicEmotion, this.tmp.dynamicTmp[index].dynamicSpeed);
      var config = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp.dynamicTmp[index].dynamicLoading = true;
        this.$http.post(audioGeneratorApi, requestData, config).then(function (response) {
          _this5.handleGenRequest(parameter, index, response.data);
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
          _this5.$refs['audio-' + parameter.key][0].load();
        }).catch(function (error) {
          console.log(error);
          _this5.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this5.tmp.dynamicTmp[index].dynamicLoading = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(parameter, index, data) {
      parameter.id = data;
      this.tmp.dynamicTmp[index].dynamicGeneratedAudio = '/audios/' + data + '.wav';
      parameter.audio = this.tmp.dynamicTmp[index].dynamicGeneratedAudio;
    },
    onChangeGenerationStateStatic: function onChangeGenerationStateStatic(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudioStatic: function genAudioStatic(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
      var _this6 = this;

      var request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this6.handleGenRequestStatic(id, audio, generatedAudio, response.data);
          _this6.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this6.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this6.tmp[loadingStatus] = false;
        });
      }
    },
    handleGenRequestStatic: function handleGenRequestStatic(id, audio, generatedAudio, data) {
      this.scenario.parameters[id] = data;
      this.tmp[generatedAudio] = '/audios/' + data + '.wav';
      this.scenario.parameters[audio] = this.tmp[generatedAudio];
    },
    loadAudioStatic: function loadAudioStatic(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequestStatic(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequestStatic: function handleUploadRequestStatic(audioId, audioValue, generationType, audioFile, audioName) {
      var _this7 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this7.setAudioValueStatic(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudioStatic: function deleteAudioStatic(audioId, audioValue, generationType1, generationType2) {
      var _this8 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this8.deleteAudioValueStatic(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this8.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValueStatic: function setAudioValueStatic(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValueStatic: function deleteAudioValueStatic(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this9 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this9.isSaved = true;
        _this9.scenario = response.data;
        _this9.question_first_audio = '/audios/' + _this9.scenario.parameters.questionFirstId + '.wav';
        _this9.question_second_audio = '/audios/' + _this9.scenario.parameters.questionSecondId + '.wav';
        _this9.question_second_yes_audio = '/audios/' + _this9.scenario.parameters.questionSecondYesId + '.wav';
        _this9.question_second_no_audio = '/audios/' + _this9.scenario.parameters.questionSecondNoId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this9.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName, isStatic) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
        this.currentAudio.append('isStatic', isStatic);
      }
    },
    confirmAction: function confirmAction(value) {
      if (this.currentAudio.get('isStatic') == 'true') {
        this.handleUploadRequestStatic(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
        // this.$refs['questionPlayer'].load()
      } else {
        this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), value.blob);
        // var key = this.currentAudio.get('audioValue')
        // this.$refs[`audio-${key}`][0].load()
      }
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this10 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this10.isActive = response.data;
        if (!_this10.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this10.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    },
    clickLoadAudio: function clickLoadAudio(parameterkey) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        this.$refs['load-audio-' + parameterkey][0].click();
      }
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'Опрос',
        parameters: {
          questionFirstId: '',
          questionFirstAudio: '',
          questionFirstText: '',
          questionFirstGenerationState: true,

          questionSecondId: '',
          questionSecondAudio: '',
          questionSecondText: '',
          questionSecondGenerationState: true,

          questionSecondYesId: '',
          questionSecondYesAudio: '',
          questionSecondYesText: '',
          questionSecondYesOptional: true,
          questionSecondYesGenerationState: true,

          questionSecondNoId: '',
          questionSecondNoAudio: '',
          questionSecondNoText: '',
          questionSecondNoOptional: true,
          questionSecondNoGenerationState: true,

          dynamicQuestions: [{
            generationState: true,
            text: '',
            audio: '',
            id: undefined,
            key: 0
          }]
        },
        checkDuration: true
      },
      tmp: {
        questionFirstGeneratedAudio: '',
        questionFirstLoadedAudio: '',
        questionFirstLoading: false,
        currentSpeakerFirst: 'oksana',
        currentEmotionFirst: 'neutral',
        currentSpeedFirst: 1,

        questionSecondGeneratedAudio: '',
        questionSecondLoadedAudio: '',
        questionSecondLoading: false,
        currentSpeakerSecond: 'oksana',
        currentEmotionSecond: 'neutral',
        currentSpeedSecond: 1,

        questionSecondYesGeneratedAudio: '',
        questionSecondYesLoadedAudio: '',
        questionSecondYesLoading: false,
        currentSpeakerSecondYes: 'oksana',
        currentEmotionSecondYes: 'neutral',
        currentSpeedSecondYes: 1,

        questionSecondNoGeneratedAudio: '',
        questionSecondNoLoadedAudio: '',
        questionSecondNoLoading: false,
        currentSpeakerSecondNo: 'oksana',
        currentEmotionSecondNo: 'neutral',
        currentSpeedSecondNo: 1,

        dynamicTmp: [{
          dynamicGeneratedAudio: '',
          dynamicLoadedAudio: '',
          dynamicLoading: false,
          dynamicSpeaker: 'oksana',
          dynamicEmotion: 'neutral',
          dynamicSpeed: 1
        }]
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      question_first_audio: '',
      question_second_audio: '',
      question_second_yes_audio: '',
      question_second_no_audio: '',
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionFirstAudio', function () {
      this.$refs.onQuestionFirst.load();
    });
    this.$watch('scenario.parameters.questionSecondAudio', function () {
      this.$refs.onQuestionSecond.load();
    });
    this.$watch('scenario.parameters.questionSecondYesAudio', function () {
      this.$refs.onQuestionSecondYes.load();
    });
    this.$watch('scenario.parameters.questionSecondNoAudio', function () {
      this.$refs.onQuestionSecondNo.load();
    });
    // for (let dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
    //  this.$watch('scenario.parameters.dynamicQuestions[dynamicIndex].audio', function () {
    //    const key = scenario.parameters.dynamicQuestions[dynamicIndex].key
    //    this.$refs[`audio-${key}`][0].load()
    //  })
    // }
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }
      if (this.scenario.parameters.questionSecondGenerationState) {
        this.tmp.questionSecondGeneratedAudio = this.scenario.parameters.questionSecondAudio;
      } else {
        this.tmp.questionSecondLoadedAudio = this.scenario.parameters.questionSecondAudio;
      }
      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }
      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }
      if (this.scenario.parameters.questionSecondGenerationState) {
        this.tmp.questionSecondGeneratedAudio = this.scenario.parameters.questionSecondAudio;
      } else {
        this.tmp.questionSecondLoadedAudio = this.scenario.parameters.questionSecondAudio;
      }
      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }
      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }
      for (var dynamicIndex = 0; dynamicIndex < this.scenario.parameters.dynamicQuestions.length; dynamicIndex++) {
        var audio = this.scenario.parameters.dynamicQuestions[dynamicIndex].audio;
        if (dynamicIndex != 0) {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: audio, dynamicLoadedAudio: '', dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          } else {
            this.tmp.dynamicTmp.push({ dynamicGeneratedAudio: '', dynamicLoadedAudio: audio, dynamicSpeaker: 'oksana', dynamicEmotion: 'neutral', dynamicSpeed: 1 });
          }
        } else {
          if (this.scenario.parameters.dynamicQuestions[dynamicIndex].generationState) {
            this.tmp.dynamicTmp[dynamicIndex].dynamicGeneratedAudio = audio;
          } else {
            this.tmp.dynamicTmp[dynamicIndex].dynamicLoadedAudio = audio;
          }
        }
      }
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_6__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_7_vue_bulma_slider___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    insertPause: function insertPause(textareaId) {
      var textarea = document.getElementById(textareaId);
      var pausePattern = ' \\pause:1 ';
      if (document.selection) {
        textarea.focus();
        var sel = document.selection.createRange();
        sel.text = pausePattern;
      } else if (textarea.selectionStart || textarea.selectionStart == '0') {
        var startPos = textarea.selectionStart;
        var endPos = textarea.selectionEnd;
        textarea.value = textarea.value.substring(0, startPos) + pausePattern + textarea.value.substring(endPos, textarea.value.length);
        textarea.selectionStart = startPos + pausePattern.length;
        textarea.selectionEnd = startPos + pausePattern.length;
      } else {
        textarea.value += pausePattern;
        textarea.selectionStart = textarea.value.length;
      }
      textarea.focus();
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));
      if (!this.scenario.parameters.questionGenerationState) {
        this.scenario.parameters.questionText = '';
      }
      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        console.log(response.data);
        _this2.isSaved = true;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
        _this2.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed,
          'text': text
        }
      };
      if (maybeId) {
        request.id = maybeId;
      }
      console.log(request);
      return request;
    },
    prepareLoadAudioRequest: function prepareLoadAudioRequest(possibleId, uploadAudio) {
      var request = {
        'scenario': this.scenario.id,
        'client': this.scenario.client,
        'audioName': uploadAudio.filename,
        'audioBytes': uploadAudio
      };
      if (possibleId) {
        request.id = id;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(audioId, audioValue, speaker, generationType, text, loadingStatus, audioName, emotion, speed) {
      console.log(emotion);
      console.log(this.tmp[emotion]);
      var request = this.genAudioRequest(this.scenario.parameters[audioId], audioName, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      this.handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request);
    },
    handleGenerateRequest: function handleGenerateRequest(audioId, audioValue, generationType, loadingStatus, request) {
      var _this3 = this;

      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.scenario.parameters[audioId] = response.data;
          _this3.tmp[generationType] = '/audios/' + _this3.scenario.parameters[audioId] + '.wav';
          _this3.scenario.parameters[audioValue] = _this3.tmp[generationType];
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
        });
      }
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
        _this6.question_audio = '/audios/' + _this6.scenario.parameters.questionId + '.wav';
        _this6.conclusionAudio = '/audios/' + _this6.scenario.parameters.conclusionId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'recognition',
        parameters: {
          questionId: '',
          questionAudio: '',
          questionText: '',
          questionGenerationState: true,

          conclusionId: '',
          conclusionAudio: '',
          conclusionText: '',
          conclusionGenerationState: true
        },
        checkDuration: true
      },
      tmp: {
        generatedQuestionAudio: '',
        loadedQuestionAudio: '',
        questionLoading: false,
        currentSpeakerQuestion: 'oksana',
        currentEmotionQuestion: 'neutral',
        currentSpeedQuestion: 1,
        conclusionGeneratedAudio: '',
        conclusionLoadedAudio: '',
        conclusionLoading: false,
        currentSpeakerConclusion: 'oksana',
        currentEmotionConclusion: 'neutral',
        currentSpeedConclusion: 1
      },
      question_audio: '',
      conclusionAudio: '',
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      isSaved: false,
      isActive: false,
      isReady: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionAudio', function () {
      this.$refs.questionPlayer.load();
    });
    this.$watch('scenario.parameters.conclusionAudio', function () {
      this.$refs.conclusionPlayer.load();
    });
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
      if (this.scenario.parameters.conclusionGenerationState) {
        this.tmp.generatedConclusionAudio = this.scenario.parameters.conclusionAudio;
      } else {
        this.tmp.loadedConclusionAudio = this.scenario.parameters.conclusionAudio;
      }
    }
  },

  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }
      if (this.scenario.parameters.questionGenerationState) {
        this.tmp.generatedQuestionAudio = this.scenario.parameters.questionAudio;
      } else {
        this.tmp.loadedQuestionAudio = this.scenario.parameters.questionAudio;
      }
      if (this.scenario.parameters.conclusionGenerationState) {
        this.tmp.generatedConclusionAudio = this.scenario.parameters.conclusionAudio;
      } else {
        this.tmp.loadedConclusionAudio = this.scenario.parameters.conclusionAudio;
      }
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));

      if (!this.scenario.parameters.mainGenerationState) {
        this.scenario.parameters.mainQuestionText = '';
      }
      if (!this.scenario.parameters.onYesGenerationState) {
        this.scenario.parameters.onYesText = '';
      }
      if (!this.scenario.parameters.onNoGenerationState) {
        this.scenario.parameters.onNoText = '';
      }

      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed,
          'text': text
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return {
        'testH': 'testHV',
        'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ'
      };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else if (!this.tmp[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
      var _this3 = this;

      var request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.handleGenRequest(id, audio, generatedAudio, response.data);
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this3.tmp[loadingStatus] = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(id, audio, generatedAudio, data) {
      this.scenario.parameters[id] = data;
      this.tmp[generatedAudio] = '/audios/' + data + '.wav';
      this.scenario.parameters[audio] = this.tmp[generatedAudio];
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.scenario = response.data;
        _this6.q1audio = '/audios/' + _this6.scenario.parameters.mainQuestionId + '.wav';
        _this6.onQuestionYesAudio = '/audios/' + _this6.scenario.parameters.onYesId + '.wav';
        _this6.onQuestionNoAudio = '/audios/' + _this6.scenario.parameters.onNoId + '.wav';
        _this6.isSaved = true;
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'yesnoonequestion',
        parameters: {
          mainQuestionId: '',
          mainQuestionAudio: '',
          mainQuestionText: '',
          mainGenerationState: true,

          onYesId: '',
          onYesAudio: '',
          onYesText: '',
          onYesGenerationState: true,
          onYesSMSText: '',

          onNoId: '',
          onNoAudio: '',
          onNoText: '',
          onNoGenerationState: true
        },
        checkDuration: true
      },
      tmp: {
        mainGeneratedAudio: '',
        mainLoadedAudio: '',
        mainLoading: false,
        currentSpeakerMain: 'oksana',
        currentEmotionMain: 'neutral',
        currentSpeedMain: 1,

        onYesGeneratedAudio: '',
        onYesLoadedAudio: '',
        onYesLoading: false,
        currentSpeakerYes: 'oksana',
        currentEmotionYes: 'neutral',
        currentSpeedYes: 1,

        onNoGeneratedAudio: '',
        onNoLoadedAudio: '',
        onNoLoading: false,
        currentSpeakerNo: 'oksana',
        currentEmotionNo: 'neutral',
        currentSpeedNo: 1
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      q1audio: '',
      onQuestionYesAudio: '',
      onQuestionNoAudio: '',
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (!this.$props.name) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + !this.$props.name);
      this.load();
    }
    this.$watch('scenario.parameters.mainQuestionAudio', function () {
      this.$refs.mainPlayer.load();
    });
    this.$watch('scenario.parameters.onYesAudio', function () {
      this.$refs.onYesPlayer.load();
    });
    this.$watch('scenario.parameters.onNoAudio', function () {
      this.$refs.onNoPlayer.load();
    });

    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.mainGenerationState) {
        this.tmp.mainGeneratedAudio = this.scenario.parameters.mainQuestionAudio;
      } else {
        this.tmp.mainLoadedAudio = this.scenario.parameters.mainQuestionAudio;
      }

      if (this.scenario.parameters.onYesGenerationState) {
        this.tmp.onYesGeneratedAudio = this.scenario.parameters.onYesAudio;
      } else {
        this.tmp.onYesLoadedAudio = this.scenario.parameters.onYesAudio;
      }

      if (this.scenario.parameters.onNoGenerationState) {
        this.tmp.onNoGeneratedAudio = this.scenario.parameters.onNoAudio;
      } else {
        this.tmp.onNoLoadedAudio = this.scenario.parameters.onNoAudio;
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.mainGenerationState) {
        this.tmp.mainGeneratedAudio = this.scenario.parameters.mainQuestionAudio;
      } else {
        this.tmp.mainLoadedAudio = this.scenario.parameters.mainQuestionAudio;
      }

      if (this.scenario.parameters.onYesGenerationState) {
        this.tmp.onYesGeneratedAudio = this.scenario.parameters.onYesAudio;
      } else {
        this.tmp.onYesLoadedAudio = this.scenario.parameters.onYesAudio;
      }

      if (this.scenario.parameters.onNoGenerationState) {
        this.tmp.onNoGeneratedAudio = this.scenario.parameters.onNoAudio;
      } else {
        this.tmp.onNoLoadedAudio = this.scenario.parameters.onNoAudio;
      }
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ModalAudio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var NotificationComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var audioGeneratorApi = '/audios/generate';
var audioUploadApi = '/audios/save';
var audioDeleteApi = '/audios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name', 'campaignid'],
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_7__ModalAudio___default.a,
    Cleave: __WEBPACK_IMPORTED_MODULE_0_vue_cleave___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_1__components_audio_player_vue___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_6_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_notification___default.a,
    Collapse: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Collapse"],
    CollapseItem: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_collapse__["Item"],
    Slider: __WEBPACK_IMPORTED_MODULE_8_vue_bulma_slider___default.a
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])(['loadedScenario', 'loggedId', 'loggedUser', 'authenticationToken'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },

    changeRoute: function changeRoute(e) {
      this.$router.push({ path: '/scenarios' + e.target.value });
    },
    checkAudioDuration: function checkAudioDuration() {
      this.scenario.checkDuration = true;
      var len = document.querySelectorAll('audio').length;
      for (var i = 0; i < len; i++) {
        if (document.querySelectorAll('audio')[i].attributes.getNamedItem('src') != null) {
          this.scenario.checkDuration = this.scenario.checkDuration && document.querySelectorAll('audio')[i].duration > 0;
        }
      }
      return this.scenario.checkDuration;
    },
    save: function save(showMessage) {
      if (this.checkAudioDuration()) {
        if (this.scenario.id === undefined) {
          this.saveNew(showMessage);
        } else {
          this.update(showMessage);
        }
      } else {
        this.openNotificationWithType('danger', 'Нельзя сохранить сценарий с аудиофайлом нулевой длительности');
      }
    },
    saveNew: function saveNew(showMessage) {
      var _this = this;

      console.log('saving new scenario: ' + JSON.stringify(this.scenario));

      if (!this.scenario.parameters.questionFirstGenerationState) {
        this.scenario.parameters.questionFirstText = '';
      }
      if (!this.scenario.parameters.questionSecondYesGenerationState) {
        this.scenario.parameters.questionSecondYesText = '';
      }
      if (!this.scenario.parameters.questionSecondYesYesGenerationState) {
        this.scenario.parameters.questionSecondYesYesText = '';
      }
      if (!this.scenario.parameters.questionSecondYesNoGenerationState) {
        this.scenario.parameters.questionSecondYesNoText = '';
      }
      if (!this.scenario.parameters.questionSecondNoGenerationState) {
        this.scenario.parameters.questionSecondNoText = '';
      }
      if (!this.scenario.parameters.questionSecondNoYesGenerationState) {
        this.scenario.parameters.questionSecondNoYesText = '';
      }
      if (!this.scenario.parameters.questionSecondNoNoGenerationState) {
        this.scenario.parameters.questionSecondNoNoText = '';
      }
      this.scenario.parameters.questionSecondYesYesOptional = true;
      this.scenario.parameters.questionSecondYesNoOptional = true;
      this.scenario.parameters.questionSecondNoYesOptional = true;
      this.scenario.parameters.questionSecondNoNoOptional = true;

      this.$http.post(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.isSaved = true;
        if (showMessage) {
          _this.openNotificationWithType('info', 'Сценарий сохранен');
          _this.$emit('set', _this.scenario);
        }
        _this.scenario = response.data;
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    update: function update(showMessage) {
      var _this2 = this;

      this.scenario.parameters.questionSecondYesYesOptional = true;
      this.scenario.parameters.questionSecondYesNoOptional = true;
      this.scenario.parameters.questionSecondNoYesOptional = true;
      this.scenario.parameters.questionSecondNoNoOptional = true;
      console.log('updating scenario: ' + JSON.stringify(this.scenario));
      this.$http.put(api, this.scenario, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.isSaved = true;
        _this2.scenario = response.data;
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Сценарий сохранен');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения сценария. ');
      });
    },
    uploadFile: function uploadFile(buttonId) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить сценарий');
      } else {
        document.getElementById(buttonId).click();
      }
    },
    genAudioRequest: function genAudioRequest(maybeId, audioName, text, speaker, emotion, speed) {
      var request = {
        'client': this.scenario.client,
        'scenario': this.scenario.id,
        'audioName': audioName,
        'generator': 'yandex',
        'text': text,
        'parameters': {
          'speaker': speaker,
          'emotion': emotion,
          'speed': speed,
          'text': text
        }
        // if audio already generated, request must contain id, so backend will overwrite existing audio
      };if (maybeId) {
        request.id = maybeId;
      }
      return request;
    },
    securityHeaders: function securityHeaders() {
      return { 'testH': 'testHV', 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ' };
    },
    onChangeGenerationState: function onChangeGenerationState(stateId, audioId, generatedAudioId, loadedAudioId, playerId) {
      if (this.scenario.parameters[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[generatedAudioId];
        this.$refs[playerId][0].load();
      } else if (!this.tmp[stateId]) {
        this.scenario.parameters[audioId] = this.tmp[loadedAudioId];
        this.$refs[playerId][0].load();
      }
    },
    genAudio: function genAudio(id, audio, speaker, generatedAudio, text, loadingStatus, name, emotion, speed) {
      var _this3 = this;

      var request = this.genAudioRequest(this.scenario.parameters[id], name, this.scenario.parameters[text], this.tmp[speaker], this.tmp[emotion], this.tmp[speed]);
      var headers = { headers: this.securityHeaders() };
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед генерацией аудио необходимо сохранить сценарий');
      } else {
        this.tmp[loadingStatus] = true;
        this.$http.post(audioGeneratorApi, request, headers).then(function (response) {
          _this3.handleGenRequest(id, audio, generatedAudio, response.data);
          _this3.tmp[loadingStatus] = false;
        }).catch(function (error) {
          console.log(error);
          _this3.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
          _this3.tmp[loadingStatus] = false;
        });
      }
    },
    handleGenRequest: function handleGenRequest(id, audio, generatedAudio, data) {
      this.scenario.parameters[id] = data;
      this.tmp[generatedAudio] = '/audios/' + data + '.wav';
      this.scenario.parameters[audio] = this.tmp[generatedAudio];
    },
    loadAudio: function loadAudio(inputId, audioId, audioValue, generationType, audioName, player) {
      var input = document.querySelector('#' + inputId);
      if (input.files && input.files[0]) {
        if (!this.isSaved) {
          this.openNotificationWithType('danger', 'Перед загрузкой аудио необходимо сохранить сценарий');
        } else {
          this.handleUploadRequest(audioId, audioValue, generationType, input.files[0], audioName);
          this.$refs[player].load();
        }
      }
    },
    handleUploadRequest: function handleUploadRequest(audioId, audioValue, generationType, audioFile, audioName) {
      var _this4 = this;

      this.$http.post(audioUploadApi, this.prepareMultipartAudio(audioFile, audioName, this.scenario.client, this.scenario.id), this.prepareUploadHeaders()).then(function (response) {
        _this4.setAudioValue(audioId, generationType, audioValue, response);
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка загрузки аудио. ');
      });
    },
    deleteAudio: function deleteAudio(audioId, audioValue, generationType1, generationType2) {
      var _this5 = this;

      this.$http.delete(audioDeleteApi + '/' + this.scenario.parameters[audioId], { headers: this.prepareUploadHeaders() }).then(function (response) {
        _this5.deleteAudioValue(audioId, generationType1, generationType2, audioValue);
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка удаления аудио. ');
      });
    },
    prepareMultipartAudio: function prepareMultipartAudio(audioFile, audioName, audioClient, audioScenario) {
      var audioFormData = new FormData();
      audioFormData.append('file', audioFile);
      audioFormData.append('name', audioName);
      audioFormData.append('client', audioClient);
      audioFormData.append('scenario', audioScenario);
      return audioFormData;
    },
    prepareUploadHeaders: function prepareUploadHeaders() {
      return {
        'headers': {
          'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJBdWRpb0dlbiJ9.qvTNenonHsJkYSNclO8SX0AQ3BIWmiZyQDL7PrnThzXJOmlxNZRuln10_LnL78E90wreiXADVimVa4CKSEI6BQ',
          'Content-Type': 'multipart/form-data',
          'testH': 'testHV'
        }
      };
    },
    setAudioValue: function setAudioValue(audioId, generationType, audioValue, response) {
      this.scenario.parameters[audioId] = response.data;
      this.tmp[generationType] = '/audios/' + this.scenario.parameters[audioId] + '.wav';
      this.scenario.parameters[audioValue] = this.tmp[generationType];
    },
    deleteAudioValue: function deleteAudioValue(audioId, generationType1, generationType2, audioValue) {
      this.scenario.parameters[audioId] = '';
      this.tmp[generationType1] = '';
      this.tmp[generationType2] = '';
      this.scenario.parameters[audioValue] = '';
    },
    load: function load() {
      var _this6 = this;

      this.$http({
        url: api + '/' + this.name,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening scenario ' + JSON.stringify(response.data));
        _this6.isSaved = true;
        _this6.scenario = response.data;
        _this6.question_first_audio = '/audios/' + _this6.scenario.parameters.questionFirstId + '.wav';
        _this6.question_second_yes_audio = '/audios/' + _this6.scenario.parameters.questionSecondYesId + '.wav';
        _this6.question_second_yes_yes_audio = '/audios/' + _this6.scenario.parameters.questionSecondYesYesId + '.wav';
        _this6.question_second_yes_no_audio = '/audios/' + _this6.scenario.parameters.questionSecondYesNoId + '.wav';
        _this6.question_second_no_audio = '/audios/' + _this6.scenario.parameters.questionSecondNoId + '.wav';
        _this6.question_second_no_yes_audio = '/audios/' + _this6.scenario.parameters.questionSecondNoYesId + '.wav';
        _this6.question_second_no_no_audio = '/audios/' + _this6.scenario.parameters.questionSecondNoNoId + '.wav';
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки сценария. ');
      });
    },
    cancel: function cancel() {
      if (this.$props.campaignid == 0) {
        this.$router.push('/scenarios/');
      } else {
        this.$router.push('/campaigns/' + this.$props.campaignid);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.currentAudio = null;
    },
    openModal: function openModal(audioId, audioValue, generationType, audioName) {
      if (!this.isSaved) {
        this.openNotificationWithType('danger', 'Перед записью аудио необходимо сохранить сценарий');
      } else {
        this.showModal = true;
        this.currentAudio = new FormData();
        this.currentAudio.append('audioId', audioId);
        this.currentAudio.append('audioValue', audioValue);
        this.currentAudio.append('generationType', generationType);
        this.currentAudio.append('audioName', audioName);
      }
    },
    confirmAction: function confirmAction(value) {
      this.handleUploadRequest(this.currentAudio.get('audioId'), this.currentAudio.get('audioValue'), this.currentAudio.get('generationType'), value.blob, this.currentAudio.get('audioName'));
      this.closeModal();
    },
    notSaved: function notSaved() {
      this.isSaved = false;
    },
    loadState: function loadState() {
      var _this7 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this7.isActive = response.data;
        if (!_this7.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  },
  data: function data() {
    return {
      scenario: {
        template: 'yesnotwoquestions',
        parameters: {
          questionFirstId: '',
          questionFirstAudio: '',
          questionFirstText: '',
          questionFirstGenerationState: true,

          questionSecondYesId: '',
          questionSecondYesAudio: '',
          questionSecondYesText: '',
          questionSecondYesGenerationState: true,
          questionSecondYesSMSText: '',

          questionSecondYesYesId: '',
          questionSecondYesYesAudio: '',
          questionSecondYesYesText: '',
          questionSecondYesYesOptional: true,
          questionSecondYesYesGenerationState: true,
          questionSecondYesYesSMSText: '',

          questionSecondYesNoId: '',
          questionSecondYesNoAudio: '',
          questionSecondYesNoText: '',
          questionSecondYesNoOptional: true,
          questionSecondYesNoGenerationState: true,

          questionSecondNoId: '',
          questionSecondNoAudio: '',
          questionSecondNoText: '',
          questionSecondNoGenerationState: true,

          questionSecondNoYesId: '',
          questionSecondNoYesAudio: '',
          questionSecondNoYesText: '',
          questionSecondNoYesOptional: true,
          questionSecondNoYesGenerationState: true,

          questionSecondNoNoId: '',
          questionSecondNoNoAudio: '',
          questionSecondNoNoText: '',
          questionSecondNoNoOptional: true,
          questionSecondNoNoGenerationState: true
        },
        checkDuration: true
      },
      tmp: {
        questionFirstGeneratedAudio: '',
        questionFirstLoadedAudio: '',
        questionFirstLoading: false,
        currentSpeakerFirst: 'oksana',
        currentEmotionFirst: 'neutral',
        currentSpeedFirst: 1,

        questionSecondYesGeneratedAudio: '',
        questionSecondYesLoadedAudio: '',
        questionSecondYesLoading: false,
        currentSpeakerSecondYes: 'oksana',
        currentEmotionSecondYes: 'neutral',
        currentSpeedSecondYes: 1,

        questionSecondYesYesGeneratedAudio: '',
        questionSecondYesYesLoadedAudio: '',
        questionSecondYesYesLoading: false,
        currentSpeakerSecondYesYes: 'oksana',
        currentEmotionSecondYesYes: 'neutral',
        currentSpeedSecondYesYes: 1,

        questionSecondYesNoGeneratedAudio: '',
        questionSecondYesNoLoadedAudio: '',
        questionSecondYesNoLoading: false,
        currentSpeakerSecondYesNo: 'oksana',
        currentEmotionSecondYesNo: 'neutral',
        currentSpeedSecondYesNo: 1,

        questionSecondNoGeneratedAudio: '',
        questionSecondNoLoadedAudio: '',
        questionSecondNoLoading: false,
        currentSpeakerSecondNo: 'oksana',
        currentEmotionSecondNo: 'neutral',
        currentSpeedSecondNo: 1,

        questionSecondNoYesGeneratedAudio: '',
        questionSecondNoYesLoadedAudio: '',
        questionSecondNoYesLoading: false,
        currentSpeakerSecondNoYes: 'oksana',
        currentEmotionSecondNoYes: 'neutral',
        currentSpeedSecondNoYes: 1,

        questionSecondNoNoGeneratedAudio: '',
        questionSecondNoNoLoadedAudio: '',
        questionSecondNoNoLoading: false,
        currentSpeakerSecondNoNo: 'oksana',
        currentEmotionSecondNoNo: 'neutral',
        currentSpeedSecondNoNo: 1
      },
      speakerList: [{
        value: 'jane'
      }, {
        value: 'oksana'
      }, {
        value: 'alyss '
      }, {
        value: 'omazh'
      }, {
        value: 'zahar '
      }, {
        value: 'ermil '
      }],
      currentEmotion: 'neutral',
      emotionList: [{
        value: 'good'
      }, {
        value: 'neutral'
      }, {
        value: 'evil'
      }],
      currentSpeed: 1,
      question_first_audio: '',
      question_second_yes_audio: '',
      question_second_yes_yes_audio: '',
      question_second_yes_no_audio: '',
      question_second_no_audio: '',
      question_second_no_yes_audio: '',
      question_second_no_no_audio: '',
      isSaved: false,
      isActive: false,
      showModal: null,
      title: '',
      currentAudio: null
    };
  },

  created: function created() {
    this.loadState();
    if (this.name === undefined) {
      console.log('creating new scenario');
      this.notSaved();
    } else {
      console.log('loading scenario: ' + this.name);
      this.load();
    }
    this.$watch('scenario.parameters.questionFirstAudio', function () {
      this.$refs.onQuestionFirst.load();
    });
    this.$watch('scenario.parameters.questionSecondYesAudio', function () {
      this.$refs.onQuestionSecondYes.load();
    });
    this.$watch('scenario.parameters.questionSecondYesYesAudio', function () {
      this.$refs.onQuestionSecondYesYes.load();
    });
    this.$watch('scenario.parameters.questionSecondYesNoAudio', function () {
      this.$refs.onQuestionSecondYesNo.load();
    });
    this.$watch('scenario.parameters.questionSecondNoAudio', function () {
      this.$refs.onQuestionSecondNo.load();
    });
    this.$watch('scenario.parameters.questionSecondNoYesAudio', function () {
      this.$refs.onQuestionSecondNoYes.load();
    });
    this.$watch('scenario.parameters.questionSecondNoNoAudio', function () {
      this.$refs.onQuestionSecondNoNo.load();
    });

    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }

      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }

      if (this.scenario.parameters.questionSecondYesYesGenerationState) {
        this.tmp.questionSecondYesYesGeneratedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      } else {
        this.tmp.questionSecondYesYesLoadedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      }

      if (this.scenario.parameters.questionSecondYesNoGenerationState) {
        this.tmp.questionSecondYesNoGeneratedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      } else {
        this.tmp.questionSecondYesNoLoadedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      }

      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }

      if (this.scenario.parameters.questionSecondNoYesGenerationState) {
        this.tmp.questionSecondNoYesGeneratedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      } else {
        this.tmp.questionSecondNoYesLoadedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      }

      if (this.scenario.parameters.questionSecondNoNoGenerationState) {
        this.tmp.questionSecondNoNoGeneratedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      } else {
        this.tmp.questionSecondNoNoLoadedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      }
    }
  },
  beforeUpdate: function beforeUpdate() {
    if (this.loadedScenario) {
      this.isSaved = true;
      if (this.scenario.isReady) {
        this.isReady = this.scenario.isReady;
        this.scenario = this.loadedScenario;
        this.scenario.isReady = this.isReady;
      } else {
        this.scenario = this.loadedScenario;
      }

      if (this.scenario.parameters.questionFirstGenerationState) {
        this.tmp.questionFirstGeneratedAudio = this.scenario.parameters.questionFirstAudio;
      } else {
        this.tmp.questionFirstLoadedAudio = this.scenario.parameters.questionFirstAudio;
      }

      if (this.scenario.parameters.questionSecondYesGenerationState) {
        this.tmp.questionSecondYesGeneratedAudio = this.scenario.parameters.questionSecondYesAudio;
      } else {
        this.tmp.questionSecondYesLoadedAudio = this.scenario.parameters.questionSecondYesAudio;
      }

      if (this.scenario.parameters.questionSecondYesYesGenerationState) {
        this.tmp.questionSecondYesYesGeneratedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      } else {
        this.tmp.questionSecondYesYesLoadedAudio = this.scenario.parameters.questionSecondYesYesAudio;
      }

      if (this.scenario.parameters.questionSecondYesNoGenerationState) {
        this.tmp.questionSecondYesNoGeneratedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      } else {
        this.tmp.questionSecondYesNoLoadedAudio = this.scenario.parameters.questionSecondYesNoAudio;
      }

      if (this.scenario.parameters.questionSecondNoGenerationState) {
        this.tmp.questionSecondNoGeneratedAudio = this.scenario.parameters.questionSecondNoAudio;
      } else {
        this.tmp.questionSecondNoLoadedAudio = this.scenario.parameters.questionSecondNoAudio;
      }

      if (this.scenario.parameters.questionSecondNoYesGenerationState) {
        this.tmp.questionSecondNoYesGeneratedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      } else {
        this.tmp.questionSecondNoYesLoadedAudio = this.scenario.parameters.questionSecondNoYesAudio;
      }

      if (this.scenario.parameters.questionSecondNoNoGenerationState) {
        this.tmp.questionSecondNoNoGeneratedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      } else {
        this.tmp.questionSecondNoNoLoadedAudio = this.scenario.parameters.questionSecondNoNoAudio;
      }
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var MessageComponent = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default.a);
var openMessage = function openMessage() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 10000,
    container: '.messages'
  };

  return new MessageComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var api = '/api/scenarios';
var PROFILES_API = '/api/profiles';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_1__Modal___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_message___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_3_vue_bulma_notification___default.a
  },

  data: function data() {
    return {
      scenarios: [],
      sortedScenarios: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'dateCreated',
      currentSortDir: 'desc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      searchName: '',
      scenarioToDelete: null,
      showModal: null,
      title: '',
      isActive: false,
      permissionKey: 'scenario'
    };
  },


  created: function created() {
    this.checkToken();
    this.loadState();
    this.loadData();
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['loggedId', 'authenticationToken']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.scenarios.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: _extends({
    loadData: function loadData() {
      var _this = this;

      this.setLoadedScenario(null);
      this.$http.get(api, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.scenarios = response.data;
        _this.sortedScenarios = _this.sortedScenario();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка сценариев. ');
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapMutations"])(['setLoadedScenario']), {
    sortedScenario: function sortedScenario() {
      var _this2 = this;

      return this.scenarios.filter(this.filterByName).sort(function (a, b) {
        var modifier = 1;
        if (_this2.currentSortDir === 'desc') modifier = -1;
        if (a[_this2.currentSort] < b[_this2.currentSort]) return -1 * modifier;
        if (a[_this2.currentSort] > b[_this2.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this2.currentPage - 1) * _this2.perPage;
        var end = _this2.currentPage * _this2.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedScenarios = this.sortedScenario();
    },

    filterByName: function filterByName(scenario) {
      if (this.searchName.length === 0) {
        return true;
      }
      return scenario.name.toLowerCase().indexOf(this.searchName.toLowerCase()) > -1;
    },
    searchByName: function searchByName() {
      this.sortedScenarios = this.sortedScenario();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    closeModal: function closeModal() {
      this.scenarioToDelete = null;
      this.showModal = false;
    },
    openModal: function openModal(scenario) {
      this.scenarioToDelete = scenario;
      this.title = 'Удалить сценарий?';
      this.showModal = true;
    },
    confirmAction: function confirmAction() {
      if (this.scenarioToDelete) {
        this.removeScenario();
        this.scenarioToDelete = null;
      }
      this.closeModal();
    },
    removeScenario: function removeScenario() {
      var _this3 = this;

      this.$http.delete(api + '/' + this.scenarioToDelete.id, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.openNotificationWithType('info', 'Сценарий удален.');
        _this3.loadData();
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка удаления сценария. ');
      });
    },
    isRemove: function isRemove(index) {
      return this.isDependentCampaign(index);
    },
    isDependentCampaign: function isDependentCampaign(index) {
      return !this.scenarios[index].inUse;
    },
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedScenarios = this.sortedScenario();
    },
    loadState: function loadState() {
      var _this4 = this;

      this.$http({
        url: PROFILES_API + '/activeState/' + this.loggedId,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this4.isActive = response.data;
        if (!_this4.isActive) {
          openMessage({
            message: 'Ваша учетная запись не активна. Создание, редактирование и сохранение сценариев и рассылок невозможно',
            type: 'danger',
            showCloseButton: true
          });
        }
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка получения статуса пользователя. ');
      });
    },
    getDate: function getDate(date) {
      var d = new Date(Number(date));
      var day = d.getUTCDate();
      var month = d.getUTCMonth() + 1;
      var year = d.getUTCFullYear();
      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;
      return day + '.' + month + '.' + year;
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  })
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var APPCONFIG_API = '/api/appConfig';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      appConfig: {},
      appConfigArray: [{
        key: '',
        value: ''
      }],
      activeScenarioTemplatesArray: [{
        key: '',
        value: ''
      }],
      phonePreprocessingParametersArray: [{
        key: '',
        value: ''
      }]
    };
  },

  created: function created() {
    this.checkToken();
    this.loadConfig();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadConfig: function loadConfig() {
      var _this = this;

      this.$http.get(APPCONFIG_API + '/dto', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.appConfig = response.data;
        _this.appConfigArray = Object.entries(_this.appConfig);
        _this.activeScenarioTemplatesArray = [];
        for (var i = 0; i < _this.appConfigArray.length; i++) {
          if (_this.appConfigArray[i][0] === 'activeScenarioTemplates') {
            _this.activeScenarioTemplatesArray = Object.entries(Object.entries(_this.appConfig)[i][1]);
          }
        }
        _this.phonePreprocessingParametersArray = Object.entries(_this.appConfig.defaultPhonePreprocessingStrategyParameters);
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки параметров приложения. ');
      });
    },
    save: function save(showMessage) {
      this.appConfig = {};
      for (var i = 0; i < this.appConfigArray.length; i++) {
        var item = this.appConfigArray[i];
        this.appConfig[item[0]] = item[1];
      }
      this.appConfig.activeScenarioTemplates = {};
      for (var _i = 0; _i < this.activeScenarioTemplatesArray.length; _i++) {
        var _item = this.activeScenarioTemplatesArray[_i];
        this.appConfig.activeScenarioTemplates[_item[0]] = _item[1];
      }
      this.appConfig.defaultPhonePreprocessingStrategyParameters = {};
      for (var _i2 = 0; _i2 < this.phonePreprocessingParametersArray.length; _i2++) {
        var _item2 = this.phonePreprocessingParametersArray[_i2];
        this.appConfig.defaultPhonePreprocessingStrategyParameters[_item2[0]] = _item2[1];
      }
      this.update(showMessage);
    },
    update: function update(showMessage) {
      var _this2 = this;

      console.log('updating app config: ' + JSON.stringify(this.appConfig));
      this.$http.put(APPCONFIG_API, this.appConfig, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (showMessage) {
          _this2.openNotificationWithType('info', 'Параметры приложения сохранены.');
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка сохранения параметров приложения. ');
      });
    },
    canEdit: function canEdit() {
      return true;
    },
    cancel: function cancel() {
      this.$router.push('/campaigns');
    },
    deletePhonePreprocessingParameter: function deletePhonePreprocessingParameter(index) {
      this.phonePreprocessingParametersArray.splice(index, 1);
    },
    addPhonePreprocessingParameter: function addPhonePreprocessingParameter() {
      this.phonePreprocessingParametersArray.push({});
    },
    openNotificationWithType: function openNotificationWithType(type, message, duration) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type,
        duration: duration
      });
    }
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_5__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var AUTH_API = '/api/auth';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__["b" /* TabPane */]
  },
  data: function data() {
    return {
      permissionKey: 'permission',
      permissionMapByRole: {
        SuperAdministrator: [],
        Administrator: [],
        Partner: [],
        Referrer: [],
        Client: []
      }
    };
  },

  created: function created() {
    this.checkToken();
    this.handlePermissions();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedUser', 'loggedId'])),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    save: function save() {
      var _this = this;

      this.$http.post(AUTH_API + '/setPermissions', this.permissionMapByRole, { headers: this.prepareSecurityHeader() }).then(function (response) {}).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка сохранения пользовательских разрешений');
      });
    },
    handlePermissions: function handlePermissions() {
      console.log('loading permissions');
      this.loadPermissions('SuperAdministrator');
      this.loadPermissions('Administrator');
      this.loadPermissions('Partner');
      this.loadPermissions('Referrer');
      this.loadPermissions('Client');
    },
    loadPermissions: function loadPermissions(role) {
      var _this2 = this;

      this.$http.get(AUTH_API + '/getPermissions/' + role, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this2.permissionMapByRole[role] = [];
        var arrPermissions = JSON.parse(JSON.stringify(Object.entries(response.data)));
        for (var i = 0, len = arrPermissions.length; i < len; i++) {
          var permission = [];
          permission.push(arrPermissions[i][0]);
          permission.push((arrPermissions[i][1] & 1) === 1);
          permission.push((arrPermissions[i][1] & 2) === 2);
          permission.push((arrPermissions[i][1] & 4) === 4);
          permission.push((arrPermissions[i][1] & 8) === 8);
          permission.push((arrPermissions[i][1] & 16) === 16);
          permission.push((arrPermissions[i][1] & 32) === 32);
          permission.push((arrPermissions[i][1] & 64) === 64);
          _this2.permissionMapByRole[role].push(permission);
        }
      }).catch(function (error) {
        console.log(error);
        _this2.openNotificationWithType('danger', 'Ошибка загрузки пользовательских разрешений. ');
      });
    },
    setDefaultPermissions: function setDefaultPermissions() {
      var _this3 = this;

      this.$http.post(AUTH_API + '/setDefaultPermissions', { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this3.handlePermissions();
        _this3.openNotificationWithType('warning', 'Установлены значения по умолчанию');
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка загрузки разрешений "По умолчанию". ');
      });
    },
    cancel: function cancel() {
      this.$router.push('/campaigns');
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cleave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_datepicker__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_bulma_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_bulma_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_6__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_7__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var USERS_API = '/api/users';
var BILLING_API = '/api/billing';
var PROFILES_API = '/api/profiles';
var PAYMENTS_API = '/api/payments';
var CLIENTS_API = '/api/clients';

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  components: {
    Cleave: __WEBPACK_IMPORTED_MODULE_3_vue_cleave___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vue_bulma_datepicker___default.a,
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a,
    Tabs: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__["a" /* Tabs */],
    TabPane: __WEBPACK_IMPORTED_MODULE_4_vue_bulma_tabs__["b" /* TabPane */]
  },
  data: function data() {
    return {
      user: {},
      profile: {},
      clients: {},
      userid: 0,
      billings: [],
      sortedBillings: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'date',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      newbilling: {},
      balance: 0,
      sumPay: 0,
      sumConsume: 0,
      sumPayment: 0,
      permissionKey: 'user',
      regSum: /^[-]?[0-9]+[.]?[0-9]{0,2}$/,
      regEmail: /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6}$/
    };
  },

  created: function created() {
    console.log('role ' + this.loggedRole);
    this.checkToken();
    this.loadClients();
    this.handleUser();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedUser', 'loggedRole', 'loggedId']), {
    l10n: function l10n() {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
          longhand: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
        },
        months: {
          shorthand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        }
      };
    },
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.billings.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),
  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      };
    },
    save: function save() {
      if (this.user.id === undefined) {
        this.saveNew();
      } else {
        this.update();
      }
    },
    saveNew: function saveNew() {
      var _this = this;

      if (this.user.username != '') {
        if (this.regEmail.test(this.user.username)) {
          console.log('saving new user: ' + JSON.stringify(this.user));
          this.$http.post(USERS_API, this.user, { headers: this.prepareSecurityHeader() }).then(function (response) {
            if (response.data != '') {
              _this.user = response.data;
              _this.openNotificationWithType('info', 'Логин и пароль сохранены.');
              // this.$router.push('/users/')
              _this.loadProfile();
              _this.loadBilling();
            } else {
              console.log('Already exist');
              _this.openNotificationWithType('danger', 'Такой пользователь уже существует');
            }
          }).catch(function (error) {
            console.log(error);
            _this.openNotificationWithType('danger', 'Ошибка регистрации пользователя');
          });
        } else {
          this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты');
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты');
      }
    },
    update: function update() {
      var _this2 = this;

      if (this.user.username != '') {
        if (this.regEmail.test(this.user.username)) {
          console.log('updating user: ' + JSON.stringify(this.user));
          this.$http.put(USERS_API, this.user, { headers: this.prepareSecurityHeader() }).then(function (response) {
            console.log(response.data);
            _this2.openNotificationWithType('info', 'Логин и пароль сохранены.');
            // this.$router.push('/users/')
          }).catch(function (error) {
            console.log(error);
            _this2.openNotificationWithType('danger', 'Ошибка регистрации пользователя');
          });
        } else {
          this.openNotificationWithType('danger', 'Необходимо ввести корректный адрес электронной почты');
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо ввести адрес электронной почты');
      }
    },
    saveProfile: function saveProfile() {
      if (this.user.id) {
        if (this.profile.id === undefined) {
          this.saveNewProfile();
        } else {
          this.updateProfile();
        }
      } else {
        this.openNotificationWithType('danger', 'Сначала необходимо сохранить логин и пароль');
      }
    },
    saveNewProfile: function saveNewProfile() {
      var _this3 = this;

      //      if (this.user.username != '') {
      //        if (this.reg.test(this.user.username)) {
      console.log('saving new profile: ' + JSON.stringify(this.profile));
      this.$http.post(PROFILES_API, this.profile, { headers: this.prepareSecurityHeader() }).then(function (response) {
        if (response.data != '') {
          console.log(response.data);
          _this3.isSaved = true;
          _this3.profile = response.data;
          _this3.openNotificationWithType('info', 'Профиль пользователя сохранен.');
          //                this.$router.push('/users/')
        } else {
          console.log('Already exist');
          _this3.openNotificationWithType('danger', 'Такой профиль уже существует.');
        }
      }).catch(function (error) {
        console.log(error);
        _this3.openNotificationWithType('danger', 'Ошибка сохранения данных');
      });
      //        } else {
      //          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
      //        }
      //      } else {
      //        errorMessage = 'Необходимо ввести адрес электронной почты'
      //      }
    },
    updateProfile: function updateProfile() {
      var _this4 = this;

      //      if (this.user.username != '') {
      //        if (this.reg.test(this.user.username)) {
      console.log('updating profile: ' + JSON.stringify(this.profile));
      this.$http.put(PROFILES_API, this.profile, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this4.isSaved = true;
        console.log(response.data);
        _this4.openNotificationWithType('info', 'Профиль пользователя сохранен.');
        //              this.$router.push('/users/')
      }).catch(function (error) {
        console.log(error);
        _this4.openNotificationWithType('danger', 'Ошибка сохранения данных');
      });
      //        } else {
      //          errorMessage = 'Необходимо ввести корректный адрес электронной почты'
      //        }
      //      } else {
      //        errorMessage = 'Необходимо ввести адрес электронной почты'
      //      }
    },
    loadClients: function loadClients() {
      var _this5 = this;

      this.$http.get(CLIENTS_API + '/getClients/' + this.loggedId, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this5.clients = response.data;
      }).catch(function (error) {
        console.log(error);
        _this5.openNotificationWithType('danger', 'Ошибка загрузки клиентов пользователя. ');
      });
    },
    handleUser: function handleUser() {
      if (this.$props.id != 'new' && this.$props.id) {
        console.log('loading user: ' + this.name);
        this.loadUser();
      } else {
        console.log('creating new user');
        return {};
      }
    },
    loadUser: function loadUser() {
      var _this6 = this;

      this.$http({
        url: USERS_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this6.userid = response.data.id;
        _this6.user = response.data;
        // this.getBalance()
        _this6.handleProfile();
      }).catch(function (error) {
        console.log(error);
        _this6.openNotificationWithType('danger', 'Ошибка загрузки пользователя. ');
      });
    },
    loadBilling: function loadBilling() {
      var _this7 = this;

      this.$http({
        url: BILLING_API + '/' + this.profile.client,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        console.log('opening campaign ' + response.data.id);
        _this7.billings = response.data;
        _this7.sortedBillings = _this7.sortedBilling();
      }).catch(function (error) {
        console.log(error);
        _this7.openNotificationWithType('danger', 'Ошибка загрузки биллинга. ');
      });
    },
    cancel: function cancel() {
      this.$router.push('/users/');
    },
    handleProfile: function handleProfile() {
      if (this.$props.id) {
        console.log('loading profile: ' + this.profile.username);
        this.loadProfile();
      } else {
        console.log('creating new profile');
        this.notSaved();
        return {};
      }
    },
    loadProfile: function loadProfile() {
      var _this8 = this;

      this.$http({
        url: PROFILES_API + '/' + this.user.id,
        headers: this.prepareSecurityHeader()
      }).then(function (response) {
        _this8.profile = response.data;
        _this8.isSaved = true;
        _this8.handleBilling();
      }).catch(function (error) {
        console.log(error);
        _this8.openNotificationWithType('danger', 'Ошибка загрузки профиля пользователя. ');
      });
    },
    handleBilling: function handleBilling() {
      if (!this.$props.id) {
        // this.$router.push('/users')
      } else {
        console.log('loading billing: ' + this.name);
        this.loadBilling();
        this.getBalance();
        this.getSumPayment();
        this.getSumConsume();
      }
    },
    uploadContract: function uploadContract(inputId) {
      if (this.user.id) {
        var input = document.querySelector('#' + inputId);
        if (input.files && input.files[0]) {
          if (!this.isSaved) {
            this.openNotificationWithType('danger', 'Перед загрузкой файла необходимо сохранить профиль');
          } else {
            if (input.files[0].size > 10 * 1024 * 1024) {
              this.openNotificationWithType('danger', 'Слишком большой файл (> 10 Мб)');
            } else {
              this.handleUploadContractRequest(input.files[0]);
            }
          }
        }
      } else {
        this.openNotificationWithType('danger', 'Сначала необходимо сохранить логин и пароль');
      }
    },
    handleUploadContractRequest: function handleUploadContractRequest(contractFile) {
      var _this9 = this;

      this.$http.post(PROFILES_API + '/' + 'loadContract', this.prepareMultipartFile(contractFile, this.user.id), this.prepareSecurityHeader()).then(function (response) {
        console.log(response);
        if (response.status == 200) {
          _this9.openNotificationWithType('info', 'Файл загружен.');
          // this.loadTasksCount()
          _this9.loadProfile();
        } else {
          _this9.openNotificationWithType('danger', 'Ошибка загрузки файла');
          // this.loadTasksCount()
        }
      }).catch(function (error) {
        _this9.openNotificationWithType('danger', 'Ошибка загрузки файла');
        // this.loadTasksCount()
        console.log(error);
      });
      // this.loadTasksCountPerformed()
    },
    prepareMultipartFile: function prepareMultipartFile(contractFile, userId) {
      var contractFormData = new FormData();
      contractFormData.append('file', contractFile);
      contractFormData.append('id', userId);
      return contractFormData;
    },
    addPayment: function addPayment() {
      var _this10 = this;

      if (this.profile.client) {
        if (this.newbilling.date) {
          if (this.regSum.test(this.newbilling.sumPay)) {
            if (this.newbilling.sumPay != 0) {
              this.newbilling.client = this.profile.client;
              this.newbilling.sumConsume = 0;
              this.$http.post(BILLING_API, this.newbilling, { headers: this.prepareSecurityHeader() }).then(function (response) {
                _this10.openNotificationWithType('success', 'Оплата добавлена');
                _this10.billings = response.data;
                _this10.sortedBillings = _this10.sortedBilling();
                _this10.getBalance();
                _this10.getSumPayment();
                _this10.getSumConsume();
                _this10.newbilling.sumPay = '';
              }).catch(function (error) {
                console.log(error);
                _this10.openNotificationWithType('danger', 'Ошибка добавления оплаты пользователя. ');
              });
            } else {
              this.openNotificationWithType('danger', 'Укажите ненулевую сумму');
            }
          } else {
            this.openNotificationWithType('danger', 'Некорректный формат числа');
          }
        } else {
          this.openNotificationWithType('danger', 'Необходимо выбрать дату');
        }
      } else {
        this.openNotificationWithType('danger', 'Сначала необходимо сохранить логин и пароль');
      }
    },
    getBalance: function getBalance() {
      var _this11 = this;

      this.$http.get(BILLING_API + '/balance/' + this.profile.client, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this11.balance = response.data;
      });
    },
    getSumPayment: function getSumPayment() {
      var _this12 = this;

      this.$http.get(BILLING_API + '/sumpayment/' + this.profile.client, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this12.sumPay = response.data;
      });
    },
    getSumConsume: function getSumConsume() {
      var _this13 = this;

      this.$http.get(BILLING_API + '/sumconsume/' + this.profile.client, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this13.sumConsume = response.data;
      });
    },
    makePayment: function makePayment() {
      var _this14 = this;

      if (this.regSum.test(this.sumPayment)) {
        if (this.sumPayment > 0) {
          this.$http.post(PAYMENTS_API + '/yandex', this.preparePaymentParameters(this.loggedId, this.sumPayment), { headers: this.prepareSecurityHeader() }).then(function (response) {
            console.log(response);
            console.log(response.data);
            window.location.href = response.data;
          }).catch(function (error) {
            console.log(error);
            _this14.openNotificationWithType('danger', 'Ошибка платежа. ');
          });
        } else {
          this.openNotificationWithType('danger', 'Укажите сумму больше нуля');
        }
      } else {
        this.openNotificationWithType('danger', 'Некорректный формат числа');
      }
    },
    preparePaymentParameters: function preparePaymentParameters(id, sum) {
      var paymentFormData = new FormData();
      var currentUrl = window.location;
      paymentFormData.append('id', id);
      paymentFormData.append('sum', sum);
      paymentFormData.append('returnUrl', currentUrl);
      return paymentFormData;
    },
    sortedBilling: function sortedBilling() {
      var _this15 = this;

      return this.billings.sort(function (a, b) {
        var modifier = 1;
        if (_this15.currentSortDir === 'desc') modifier = -1;
        if (a[_this15.currentSort] < b[_this15.currentSort]) return -1 * modifier;
        if (a[_this15.currentSort] > b[_this15.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this15.currentPage - 1) * _this15.perPage;
        var end = _this15.currentPage * _this15.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedBillings = this.sortedBilling();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedBillings = this.sortedBilling();
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_3__authentication_CheckToken___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__authentication_CheckPermission___default.a);

var NotificationComponent = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].extend(__WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a);
var openNotification = function openNotification() {
  var propsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4600,
    container: '.notifications'
  };

  return new NotificationComponent({
    el: document.createElement('div'),
    propsData: propsData
  });
};

var USERS_API = '/api/users';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notification: __WEBPACK_IMPORTED_MODULE_2_vue_bulma_notification___default.a
  },
  data: function data() {
    return {
      users: [],
      sortedUsers: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'username',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      dependedUserId: null,
      permissionKey: 'user'
    };
  },

  created: function created() {
    this.checkToken();
    this.loadData();
  },
  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["mapGetters"])(['authenticationToken', 'loggedId']), {
    totalPages: function totalPages() {
      return Math.max(Math.ceil(this.users.length / this.perPage), 1);
    },
    startPage: function startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1);
      }

      return this.currentPage - 1;
    },
    endPage: function endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
    },
    pages: function pages() {
      var range = [];
      for (var i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }
      return range;
    },
    isInFirstPage: function isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage: function isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  }),

  methods: {
    prepareSecurityHeader: function prepareSecurityHeader() {
      console.log(this.authenticationToken);
      return {
        Authorization: 'Bearer ' + this.authenticationToken
      };
    },
    loadApplications: function loadApplications() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$http.get(USERS_API, { headers: this.prepareSecurityHeader() }).then(function (response) {
        _this.users = response.data;
        _this.sortedUsers = _this.sortedUser();
      }).catch(function (error) {
        console.log(error);
        _this.openNotificationWithType('danger', 'Ошибка загрузки списка пользователей. ');
      });
    },
    addUserByIdToMain: function addUserByIdToMain() {
      var _this2 = this;

      if (this.dependedUserId) {
        this.$http.post(USERS_API + '/addToMain', this.prepareRequest(this.dependedUserId), { headers: this.prepareSecurityHeader() }).then(function (response) {
          if (response.status == 200) {
            _this2.openNotificationWithType('success', 'Клиент добавлен');
            _this2.users = _this2.loadData();
            _this2.dependedUserId = null;
          } else {
            _this2.openNotificationWithType('warning', 'Невозможно добавить клиента');
          }
        }).catch(function (error) {
          _this2.openNotificationWithType('danger', 'Ошибка добавления клиента');
          console.log(error);
        });
      } else {
        this.openNotificationWithType('danger', 'Укажите ID клиента');
      }
    },
    prepareRequest: function prepareRequest(userId) {
      var formData = new FormData();
      formData.append('id', userId);
      return formData;
    },
    sortedUser: function sortedUser() {
      var _this3 = this;

      return this.users.sort(function (a, b) {
        var modifier = 1;
        if (_this3.currentSortDir === 'desc') modifier = -1;
        if (a[_this3.currentSort] < b[_this3.currentSort]) return -1 * modifier;
        if (a[_this3.currentSort] > b[_this3.currentSort]) return 1 * modifier;
        return 0;
      }).filter(function (row, index) {
        var start = (_this3.currentPage - 1) * _this3.perPage;
        var end = _this3.currentPage * _this3.perPage;
        if (index >= start && index < end) return true;
      });
    },
    sort: function sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
      this.sortedUsers = this.sortedUser();
    },
    sortIcon: function sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon;
        } else {
          return this.descIcon;
        }
      } else {
        return '';
      }
    },
    onClickFirstPage: function onClickFirstPage() {
      this.onPageChange(1);
    },
    onClickPreviousPage: function onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1);
    },
    onClickPage: function onClickPage(page) {
      this.onPageChange(page);
    },
    onClickNextPage: function onClickNextPage() {
      this.onPageChange(this.currentPage + 1);
    },
    onClickLastPage: function onClickLastPage() {
      this.onPageChange(this.totalPages);
    },
    isPageActive: function isPageActive(page) {
      return this.currentPage === page;
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.sortedUsers = this.sortedUser();
    },
    viewBilling: function viewBilling(id) {
      this.$router.push('/billing/client/' + id);
    },
    viewProfile: function viewProfile(id) {
      this.$router.push('/profiles/' + id);
    },
    openNotificationWithType: function openNotificationWithType(type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      });
    }
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    separator: String
  },

  mounted: function mounted() {
    if (this.separator) {
      this.$el.style.setProperty('--separator', '"' + this.separator + '"');
    }
  },


  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      return item.meta && item.meta.label || item.name;
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//

 // With moment.js

var types = ['line', 'bar', 'radar', 'polarArea', 'pie', 'doughnut', 'bubble', 'scatter'];

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    width: Number,
    height: Number,
    type: {
      type: String,
      required: true,
      validator: function validator(val) {
        return types.includes(val);
      }
    },
    data: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    plugins: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.resetChart();
  },
  data: function data() {
    return {
      chart: null
    };
  },


  methods: {
    resetChart: function resetChart() {
      if (this.chart) this.chart.destroy();

      this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$el, {
        type: this.type,
        data: this.data,
        options: this.options,
        plugins: this.plugins
      });
    }
  },

  watch: {
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        return _this.resetChart();
      });
    },
    data: function data() {
      this.chart.update();
    },
    options: function options() {
      var _this2 = this;

      this.$nextTick(function () {
        return _this2.resetChart();
      });
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    isFullwidth: Boolean,
    accordion: Boolean
  },

  computed: {
    $collapseItems: function $collapseItems() {
      return this.$children.filter(function (child) {
        return child._isCollapseItem;
      });
    }
  },

  methods: {
    openByIndex: function openByIndex(index) {
      if (this.accordion) {
        this.$collapseItems.forEach(function (item, i) {
          if (i !== index) {
            item.isActived = false;
          }
        });
      }
    }
  }

});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    selected: Boolean,
    title: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      isActived: this.selected
    };
  },
  created: function created() {
    this._isCollapseItem = true;
  },
  mounted: function mounted() {
    this.$on('open', this.$parent.openByIndex);
    if (this.isActived) {
      this.$emit('open', this.index);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anime && this.targets) {
      __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.remove(this.targets);
    }
    this.$off('open', this.$parent.openByIndex);
  },


  computed: {
    index: function index() {
      return this.$parent.$collapseItems.indexOf(this);
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.isActived = !this.isActived) {
        this.$emit('open', this.index);
      }
    },
    getAnime: function getAnime(targets) {
      if (this.anime) return this.anime;
      return this.anime = __WEBPACK_IMPORTED_MODULE_0_animejs___default()({ targets: targets });
    },
    cancel: function cancel() {
      this.anime.pause();
    },
    before: function before(targets) {
      if (!this.targets) this.targets = targets;
      targets.removeAttribute('style');
    },
    enter: function enter(targets, done) {
      var height = targets.scrollHeight;
      targets.style.height = 0;
      targets.style.opacity = 0;
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [0, 1],
        height: height,
        complete: function complete() {
          targets.removeAttribute('style');
          done();
        }
      });
    },
    leave: function leave(targets, complete) {
      this.getAnime(targets).play({
        targets: targets,
        duration: 377,
        easing: 'easeOutExpo',
        opacity: [1, 0],
        height: 0,
        complete: complete
      });
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(24);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]]
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(24);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BasicInput__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingleInput__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SingleInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SingleInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WrapperInput__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WrapperInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WrapperInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flatpickr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flatpickr__);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BasicInput__["a" /* default */]],

  props: {
    alignment: String,
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  components: {
    SingleInput: __WEBPACK_IMPORTED_MODULE_1__SingleInput___default.a,
    WrapperInput: __WEBPACK_IMPORTED_MODULE_2__WrapperInput___default.a
  },

  data: function data() {
    return {
      datepicker: null,
      selectedDates: null
    };
  },
  mounted: function mounted() {
    if (!this.datepicker) {
      this.config.onValueUpdate = this.dateUpdated;
      this.datepicker = new __WEBPACK_IMPORTED_MODULE_3_flatpickr___default.a(this.$el, this.config);
      this.setDate(this.value);
    }
    this.$watch('config', this.redraw);
    this.$watch('value', this.setDate);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.datepicker && !this.static) {
      this.datepicker.destroy();
      this.datepicker = null;
    }
  },


  methods: {
    redraw: function redraw(newConfig) {
      this.datepicker.config = Object.assign(this.datepicker.config, newConfig);
      this.datepicker.redraw();
      this.datepicker.jumpToDate();
    },
    setDate: function setDate(newDate, oldDate) {
      newDate && this.datepicker.setDate(newDate);
    },
    dateUpdated: function dateUpdated(selectedDates, dateStr) {
      this.date = dateStr;
    }
  },

  computed: {
    wrap: function wrap() {
      return !!this.config.wrap;
    },
    static: function _static() {
      return !!this.config.static;
    },
    name: function name() {
      return this.wrap ? 'wrapperInput' : 'singleInput';
    },

    date: {
      get: function get() {
        return this.selectedDates || this.value;
      },
      set: function set(newValue) {
        if (this.selectedDates !== newValue) {
          this.selectedDates = newValue;
          this.$emit('input', newValue);
        }
      }
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.classList.remove('collapse');
      el.style.display = 'block';
      el.classList.add('collapsing');
      el.style.height = el.scrollHeight + 'px';
    },
    afterEnter: function afterEnter(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse', 'in');
    },
    beforeLeave: function beforeLeave(el) {
      el.classList.add('collapsing');
      el.classList.remove('collapse', 'in');
      el.style.height = 0;
    },
    afterLeave: function afterLeave(el) {
      el.classList.remove('collapsing');
      el.classList.add('collapse');
      el.style.display = 'none';
    }
  }

});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(226);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    visibilityHeight: {
      type: Number,
      default: 400
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },
  mounted: function mounted() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },


  methods: {
    handleScroll: function handleScroll() {
      this.visible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* getScroll */])(window, true) > this.visibilityHeight;
    },
    scrollToTop: function scrollToTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(document.body, this.options);
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jump_js__ = __webpack_require__(38);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    target: String,
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  created: function created() {
    this.$el = this.$el.nextSibling;
  },
  mounted: function mounted() {
    this.$el.addEventListener('click', this.handler);
  },


  methods: {
    handler: function handler() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jump_js__["a" /* default */])(this.target, this.options);
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Down'
    },
    duration: {
      type: Number,
      default: 1500
    },
    container: {
      type: String,
      default: '.messages'
    },
    showCloseButton: Boolean
  },

  data: function data() {
    return {
      $_parent_: null,
      icons: {
        normal: '',
        primary: 'arrow-circle-right',
        info: 'info-circle',
        success: 'check-circle',
        warning: 'exclamation-circle',
        danger: 'times-circle'
      },
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Messages = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Messages',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Messages().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + (this.direction === 'Up' ? 'Down' : 'Up');
    },
    icon: function icon() {
      return this.icons[this.type];
    }
  },

  methods: {
    close: function close() {
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BaseModal__["a" /* default */]],

  props: {
    title: {
      type: String
    },
    okText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  },

  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BaseModal__["a" /* default */]],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseModal__ = __webpack_require__(18);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__BaseModal__["a" /* default */]],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    type: String,
    title: String,
    message: String,
    direction: {
      type: String,
      default: 'Right'
    },
    duration: {
      type: Number,
      default: 4500
    },
    container: {
      type: String,
      default: '.notifications'
    }
  },

  data: function data() {
    return {
      $_parent_: null,
      show: true
    };
  },
  created: function created() {
    var $parent = this.$parent;
    if (!$parent) {
      var parent = document.querySelector(this.container);
      if (!parent) {
        // Lazy creating `div.notifications` container.
        var className = this.container.replace('.', '');
        var Notifications = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
          name: 'Notifications',
          render: function render(h) {
            return h('div', {
              'class': _defineProperty({}, '' + className, true)
            });
          }
        });
        $parent = new Notifications().$mount();
        document.body.appendChild($parent.$el);
      } else {
        $parent = parent.__vue__;
      }
      // Hacked.
      this.$_parent_ = $parent;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$_parent_) {
      this.$_parent_.$el.appendChild(this.$el);
      this.$parent = this.$_parent_;
      delete this.$_parent_;
    }
    if (this.duration > 0) {
      this.timer = setTimeout(function () {
        return _this.close();
      }, this.duration);
    }
  },
  destroyed: function destroyed() {
    this.$el.remove();
  },


  computed: {
    transition: function transition() {
      return 'bounce-' + this.direction;
    },
    enterClass: function enterClass() {
      return 'bounceIn' + this.direction;
    },
    leaveClass: function leaveClass() {
      return 'bounceOut' + this.direction;
    }
  },

  methods: {
    closedByUser: function closedByUser() {
      this.$emit('closed-by-user');
      clearTimeout(this.timer);
      this.show = false;
    },
    close: function close() {
      this.$emit('closed-automatically');
      clearTimeout(this.timer);
      this.show = false;
    },
    afterLeave: function afterLeave() {
      this.$destroy();
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    },
    value: {
      type: Number,
      default: 0
    },
    type: String,
    name: String,
    size: String,
    isFullwidth: Boolean,
    disabled: Boolean,
    // orientation:
    vertical: Boolean
  },

  data: function data() {
    return {
      realValue: this.value
    };
  },
  beforeMount: function beforeMount() {
    if (this.max < this.min) {
      throw 'Unexpected range setting: Maximum cannot be less than minimum';
    }

    this.update(this.value);
  },
  mounted: function mounted() {
    this.$el.style.setProperty('--low', this.low);
    this.$el.style.setProperty('--high', this.high);
  },


  watch: {
    realValue: function realValue(newVal, oldVal) {
      if (Number(newVal) !== Number(oldVal)) {
        this.$el.style.setProperty('--high', this.high);
        this.$emit('change', newVal);
      }
    },
    value: function value(val) {
      this.update(val);
    }
  },

  methods: {
    update: function update(val) {
      if (val > this.max) {
        this.realValue = this.max;
      } else if (val < this.min) {
        this.realValue = this.min;
      } else {
        this.realValue = val;
      }
    }
  },

  computed: {
    low: function low() {
      return '0%';
    },
    high: function high() {
      return (this.realValue - this.min) / (this.max - this.min) * 100 + '%';
    },
    classObject: function classObject() {
      var _ref;

      var type = this.type,
          size = this.size,
          isFullwidth = this.isFullwidth;

      return _ref = {
        slider: true
      }, _defineProperty(_ref, 'is-' + type, type), _defineProperty(_ref, 'is-' + size, size), _defineProperty(_ref, 'is-fullwidth', isFullwidth), _ref;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    alignment: {
      type: String,
      default: ''
    }
  },

  computed: {
    classObject: function classObject() {
      var alignment = this.alignment;

      return _defineProperty({
        'tab-list': true,
        'is-flex': true
      }, 'is-' + alignment, alignment);
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var TS = {
  'fade': {
    enterClass: 'fadeIn',
    leaveClass: 'fadeOut'
  },
  'fade-horizontal-rtl': {
    enterClass: 'fadeInRight',
    leaveClass: 'fadeOutLeft'
  },
  'fade-horizontal-ltr': {
    enterClass: 'fadeInLeft',
    leaveClass: 'fadeOutRight'
  },
  'slide-horizontal-rtl': {
    enterClass: 'slideInRight',
    leaveClass: 'slideOutLeft'
  },
  'slide-horizontal-ltr': {
    enterClass: 'slideInLeft',
    leaveClass: 'slideOutRight'
  },
  'fade-vertical-dtu': {
    enterClass: 'fadeInUp',
    leaveClass: 'fadeOutUp'
  },
  'fade-vertical-utd': {
    enterClass: 'fadeInDown',
    leaveClass: 'fadeOutDown'
  },
  'slide-vertical-dtu': {
    enterClass: 'slideInUp',
    leaveClass: 'slideOutUp'
  },
  'slide-vertical-utd': {
    enterClass: 'slideInDown',
    leaveClass: 'slideOutDown'
  }
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    icon: String,
    selected: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      default: 'out-in'
    }
  },

  data: function data() {
    return {
      realSelected: this.selected,
      transition: TS['fade']
    };
  },
  created: function created() {
    this.$parent.tabPanes.push(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.$parent.tabPanes.splice(this.index, 1);
  },


  computed: {
    classObject: function classObject() {
      var realSelected = this.realSelected;

      return {
        'tab-pane': true,
        'animated': true,
        'is-active': realSelected,
        'is-deactive': !realSelected
      };
    },
    layout: function layout() {
      return this.$parent.layout;
    },
    direction: function direction() {
      if (this.layout === 'top' || this.layout === 'bottom') {
        return 'horizontal';
      } else if (this.layout === 'left' || this.layout === 'right') {
        return 'vertical';
      }
      return '';
    },
    animation: function animation() {
      return this.$parent.animation;
    },
    onlyFade: function onlyFade() {
      return this.$parent.onlyFade;
    },
    gte: function gte() {
      if (this.direction === 'vertical') {
        return 'utd';
      } else if (this.direction === 'horizontal') {
        return 'ltr';
      }
      return '';
    },
    lt: function lt() {
      if (this.direction === 'vertical') {
        return 'dtu';
      } else if (this.direction === 'horizontal') {
        return 'rtl';
      }
      return '';
    },
    hidden: function hidden() {
      return this.realSelected ? 'false' : 'true';
    },
    index: function index() {
      return this.$parent.tabPanes.indexOf(this);
    }
  },

  watch: {
    '$parent.realSelectedIndex': function $parentRealSelectedIndex(index, prevIndex) {
      if (!this.onlyFade) {
        var transition = void 0;
        if (prevIndex === -1 || prevIndex > index) {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.gte ? '-' + this.gte : '');
        } else {
          transition = '' + this.animation + (this.layout ? '-' + this.direction : '') + (this.lt ? '-' + this.lt : '');
        }
        this.transition = TS[transition] || TS['fade'];
      }
      this.realSelected = this.index === index;
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TabList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TabList: __WEBPACK_IMPORTED_MODULE_0__TabList___default.a
  },

  props: {
    isFullwidth: Boolean,
    layout: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'bottom', 'left', 'right'].indexOf(val) > -1;
      }
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    alignment: {
      type: String,
      default: ''
    },
    selectedIndex: {
      type: Number,
      default: -1
    },
    animation: {
      type: String,
      default: 'fade'
    },
    onlyFade: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      realSelectedIndex: this.selectedIndex,
      tabPanes: []
    };
  },
  mounted: function mounted() {
    this.update();
    if (this.realSelectedIndex === -1) {
      this.select(0);
    }
  },


  methods: {
    update: function update() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.tabPanes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tabPane = _step.value;

          if (!tabPane.disabled && tabPane.realSelected) {
            this.select(tabPane.index);
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isActived: function isActived(index) {
      return index === this.realSelectedIndex;
    },
    select: function select(index) {
      this.$emit('tab-selected', index);
      this.realSelectedIndex = index;
    }
  },
  watch: {
    selectedIndex: function selectedIndex(newIndex) {
      this.select(newIndex);
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cleave_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cleave_js__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      cleave: null
    };
  },


  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  },

  mounted: function mounted() {
    this.cleave = new __WEBPACK_IMPORTED_MODULE_0_cleave_js___default.a(this.$el, this.options);
  },
  beforeDestroy: function beforeDestroy() {
    this.cleave.destroy();
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 39,
	"./af.js": 39,
	"./ar": 46,
	"./ar-dz": 40,
	"./ar-dz.js": 40,
	"./ar-kw": 41,
	"./ar-kw.js": 41,
	"./ar-ly": 42,
	"./ar-ly.js": 42,
	"./ar-ma": 43,
	"./ar-ma.js": 43,
	"./ar-sa": 44,
	"./ar-sa.js": 44,
	"./ar-tn": 45,
	"./ar-tn.js": 45,
	"./ar.js": 46,
	"./az": 47,
	"./az.js": 47,
	"./be": 48,
	"./be.js": 48,
	"./bg": 49,
	"./bg.js": 49,
	"./bm": 50,
	"./bm.js": 50,
	"./bn": 51,
	"./bn.js": 51,
	"./bo": 52,
	"./bo.js": 52,
	"./br": 53,
	"./br.js": 53,
	"./bs": 54,
	"./bs.js": 54,
	"./ca": 55,
	"./ca.js": 55,
	"./cs": 56,
	"./cs.js": 56,
	"./cv": 57,
	"./cv.js": 57,
	"./cy": 58,
	"./cy.js": 58,
	"./da": 59,
	"./da.js": 59,
	"./de": 62,
	"./de-at": 60,
	"./de-at.js": 60,
	"./de-ch": 61,
	"./de-ch.js": 61,
	"./de.js": 62,
	"./dv": 63,
	"./dv.js": 63,
	"./el": 64,
	"./el.js": 64,
	"./en-SG": 65,
	"./en-SG.js": 65,
	"./en-au": 66,
	"./en-au.js": 66,
	"./en-ca": 67,
	"./en-ca.js": 67,
	"./en-gb": 68,
	"./en-gb.js": 68,
	"./en-ie": 69,
	"./en-ie.js": 69,
	"./en-il": 70,
	"./en-il.js": 70,
	"./en-nz": 71,
	"./en-nz.js": 71,
	"./eo": 72,
	"./eo.js": 72,
	"./es": 75,
	"./es-do": 73,
	"./es-do.js": 73,
	"./es-us": 74,
	"./es-us.js": 74,
	"./es.js": 75,
	"./et": 76,
	"./et.js": 76,
	"./eu": 77,
	"./eu.js": 77,
	"./fa": 78,
	"./fa.js": 78,
	"./fi": 79,
	"./fi.js": 79,
	"./fo": 80,
	"./fo.js": 80,
	"./fr": 83,
	"./fr-ca": 81,
	"./fr-ca.js": 81,
	"./fr-ch": 82,
	"./fr-ch.js": 82,
	"./fr.js": 83,
	"./fy": 84,
	"./fy.js": 84,
	"./ga": 85,
	"./ga.js": 85,
	"./gd": 86,
	"./gd.js": 86,
	"./gl": 87,
	"./gl.js": 87,
	"./gom-latn": 88,
	"./gom-latn.js": 88,
	"./gu": 89,
	"./gu.js": 89,
	"./he": 90,
	"./he.js": 90,
	"./hi": 91,
	"./hi.js": 91,
	"./hr": 92,
	"./hr.js": 92,
	"./hu": 93,
	"./hu.js": 93,
	"./hy-am": 94,
	"./hy-am.js": 94,
	"./id": 95,
	"./id.js": 95,
	"./is": 96,
	"./is.js": 96,
	"./it": 98,
	"./it-ch": 97,
	"./it-ch.js": 97,
	"./it.js": 98,
	"./ja": 99,
	"./ja.js": 99,
	"./jv": 100,
	"./jv.js": 100,
	"./ka": 101,
	"./ka.js": 101,
	"./kk": 102,
	"./kk.js": 102,
	"./km": 103,
	"./km.js": 103,
	"./kn": 104,
	"./kn.js": 104,
	"./ko": 105,
	"./ko.js": 105,
	"./ku": 106,
	"./ku.js": 106,
	"./ky": 107,
	"./ky.js": 107,
	"./lb": 108,
	"./lb.js": 108,
	"./lo": 109,
	"./lo.js": 109,
	"./lt": 110,
	"./lt.js": 110,
	"./lv": 111,
	"./lv.js": 111,
	"./me": 112,
	"./me.js": 112,
	"./mi": 113,
	"./mi.js": 113,
	"./mk": 114,
	"./mk.js": 114,
	"./ml": 115,
	"./ml.js": 115,
	"./mn": 116,
	"./mn.js": 116,
	"./mr": 117,
	"./mr.js": 117,
	"./ms": 119,
	"./ms-my": 118,
	"./ms-my.js": 118,
	"./ms.js": 119,
	"./mt": 120,
	"./mt.js": 120,
	"./my": 121,
	"./my.js": 121,
	"./nb": 122,
	"./nb.js": 122,
	"./ne": 123,
	"./ne.js": 123,
	"./nl": 125,
	"./nl-be": 124,
	"./nl-be.js": 124,
	"./nl.js": 125,
	"./nn": 126,
	"./nn.js": 126,
	"./pa-in": 127,
	"./pa-in.js": 127,
	"./pl": 128,
	"./pl.js": 128,
	"./pt": 130,
	"./pt-br": 129,
	"./pt-br.js": 129,
	"./pt.js": 130,
	"./ro": 131,
	"./ro.js": 131,
	"./ru": 132,
	"./ru.js": 132,
	"./sd": 133,
	"./sd.js": 133,
	"./se": 134,
	"./se.js": 134,
	"./si": 135,
	"./si.js": 135,
	"./sk": 136,
	"./sk.js": 136,
	"./sl": 137,
	"./sl.js": 137,
	"./sq": 138,
	"./sq.js": 138,
	"./sr": 140,
	"./sr-cyrl": 139,
	"./sr-cyrl.js": 139,
	"./sr.js": 140,
	"./ss": 141,
	"./ss.js": 141,
	"./sv": 142,
	"./sv.js": 142,
	"./sw": 143,
	"./sw.js": 143,
	"./ta": 144,
	"./ta.js": 144,
	"./te": 145,
	"./te.js": 145,
	"./tet": 146,
	"./tet.js": 146,
	"./tg": 147,
	"./tg.js": 147,
	"./th": 148,
	"./th.js": 148,
	"./tl-ph": 149,
	"./tl-ph.js": 149,
	"./tlh": 150,
	"./tlh.js": 150,
	"./tr": 151,
	"./tr.js": 151,
	"./tzl": 152,
	"./tzl.js": 152,
	"./tzm": 154,
	"./tzm-latn": 153,
	"./tzm-latn.js": 153,
	"./tzm.js": 154,
	"./ug-cn": 155,
	"./ug-cn.js": 155,
	"./uk": 156,
	"./uk.js": 156,
	"./ur": 157,
	"./ur.js": 157,
	"./uz": 159,
	"./uz-latn": 158,
	"./uz-latn.js": 158,
	"./uz.js": 159,
	"./vi": 160,
	"./vi.js": 160,
	"./x-pseudo": 161,
	"./x-pseudo.js": 161,
	"./yo": 162,
	"./yo.js": 162,
	"./zh-cn": 163,
	"./zh-cn.js": 163,
	"./zh-hk": 164,
	"./zh-hk.js": 164,
	"./zh-tw": 165,
	"./zh-tw.js": 165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 391;

/***/ }),
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(429),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(381)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(370)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(372)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(378)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(461),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(437),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(369)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(422),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(374)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(456),
  /* scopeId */
  "data-v-66188c51",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(373)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(470),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(426),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(418),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(366)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(376)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(458),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas', {
    staticClass: "chartjs",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  })
},staticRenderFns: []}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionText),
      expression: "scenario.parameters.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionId', 'questionAudio', 'currentSpeakerQuestion', 'generatedQuestionAudio', 'questionText', 'questionLoading', 'question', 'currentEmotionQuestion', 'currentSpeedQuestion')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n          Сгенерировать аудио\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerQuestion),
      expression: "tmp.currentSpeakerQuestion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerQuestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n              " + _vm._s(speaker.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionQuestion),
      expression: "tmp.currentEmotionQuestion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionQuestion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n              " + _vm._s(emotion.value) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedQuestion,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedQuestion = $event
      }
    }
  }), _vm._v("\n          Скорость: " + _vm._s(_vm.tmp.currentSpeedQuestion) + "\n        ")], 1), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio', {
    ref: 'questionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('loadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('loadAudio', 'questionId', 'questionAudio', 'loadedQuestionAudio', 'question', 'questionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionId', 'questionAudio', 'loadedQuestionAudio', 'question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio', {
    ref: "questionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n          Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionId', 'questionAudio', 'loadedQuestionAudio', 'generatedQuestionAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Заключение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionGenerationState),
      expression: "scenario.parameters.conclusionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.conclusionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "conclusionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('conclusionGenerationState', 'conclusionAudio', 'generatedConclusionAudio', 'loadedConclusionAudio', 'conclusionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionGenerationState),
      expression: "scenario.parameters.conclusionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.conclusionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "conclusionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('conclusionGenerationState', 'conclusionAudio', 'generatedConclusionAudio', 'loadedConclusionAudio', 'conclusionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.conclusionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.conclusionText),
      expression: "scenario.parameters.conclusionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.conclusionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "conclusionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('conclusionId', 'conclusionAudio', 'currentSpeakerConclusion', 'generatedConclusionAudio', 'conclusionText', 'conclusionLoading', 'conclusion', 'currentEmotionConclusion', 'currentSpeedConclusion')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.conclusionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n        Сгенерировать аудио\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerConclusion),
      expression: "tmp.currentSpeakerConclusion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerConclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n            " + _vm._s(speaker.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionConclusion),
      expression: "tmp.currentEmotionConclusion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionConclusion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n            " + _vm._s(emotion.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedConclusion,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedConclusion = $event
      }
    }
  }), _vm._v("\n        Скорость: " + _vm._s(_vm.tmp.currentSpeedConclusion) + "\n      ")], 1), _vm._v(" "), (_vm.tmp.generatedConclusionAudio) ? _c('audio', {
    ref: 'conclusionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.conclusionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedConclusionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.conclusionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.conclusionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('conclusionLoadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "conclusionLoadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('conclusionLoadAudio', 'conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'conclusion', 'conclusionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'conclusion')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedConclusionAudio) ? _c('audio', {
    ref: "conclusionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.conclusionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedConclusionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.conclusionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (this.scenario.parameters.conclusionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('conclusionId', 'conclusionAudio', 'loadedConclusionAudio', 'generatedConclusionAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n        Шаблон сценария\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentScenario),
      expression: "currentScenario"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loadedScenario !== null
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentScenario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.activeSelectList), function(scenario) {
    return _c('option', [_vm._v("\n            " + _vm._s(scenario.name) + "\n          ")])
  }), 0)]), _vm._v(" "), (_vm.currentScenario === _vm.selectList[0].name) ? _c('scenario-question-recognition', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[1].name) ? _c('scenario-question-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[2].name) ? _c('scenario-two-level-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[3].name) ? _c('scenario-notice', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[4].name) ? _c('scenario-question-interview', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "control has-addons flatpickr",
    class: ( _obj = {}, _obj[("has-addons-" + _vm.alignment)] = _vm.alignment, _obj ),
    attrs: {
      "data-wrap": "true",
      "data-clickOpens": "false"
    }
  }, [_c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "data-input": ""
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "player"
  }, [_c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "my_iframe"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "player-controls"
  }, [_c('div', [_c('a', {
    attrs: {
      "title": "Стоп",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stop($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808C15.554,4,16,4.446,16,4.995z"
    }
  })])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "title": "Воспроизведение/Пауза",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.playing = !_vm.playing
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [(!_vm.playing) ? _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"
    }
  }) : _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "player-progress",
    attrs: {
      "title": "Воспроизведено : Всего"
    },
    on: {
      "click": _vm.seek
    }
  }, [_c('div', {
    staticClass: "player-seeker",
    style: ({
      width: this.percentComplete + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "player-time"
  }, [_c('div', {
    staticClass: "player-time-current"
  }, [_vm._v(_vm._s(_vm.currentTime))]), _vm._v(" "), _c('div', {
    staticClass: "player-time-total"
  }, [_vm._v(_vm._s(_vm.durationTime))])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "title": "Загрузка файла",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.download($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"
    }
  })])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "title": "Приглушение",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.mute($event)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [(!_vm.muted) ? _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"
    }
  }) : _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"
    }
  })])])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "title": "Громкость",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      },
      "mouseenter": function($event) {
        _vm.showVolume = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "18px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy.number",
      value: (_vm.volume),
      expression: "volume",
      modifiers: {
        "lazy": true,
        "number": true
      }
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.showVolume),
      expression: "showVolume"
    }],
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.volume)
    },
    on: {
      "change": function($event) {
        _vm.volume = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('audio', {
    ref: "audiofile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.file,
      "preload": "auto"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "message-box animated"
  }, [_c('article', {
    class: ['message', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('div', {
    staticClass: "message-header"
  }, [(_vm.showCloseButton) ? _c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    class: ['fa', ("fa-" + _vm.icon)]
  })]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), (_vm.message) ? _c('div', {
    staticClass: "message-body"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("по рассылке " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Номер телефона " + _vm._s(_vm.callTask.phone))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "control"
  }, [_vm._v("\n          Состояние  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskState),
      expression: "callTaskState"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskState)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskState = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    attrs: {
      "title": "Результаты",
      "selected": ""
    }
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Параметр")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.results), function(res) {
    return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(res[0]) + "\n                ")]), _vm._v(" "), (res[0] == 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDateTime(res[1])) + "\n                ")]) : _vm._e(), _vm._v(" "), (res[0] != 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(res[1]) + "\n                ")]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": "Информация"
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("\n              Тег  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.tag),
      expression: "callTask.tag"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "tag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              failComment  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.failComment),
      expression: "callTask.failComment"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.failComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "failComment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              calledTimestamp  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.calledTimestamp),
      expression: "callTask.calledTimestamp"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.calledTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "calledTimestamp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              talkMillis  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.talkMillis),
      expression: "callTask.talkMillis"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.talkMillis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "talkMillis", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              nextAttemptTimestamp  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.nextAttemptTimestamp),
      expression: "callTask.nextAttemptTimestamp"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.nextAttemptTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "nextAttemptTimestamp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              parameters  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskParameters),
      expression: "callTaskParameters"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskParameters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskParameters = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              reportParameters  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskReportParameters),
      expression: "callTaskReportParameters"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskReportParameters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskReportParameters = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              created  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.created),
      expression: "callTask.created"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.created)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "created", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.deactive
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.client.username))]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('date')
      }
    }
  }, [_vm._v("Дата" + _vm._s(_vm.sortIcon('date')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumPay')
      }
    }
  }, [_vm._v("Сумма пополнено" + _vm._s(_vm.sortIcon('sumPay')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumConsume')
      }
    }
  }, [_vm._v("Сумма израсходовано" + _vm._s(_vm.sortIcon('sumConsume')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('author')
      }
    }
  }, [_vm._v("Автор" + _vm._s(_vm.sortIcon('author')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.sortedBillings), function(billing) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(billing.date) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(billing.sumPay) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(billing.sumConsume) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(billing.author) + "\n            ")]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), (_vm.canCreate(_vm.permissionKey)) ? _c('tr', [_c('td', [_c('datepicker', {
    attrs: {
      "placeholder": "Введите дату",
      "inputClass": {
        test: true
      },
      "config": {
        wrap: true,
        dateFormat: 'd.m.Y',
        locale: _vm.l10n
      },
      "readonly": ""
    },
    model: {
      value: (_vm.newbilling.date),
      callback: function($$v) {
        _vm.$set(_vm.newbilling, "date", $$v)
      },
      expression: "newbilling.date"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "data-clear": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])], 1), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbilling.sumPay),
      expression: "newbilling.sumPay"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты"
    },
    domProps: {
      "value": (_vm.newbilling.sumPay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newbilling, "sumPay", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _c('td', [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.addPayment
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Добавить оплату")])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ИТОГО")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.sumPay))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.sumConsume))]), _vm._v(" "), _c('th', [_vm._v("ОСТАТОК")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.balance))])])], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loggedId == _vm.$props.id) ? _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Оплатить на сумму")])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumPayment),
      expression: "sumPayment"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты"
    },
    domProps: {
      "value": (_vm.sumPayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sumPayment = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.icons[_vm.name])
    }
  })
},staticRenderFns: []}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('navbar', {
    attrs: {
      "show": true
    }
  }), _vm._v(" "), _c('sidebar', {
    attrs: {
      "show": _vm.sidebar.opened && !_vm.sidebar.hidden && _vm.isLogged
    }
  }), _vm._v(" "), _c('app-main'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 1")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstText),
      expression: "scenario.parameters.questionFirstText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionFirstLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerFirst),
      expression: "tmp.currentSpeakerFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionFirst),
      expression: "tmp.currentEmotionFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedFirst,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedFirst = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedFirst) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionFirstLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    ref: "questionFirstLoadedAudio",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionFirstLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('span', {
    staticClass: "second-layer positive-scenario add-button-wrapper"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Опрос (При ответе Да на Вопрос 1)")]), _vm._v(" "), _vm._l((_vm.scenario.parameters.dynamicQuestions), function(parameter, index) {
    return _c('div', {
      key: parameter.key
    }, [(_vm.scenario.parameters.dynamicQuestions.length != index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Вопрос опроса " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.dynamicQuestions.length == index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Заключительное сообщение")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, false)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", false)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, true)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", true)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.text),
        expression: "parameter.text"
      }],
      staticClass: "textarea",
      domProps: {
        "value": (parameter.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control is-grouped"
    }, [_c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.genAudio(index)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoading) ? _c('div', {
      staticClass: "loader spinner"
    }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicSpeaker),
        expression: "tmp.dynamicTmp[index].dynamicSpeaker"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.speakerList), function(speaker) {
      return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicEmotion),
        expression: "tmp.dynamicTmp[index].dynamicEmotion"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.emotionList), function(emotion) {
      return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
      attrs: {
        "size": "small",
        "value": _vm.tmp.dynamicTmp[index].dynamicSpeed,
        "min": 0.1,
        "step": 0.1,
        "max": 3
      },
      on: {
        "change": function($event) {
          _vm.tmp.dynamicTmp[index].dynamicSpeed = $event
        }
      }
    }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.dynamicTmp[index].dynamicSpeed) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }), _c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Загрузить из файла"
      },
      on: {
        "click": function($event) {
          return _vm.clickLoadAudio(parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: ("load-audio-" + (parameter.key)),
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": "load-audio",
        "type": "file",
        "accept": ".wav,.mp3"
      },
      on: {
        "input": function($event) {
          return _vm.loadAudio(index, parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Записать с микрофона"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(index, parameter.key, '', '', false)
        }
      }
    }), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "button-center"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined add-new",
    on: {
      "click": _vm.addNewParameter
    }
  }, [_vm._v("+")])])], 2), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("При ответе Нет на Вопрос 1")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondGenerationState),
      expression: "scenario.parameters.questionSecondGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondGenerationState),
      expression: "scenario.parameters.questionSecondGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondGenerationState', 'questionSecondAudio', 'questionSecondGeneratedAudio', 'questionSecondLoadedAudio', 'onQuestionSecond')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondText),
      expression: "scenario.parameters.questionSecondText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondId', 'questionSecondAudio', 'currentSpeakerSecond', 'questionSecondGeneratedAudio', 'questionSecondText', 'questionSecondLoading', 'Second question', 'currentEmotionSecond', 'currentSpeedSecond')
      }
    }
  }, [_vm._m(6), _vm._v(" "), (_vm.tmp.questionSecondLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecond),
      expression: "tmp.currentSpeakerSecond"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecond", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecond),
      expression: "tmp.currentEmotionSecond"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecond", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecond,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecond = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedSecond) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.questionSecondGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecond'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondLoadedAudio', 'questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', 'onQuestionSecond')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'Second question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecond'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondAudio
    }
  }), _vm._v("\n                    Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondId', 'questionSecondAudio', 'questionSecondLoadedAudio', 'questionSecondGeneratedAudio')
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesText),
      expression: "scenario.parameters.questionSecondYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYes),
      expression: "tmp.currentSpeakerSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYes),
      expression: "tmp.currentEmotionSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])]), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationStateStatic('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoText),
      expression: "scenario.parameters.questionSecondNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNo),
      expression: "tmp.currentSpeakerSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNo),
      expression: "tmp.currentEmotionSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudioStatic('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', true)
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudioStatic('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])])], 1)], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(12), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(13), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainGenerationState),
      expression: "scenario.parameters.mainGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.mainGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainGenerationState),
      expression: "scenario.parameters.mainGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.mainGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('mainGenerationState', 'mainQuestionAudio', 'mainGeneratedAudio', 'mainLoadedAudio', 'mainPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.mainGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.mainQuestionText),
      expression: "scenario.parameters.mainQuestionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.mainQuestionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('mainQuestionId', 'mainQuestionAudio', 'currentSpeakerMain', 'mainGeneratedAudio', 'mainQuestionText', 'mainLoading', 'Main question', 'currentEmotionMain', 'currentSpeedMain')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.mainLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n            Сгенерировать аудио\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerMain),
      expression: "tmp.currentSpeakerMain"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerMain", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                " + _vm._s(speaker.value) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionMain),
      expression: "tmp.currentEmotionMain"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionMain", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                " + _vm._s(emotion.value) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedMain,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedMain = $event
      }
    }
  }), _vm._v("\n            Скорость: " + _vm._s(_vm.tmp.currentSpeedMain) + "\n          ")], 1), _vm._v(" "), (_vm.tmp.mainGeneratedAudio) ? _c('audio', {
    ref: 'mainPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.mainQuestionAudio
    }
  }), _vm._v("\n            Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.mainGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.mainQuestionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.mainGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('mainLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mainLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('mainLoadedAudio', 'mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question', 'mainPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'Main question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.mainLoadedAudio) ? _c('audio', {
    ref: 'mainPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.mainQuestionAudio
    }
  }), _vm._v("\n            Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n          ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.mainLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.mainQuestionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.mainQuestionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('mainQuestionId', 'mainQuestionAudio', 'mainLoadedAudio', 'mainGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer positive-scenario"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение при ответе да")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesGenerationState),
      expression: "scenario.parameters.onYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.onYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesGenerationState),
      expression: "scenario.parameters.onYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.onYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('onYesGenerationState', 'onYesAudio', 'onYesGeneratedAudio', 'onYesLoadedAudio', 'onYesPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), (_vm.scenario.parameters.onYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesText),
      expression: "scenario.parameters.onYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('onYesId', 'onYesAudio', 'currentSpeakerYes', 'onYesGeneratedAudio', 'onYesText', 'onYesLoading', 'Yes question', 'currentEmotionYes', 'currentSpeedYes')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.onYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerYes),
      expression: "tmp.currentSpeakerYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionYes),
      expression: "tmp.currentEmotionYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedYes = $event
      }
    }
  }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.currentSpeedYes) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.onYesGeneratedAudio) ? _c('audio', {
    ref: 'onYesPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onYesAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.onYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('onYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "onYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('onYesLoadedAudio', 'onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question', 'onYesPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'Yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.onYesLoadedAudio) ? _c('audio', {
    ref: 'onYesPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onYesAudio
    }
  }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.onYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('onYesId', 'onYesAudio', 'onYesLoadedAudio', 'onYesGeneratedAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.onYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onYesSMSText),
      expression: "scenario.parameters.onYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onYesSMSText", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('p')], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение при ответе нет")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoGenerationState),
      expression: "scenario.parameters.onNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.onNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoGenerationState),
      expression: "scenario.parameters.onNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.onNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('onNoGenerationState', 'onNoAudio', 'onNoGeneratedAudio', 'onNoLoadedAudio', 'onNoPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.onNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.onNoText),
      expression: "scenario.parameters.onNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.onNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "onNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('onNoId', 'onNoAudio', 'currentSpeakerNo', 'onNoGeneratedAudio', 'onNoText', 'onNoLoading', 'No question', 'currentEmotionNo', 'currentSpeedNo')
      }
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.tmp.onNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerNo),
      expression: "tmp.currentSpeakerNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionNo),
      expression: "tmp.currentEmotionNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedNo = $event
      }
    }
  }), _vm._v("\n              Скорость: " + _vm._s(_vm.tmp.currentSpeedNo) + "\n            ")], 1), _vm._v(" "), (_vm.tmp.onNoGeneratedAudio) ? _c('audio', {
    ref: 'onNoPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onNoAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.onNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('onNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "onNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('onNoLoadedAudio', 'onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question', 'onNoPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'No question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.onNoLoadedAudio) ? _c('audio', {
    ref: 'onNoPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.onNoAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.onNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.onNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.onNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('onNoId', 'onNoAudio', 'onNoLoadedAudio', 'onNoGeneratedAudio')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar animated",
    class: {
      slideInLeft: _vm.show, slideOutLeft: !_vm.show
    }
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    Меню\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', [((_vm.menuRoles[index].role & _vm.getLoggedUserRole()) > 0) ? _c('div', [(item.path) ? _c('router-link', {
      attrs: {
        "to": item.path,
        "exact": true,
        "aria-expanded": _vm.isExpanded(item) ? 'true' : 'false'
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n          " + _vm._s(item.meta.label || item.name) + "\n          "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]) : _c('a', {
      attrs: {
        "aria-expanded": _vm.isExpanded(item)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(index, item)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.meta.icon]
    })]), _vm._v("\n          " + _vm._s(item.meta.label || item.name) + "\n          "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExpanded(item)),
        expression: "isExpanded(item)"
      }]
    }, _vm._l((item.children), function(subItem) {
      return (subItem.path) ? _c('li', [_c('router-link', {
        attrs: {
          "to": _vm.generatePath(item, subItem)
        }
      }, [_vm._v("\n                " + _vm._s(subItem.meta && subItem.meta.label || subItem.name) + "\n              ")])], 1) : _vm._e()
    }), 0)]) : _vm._e()], 1) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/scenarios/0/new",
      "disabled": !_vm.isActive
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать сценарий")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-info is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Поиск")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "change": _vm.searchByName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v("Название" + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('client')
      }
    }
  }, [_vm._v("Клиент" + _vm._s(_vm.sortIcon('client')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('template')
      }
    }
  }, [_vm._v("Шаблон" + _vm._s(_vm.sortIcon('template')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('isReady')
      }
    }
  }, [_vm._v("Готовность" + _vm._s(_vm.sortIcon('isReady')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('dateCreated')
      }
    }
  }, [_vm._v("Дата создания" + _vm._s(_vm.sortIcon('dateCreated')))]), _vm._v(" "), _c('th', [_vm._v("Действие")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedScenarios), function(scenario, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/scenarios/0/' + scenario.id
      }
    }, [_vm._v(_vm._s(scenario.name))])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(scenario.client) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(scenario.template) + "\n                ")]), _vm._v(" "), _c('td', [(scenario.isReady) ? _c('button', {
      staticClass: "button is-success is-outlined",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": true
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
      staticClass: "button is-danger is-outlined",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": true
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDate(scenario.dateCreated)) + "\n                ")]), _vm._v(" "), _c('td', [(_vm.isRemove(index) && _vm.canDelete(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.openModal(scenario, 'delete')
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n                Первая\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n                Предыдущая\n              ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page.name) + "\n              ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n                Следующая\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n                Последняя\n              ")])])], 2)])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
}]}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Match password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.matchPassword),
      expression: "data.matchPassword"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "match password"
    },
    domProps: {
      "value": (_vm.data.matchPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "matchPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Идентификатор партнера/реферера")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.mainUserId),
      expression: "data.body.mainUserId"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Идентификатор"
    },
    domProps: {
      "value": (_vm.data.body.mainUserId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "mainUserId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "data-sitekey": _vm.rcapt_sig_key,
      "id": "g-recaptcha"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canSignUp) ? _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Зарегистрироваться")]) : _vm._e(), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/login"
    }
  }, [_c('span', [_vm._v("Войти")])])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.appConfigArray), function(param, index) {
    return _c('tr', [(param[0] != 'activeScenarioTemplates' && param[0] != 'defaultPhonePreprocessingStrategyParameters') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (param[0] != 'activeScenarioTemplates' && param[0] != 'defaultPhonePreprocessingStrategyParameters') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.phonePreprocessingParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deletePhonePreprocessingParameter(index)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addPhonePreprocessingParameter
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Добавить")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.activeScenarioTemplatesArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canEdit()) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("App Config")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Phone Preprocessing Parameters")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Active Scenario Templates")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scenario Template")]), _vm._v(" "), _c('th', [_vm._v("Activity")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse is-fullwidth"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    class: _vm.classObject,
    attrs: {
      "role": "tablist"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Сообщение")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionGenerationState),
      expression: "scenario.parameters.questionGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionGenerationState', 'questionAudio', 'generatedQuestionAudio', 'loadedQuestionAudio', 'questionPlayer')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionText),
      expression: "scenario.parameters.questionText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionId', 'questionAudio', 'generatedQuestionAudio', 'questionText', 'questionLoading', 'question')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n        Сгенерировать аудио\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentSpeaker),
      expression: "currentSpeaker"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentSpeaker = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n            " + _vm._s(speaker.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentEmotion),
      expression: "currentEmotion"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentEmotion = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n            " + _vm._s(emotion.value) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.currentSpeed,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.currentSpeed = $event
      }
    }
  }), _vm._v("\n        Скорость: " + _vm._s(_vm.currentSpeed) + "\n      ")], 1), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio', {
    ref: 'questionPlayer'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.generatedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('loadAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loadAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('loadAudio', 'questionId', 'questionAudio', 'loadedQuestionAudio', 'question', 'questionPlayer')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionId', 'questionAudio', 'loadedQuestionAudio', 'question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio', {
    ref: "questionPlayer"
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionAudio
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.loadedQuestionAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionId', 'questionAudio', 'loadedQuestionAudio', 'generatedQuestionAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v("Название" + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('client')
      }
    }
  }, [_vm._v("Автор" + _vm._s(_vm.sortIcon('client')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('scenario')
      }
    }
  }, [_vm._v("Сценарий" + _vm._s(_vm.sortIcon('scenario')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('date')
      }
    }
  }, [_vm._v("Прозвон" + _vm._s(_vm.sortIcon('date')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('state')
      }
    }
  }, [_vm._v("Статус" + _vm._s(_vm.sortIcon('state')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('dateCreated')
      }
    }
  }, [_vm._v("Дата создания" + _vm._s(_vm.sortIcon('dateCreated')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumConsume')
      }
    }
  }, [_vm._v("Сумма" + _vm._s(_vm.sortIcon('sumConsume')))]), _vm._v(" "), _c('th', [_vm._v("Отчет")]), _vm._v(" "), _c('th', [_vm._v("Действие")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedCampaigns), function(campaign) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/campaigns/' + campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.client) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.scenario) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.date) + " " + _vm._s(campaign.timeStart) + "-" + _vm._s(campaign.timeEnd) + " " + _vm._s(campaign.zoneOffset) + " UTC\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.state) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.getDate(campaign.dateCreated)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(campaign.sumConsume) + "\n            ")]), _vm._v(" "), _c('td', [(campaign.state == 'Завершена') ? _c('div', {
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "dropdown__header",
      on: {
        "click": function($event) {
          return _vm.toggleDropdown($event)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-down",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-up",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown__content"
    }, [_c('ul', [_c('li', [_c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.getReportCSV(campaign)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v("Отчет в CSV")])])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": '/report/reportByCampaignId.xls?campaignId=' + campaign.id,
        "tag": "button"
      }
    }, [_vm._m(2, true)])])])])]) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
      staticClass: "button is-success",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "href": '#/campaigns/copy/' + campaign.id,
        "disabled": !_vm.isActive
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v("Копировать")])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("Отчеты")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('span', [_vm._v("Отчет в XLS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])
}]}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('audio-recorder', {
    attrs: {
      "attempts": 1,
      "time": 2
    },
    on: {
      "close": _vm.close,
      "confirm": _vm.confirmAction
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Идентификатор пользователя")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.id),
      expression: "profile.id"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": (_vm.profile.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.roleId),
      expression: "profile.roleId"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Администратор")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Партнер")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Реферер")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Клиент")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.state),
      expression: "profile.state"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FILL_PROFILE"
    }
  }, [_vm._v("Заполните личную карточку")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SIGN_CONTRACT"
    }
  }, [_vm._v("Ожидаем подписания договора")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "REFILL_BALANCE"
    }
  }, [_vm._v("Нужно пополнить баланс")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("Активен")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ФИО")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.fullname),
      expression: "profile.fullname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "fullname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Часовой пояс (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.timeZone),
      expression: "profile.timeZone"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "timeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.phone),
      expression: "profile.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ИНН")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.INN),
      expression: "profile.INN"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.INN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "INN", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Паспорт")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.passport),
      expression: "profile.passport"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "passport", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вид деятельности")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.businessType),
      expression: "profile.businessType"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.businessType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "businessType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Менеджер")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.manager),
      expression: "profile.manager"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.manager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "manager", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тариф")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.tariff),
      expression: "profile.tariff"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.tariff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "tariff", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "id": "uploadFile",
      "value": "Загрузить скан договора (pdf, jpg, png; до 10 Мб)",
      "onclick": "document.getElementById('uploadContract').click();"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadContract",
      "name": "load-contract",
      "type": "file",
      "accept": ".jpg,.png,.pdf"
    },
    on: {
      "input": function($event) {
        return _vm.uploadContract('uploadContract')
      }
    }
  }), _vm._v(" "), (_vm.profile.contractName != '') ? _c('a', {
    attrs: {
      "href": '/api/profiles/contract?userId=' + this.$props.id,
      "tag": "button"
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-info"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('span', [_vm._v("Просмотр договора")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "level app-levelbar"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('h3', {
    staticClass: "subtitle is-5"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right is-hidden-mobile"
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.username),
      expression: "data.body.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "email@example.org"
    },
    domProps: {
      "value": (_vm.data.body.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "password"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Войти")]), _vm._v(" "), (_vm.canSignUp) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/sign-up"
    }
  }, [_c('span', [_vm._v("Зарегистрироваться")])]) : _vm._e()])])])])])])
},staticRenderFns: []}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1['is-fullwidth'] =  _vm.isFullwidth, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index), 'is-disabled': tab.disabled, 'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Тестовые звонки по рассылке " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('div', {
    staticClass: "jump-target"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.calltasks), function(calltask) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/callTasksTestResult/' + _vm.$props.id + '/' + calltask.id
      }
    }, [_vm._v(_vm._s(calltask.phone))])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(_vm.getCallTaskState(calltask.state)) + "\n              ")])])
  }), 0)])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "target": ".jump-target"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Наверх")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("Состояние")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.wrap ? 'WrapperInput' : 'SingleInput', {
    tag: "component",
    attrs: {
      "value": _vm.date,
      "placeholder": _vm.placeholder,
      "inputClass": _vm.inputClass,
      "alignment": _vm.alignment
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/campaigns/new",
      "disabled": !_vm.isActive
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать рассылку")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-info is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Поиск")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название рассылки"
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "change": _vm.searchByName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v("Название" + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('client')
      }
    }
  }, [_vm._v("Клиент" + _vm._s(_vm.sortIcon('client')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('scenario')
      }
    }
  }, [_vm._v("Сценарий" + _vm._s(_vm.sortIcon('scenario')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sortingDate')
      }
    }
  }, [_vm._v("Прозвон" + _vm._s(_vm.sortIcon('sortingDate')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('state')
      }
    }
  }, [_vm._v("Статус" + _vm._s(_vm.sortIcon('state')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('dateCreated')
      }
    }
  }, [_vm._v("Дата создания" + _vm._s(_vm.sortIcon('dateCreated')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumConsume')
      }
    }
  }, [_vm._v("Сумма" + _vm._s(_vm.sortIcon('sumConsume')))]), _vm._v(" "), _c('th', [_vm._v("Отчет")]), _vm._v(" "), _c('th', [_vm._v("Действие")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedCampaigns), function(campaign, index) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/campaigns/' + campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(campaign.client) + "\n                ")]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": '#/scenarios/0/' + campaign.scenario
      }
    }, [_vm._v(_vm._s(campaign.scenarioName))])]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDate(campaign.sortingDate)) + " " + _vm._s(campaign.timeStart) + "-" + _vm._s(campaign.timeEnd) + " " + _vm._s(campaign.zoneOffset) + " UTC\n                ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-info is-outlined",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": true
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(campaign.state))])]), _vm._v(" "), _c('tooltip', {
      attrs: {
        "label": "Если в завершенной рассылке остались необработанные номера, укажите новые дату и время рассылки и подтвердите ее готовность для запуска",
        "placement": "top",
        "type": "warning"
      }
    }, [(_vm.canContinue(campaign)) ? _c('button', {
      staticClass: "button is-warning",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.getReadyCallTasksCSV(campaign)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]), _vm._v(" "), _c('span', [_vm._v("Необработанные")])]) : _vm._e()]), _vm._v(" "), _c('tooltip', {
      attrs: {
        "label": "Подтвердите готовность рассылки и она запустится в указанные дату и время",
        "placement": "top",
        "type": "info"
      }
    }, [(_vm.canSetReadyStatus(campaign)) ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive,
        "disabled": _vm.appconfig.disableCampaignSetReadyState
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'readyStatus')
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    })]), _vm._v(" "), _c('span', [_vm._v("Запустить")])]) : _vm._e()])], 1), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDate(campaign.dateCreated)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(campaign.sumConsume) + "\n                ")]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.viewMonitor(campaign)
        }
      }
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v("Мониторинг")])]), _vm._v(" "), _c('div', {
      staticClass: "control"
    }, [(campaign.state == 'Завершена') ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.getReportCSV(campaign)
        }
      }
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v("Отчет в CSV")])]) : _vm._e(), _vm._v(" "), (campaign.state == 'Завершена') ? _c('button', {
      staticClass: "button is-info",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.getSumConsume(campaign)
        }
      }
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v("Стоимость")])]) : _vm._e()])]), _vm._v(" "), _c('td', [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
      staticClass: "button is-success",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "href": '#/campaigns/copy/' + campaign.id,
        "disabled": !_vm.isActive
      }
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v("Копировать")])]) : _vm._e(), _vm._v(" "), (!_vm.canDeleteState(campaign) && _vm.canDelete(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'archive')
        }
      }
    }, [_vm._m(7, true), _vm._v(" "), _c('span', [_vm._v("В архив")])]) : _vm._e(), _vm._v(" "), (_vm.canDeleteState(campaign) && _vm.canDelete(_vm.permissionKey)) ? _c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.isActive
      },
      on: {
        "click": function($event) {
          return _vm.openModal(campaign, 'delete')
        }
      }
    }, [_vm._m(8, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n                Первая\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n                Предыдущая\n              ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n                " + _vm._s(page.name) + "\n              ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n                Следующая\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n                Последняя\n              ")])])], 2)])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title,
      "confirmation": _vm.confirmation,
      "clipboard": false
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tv"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-copy"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-archive"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
}]}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card collapse-item",
    class: {
      'is-fullwidth': _vm.$parent.isFullwidth, 'is-active': _vm.isActived
    }
  }, [_c('header', {
    staticClass: "card-header touchable",
    attrs: {
      "role": "tab",
      "aria-expanded": _vm.selected ? 'true' : 'fase'
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('h3', {
    staticClass: "card-header-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapsed-fade",
      "css": false,
      "appear": ""
    },
    on: {
      "before-appear": _vm.before,
      "appear": _vm.enter,
      "appear-cancel": _vm.cancel,
      "before-enter": _vm.before,
      "enter": _vm.enter,
      "enter-cancel": _vm.cancel,
      "leave": _vm.leave,
      "leave-cancel": _vm.cancel
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActived),
      expression: "isActived"
    }],
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-box"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "card-header-icon"
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_vm._v("Разработано "), _c('a', {
    attrs: {
      "href": "http://ivoice.tech",
      "target": "_blank"
    }
  }, [_vm._v("ivoice.tech")])])])])])
}]}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: ['notification', 'animated', _vm.type ? ("is-" + _vm.type) : '']
  }, [_c('button', {
    staticClass: "delete touchable",
    on: {
      "click": function($event) {
        return _vm.closedByUser()
      }
    }
  }), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left is-flex"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.loggedUser) ? _c('div', {
    staticClass: "nav-item"
  }, [_c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loggedUser))])]), _vm._v(" "), (_vm.loggedUserState != 'Активен') ? _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.loggedUserState))])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('tooltip', {
    attrs: {
      "label": 'beta',
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v(_vm._s(_vm.appTitle))]), _vm._v(" "), _c('strong', {
    staticClass: "admin"
  }, [_vm._v(" Личный Кабинет")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": '#/users/' + _vm.loggedId,
      "tag": "button"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "nav-item",
    attrs: {
      "tag": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(2)]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Профиль пользователя")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://voicebot.doc.ivoice.online/",
      "target": "_blank",
      "tag": "button"
    }
  }, [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-wikipedia-w"
  })]), _vm._v(" "), _c('span', [_vm._v("Помощь")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  })]), _vm._v(" "), _c('span', [_vm._v("Выход")])])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.animation,
      "mode": "out-in",
      "appear": "",
      "appear-active-class": _vm.transition.enterClass,
      "enter-active-class": _vm.transition.enterClass,
      "leave-active-class": _vm.transition.leaveClass
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realSelected),
      expression: "realSelected"
    }],
    class: _vm.classObject,
    attrs: {
      "role": "tabpanel",
      "aria-labelledby": _vm.label,
      "aria-hidden": _vm.hidden
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "jump back-to-top",
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "afterLeave": _vm.afterLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "Логин и пароль"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Введите e-mail"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "placeholder": "Введите пароль"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey) || _vm.loggedId == _vm.user.id) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Профиль пользователя"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Идентификатор пользователя")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.id),
      expression: "profile.id"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": true
    },
    domProps: {
      "value": (_vm.profile.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Клиент")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.client),
      expression: "profile.client"
    }],
    attrs: {
      "disabled": !_vm.canUpdateUserTypeAndState(_vm.permissionKey)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "client", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client.id
      }
    }, [_vm._v("\n                " + _vm._s(client.name) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тип")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.roleId),
      expression: "profile.roleId"
    }],
    attrs: {
      "disabled": !_vm.canUpdateUserTypeAndState(_vm.permissionKey)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "roleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(_vm.loggedRole <= 1) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("СуперАдминистратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 2) ? _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Администратор")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 4) ? _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Партнер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 8) ? _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Реферер")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole <= 16) ? _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("Клиент")]) : _vm._e()])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.state),
      expression: "profile.state"
    }],
    attrs: {
      "disabled": !_vm.canUpdateUserTypeAndState(_vm.permissionKey)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FILL_PROFILE"
    }
  }, [_vm._v("Заполните личную карточку")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SIGN_CONTRACT"
    }
  }, [_vm._v("Ожидаем подписания договора")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "REFILL_BALANCE"
    }
  }, [_vm._v("Нужно пополнить баланс")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ACTIVE"
    }
  }, [_vm._v("Активен")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ФИО")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.fullname),
      expression: "profile.fullname"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.fullname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "fullname", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Часовой пояс (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.timeZone),
      expression: "profile.timeZone"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.profile, "timeZone", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Телефон")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.phone),
      expression: "profile.phone"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("ИНН")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.INN),
      expression: "profile.INN"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.INN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "INN", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.address),
      expression: "profile.address"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "address", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Паспорт")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.passport),
      expression: "profile.passport"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "passport", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Вид деятельности")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.businessType),
      expression: "profile.businessType"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.businessType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "businessType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Менеджер")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.manager),
      expression: "profile.manager"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.manager)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "manager", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тариф")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.tariff),
      expression: "profile.tariff"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.profile.tariff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "tariff", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canUpdate(_vm.permissionKey) || _vm.loggedId == _vm.user.id) ? _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "id": "uploadFile",
      "value": "Загрузить скан договора (pdf, jpg, png; до 10 Мб)",
      "onclick": "document.getElementById('uploadContract').click();"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadContract",
      "name": "load-contract",
      "type": "file",
      "accept": ".jpg,.png,.pdf"
    },
    on: {
      "input": function($event) {
        return _vm.uploadContract('uploadContract')
      }
    }
  }), _vm._v(" "), (_vm.profile.contractName != '') ? _c('a', {
    attrs: {
      "href": '/api/profiles/contract?userId=' + _vm.user.id,
      "tag": "button"
    }
  }, [_c('button', {
    staticClass: "button is-info"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('span', [_vm._v("Просмотр договора")])])]) : _vm._e()]), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey) || _vm.loggedId == _vm.user.id) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.saveProfile
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "Лицевой счет"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.username),
      expression: "profile.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": true
    },
    domProps: {
      "value": (_vm.profile.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profile, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('date')
      }
    }
  }, [_vm._v("Дата" + _vm._s(_vm.sortIcon('date')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumPay')
      }
    }
  }, [_vm._v("Сумма пополнено" + _vm._s(_vm.sortIcon('sumPay')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('sumConsume')
      }
    }
  }, [_vm._v("Сумма израсходовано" + _vm._s(_vm.sortIcon('sumConsume')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('author')
      }
    }
  }, [_vm._v("Автор" + _vm._s(_vm.sortIcon('author')))]), _vm._v(" "), _c('th', [_vm._v("Действие")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.sortedBillings), function(billing) {
    return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(billing.date) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(billing.sumPay) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(billing.sumConsume) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(billing.author) + "\n                ")]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), (_vm.canUpdateUserPayment(_vm.permissionKey)) ? _c('tr', [_c('td', [_c('datepicker', {
    attrs: {
      "placeholder": "Введите дату",
      "inputClass": {
        test: true
      },
      "config": {
        wrap: true,
        dateFormat: 'd.m.Y',
        locale: _vm.l10n
      },
      "readonly": ""
    },
    model: {
      value: (_vm.newbilling.date),
      callback: function($$v) {
        _vm.$set(_vm.newbilling, "date", $$v)
      },
      expression: "newbilling.date"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "data-clear": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])], 1), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newbilling.sumPay),
      expression: "newbilling.sumPay"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты"
    },
    domProps: {
      "value": (_vm.newbilling.sumPay)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newbilling, "sumPay", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _c('td', [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.addPayment
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Добавить оплату")])])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ИТОГО")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.sumPay))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.sumConsume))]), _vm._v(" "), _c('th', [_vm._v("ОСТАТОК")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.balance))])])], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n                  Первая\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n                  Предыдущая\n                ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(page.name) + "\n                ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n                  Следующая\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n                  Последняя\n                ")])])], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loggedId == _vm.user.id) ? _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.makePayment
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })]), _vm._v(" "), _c('span', [_vm._v("Оплатить на сумму")])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumPayment),
      expression: "sumPayment"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты"
    },
    domProps: {
      "value": (_vm.sumPayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sumPayment = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "SUPERADMIN"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.SuperAdministrator), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "ADMIN"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Administrator), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "PARTNER"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Partner), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "REFERRER"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign&Client:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Referrer), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])]), _vm._v(" "), _c('tab-pane', {
    attrs: {
      "label": "CLIENT"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Create")]), _vm._v(" "), _c('th', [_vm._v("Read")]), _vm._v(" "), _c('th', [_vm._v("Update")]), _vm._v(" "), _c('th', [_vm._v("Delete")]), _vm._v(" "), _c('th', [_vm._v("Campaign:Moderate / User:SelectUser")]), _vm._v(" "), _c('th', [_vm._v("Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState")]), _vm._v(" "), _c('th', [_vm._v("Campaign:AccessAdditionalParameters / User:UpdateUserPayment")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.permissionMapByRole.Client), function(permission) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(permission[0]))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[1]),
        expression: "permission[1]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[1]"
      },
      domProps: {
        "checked": Array.isArray(permission[1]) ? _vm._i(permission[1], "permission[1]") > -1 : (permission[1])
      },
      on: {
        "change": function($event) {
          var $$a = permission[1],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[1]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 1, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 1, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 1, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[2]),
        expression: "permission[2]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[2]"
      },
      domProps: {
        "checked": Array.isArray(permission[2]) ? _vm._i(permission[2], "permission[2]") > -1 : (permission[2])
      },
      on: {
        "change": function($event) {
          var $$a = permission[2],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[2]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 2, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 2, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 2, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[3]),
        expression: "permission[3]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[3]"
      },
      domProps: {
        "checked": Array.isArray(permission[3]) ? _vm._i(permission[3], "permission[3]") > -1 : (permission[3])
      },
      on: {
        "change": function($event) {
          var $$a = permission[3],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[3]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 3, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 3, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 3, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[4]),
        expression: "permission[4]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[4]"
      },
      domProps: {
        "checked": Array.isArray(permission[4]) ? _vm._i(permission[4], "permission[4]") > -1 : (permission[4])
      },
      on: {
        "change": function($event) {
          var $$a = permission[4],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[4]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 4, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 4, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 4, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[5]),
        expression: "permission[5]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[5]"
      },
      domProps: {
        "checked": Array.isArray(permission[5]) ? _vm._i(permission[5], "permission[5]") > -1 : (permission[5])
      },
      on: {
        "change": function($event) {
          var $$a = permission[5],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[5]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 5, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 5, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 5, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[6]),
        expression: "permission[6]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[6]"
      },
      domProps: {
        "checked": Array.isArray(permission[6]) ? _vm._i(permission[6], "permission[6]") > -1 : (permission[6])
      },
      on: {
        "change": function($event) {
          var $$a = permission[6],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[6]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 6, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 6, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 6, $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (permission[7]),
        expression: "permission[7]"
      }],
      attrs: {
        "type": "checkbox",
        "value": "permission[7]"
      },
      domProps: {
        "checked": Array.isArray(permission[7]) ? _vm._i(permission[7], "permission[7]") > -1 : (permission[7])
      },
      on: {
        "change": function($event) {
          var $$a = permission[7],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "permission[7]",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(permission, 7, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(permission, 7, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(permission, 7, $$c)
          }
        }
      }
    })])])
  }), 0)])])])], 1), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), (_vm.canUpdate(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.setDefaultPermissions
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Установить значения по умолчанию")])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-industry"
  })])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "input",
    class: _vm.inputClass,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', [(_vm.isLast(index)) ? _c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(_vm.showName(item)))]) : _c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(_vm.showName(item)))])], 1)
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ar"
  }, [(_vm.isUploading) ? _c('div', {
    staticClass: "ar__overlay"
  }) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('div', {
    staticClass: "ar-spinner"
  }, [_c('div', {
    staticClass: "ar-spinner__dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "ar-spinner__dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "ar-spinner__dot"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ar-content",
    class: {
      'ar__blur': _vm.isUploading
    }
  }, [_c('div', {
    staticClass: "ar-recorder"
  }, [_c('icon-button', {
    staticClass: "ar-icon ar-icon__lg",
    class: {
      'ar-icon--rec': _vm.isRecording,
      'ar-icon--pulse': _vm.isRecording && _vm.volume > 0.02
    },
    attrs: {
      "name": _vm.iconButtonType
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleRecorder($event)
      }
    }
  }), _vm._v(" "), _c('icon-button', {
    staticClass: "ar-icon ar-icon__sm ar-recorder__stop",
    attrs: {
      "name": "stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopRecorder($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ar-recorder__duration"
  }, [_vm._v(_vm._s(_vm.recordedTime))]), _vm._v(" "), (_vm.time) ? _c('div', {
    staticClass: "ar-recorder__time-limit"
  }, [_vm._v("Длительность записи ограничена: " + _vm._s(_vm.time) + " мин")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ar-records"
  }, [(_vm.audioSource.url) ? _c('audio', {
    ref: "questionPlayer",
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.audioSource.url
    }
  }), _vm._v("\n        Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ar__upload-status"
  }, [(_vm.audioSource.url) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.retry
    }
  }, [_vm._v("Перезаписать")]) : _vm._e(), _vm._v(" "), (_vm.audioSource.url) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm', _vm.audioSource)
      }
    }
  }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-link",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Закрыть")])]), _vm._v(" "), (_vm.uploadStatus) ? _c('div', {
    class: _vm.uploadStatusClasses
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "second-layer add-button-wrapper"
  }, [_vm._l((_vm.scenario.parameters.dynamicQuestions), function(parameter, index) {
    return _c('div', {
      key: parameter.key
    }, [(_vm.scenario.parameters.dynamicQuestions.length != index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Вопрос опроса " + _vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.dynamicQuestions.length == index + 1) ? _c('label', {
      staticClass: "label"
    }, [_vm._v("Заключительное сообщение")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": false,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, false)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", false)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.scenario.parameters.dynamicQuestions[index].generationState),
        expression: "scenario.parameters.dynamicQuestions[index].generationState"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": true,
        "checked": _vm._q(_vm.scenario.parameters.dynamicQuestions[index].generationState, true)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.scenario.parameters.dynamicQuestions[index], "generationState", true)
        }, function($event) {
          return _vm.onChangeGenerationState(parameter.generationState, index, parameter.key)
        }]
      }
    }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.text),
        expression: "parameter.text"
      }],
      staticClass: "textarea",
      domProps: {
        "value": (parameter.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "text", $event.target.value)
        }
      }
    })]), _c('div', {
      staticClass: "control is-grouped"
    }, [_c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.genAudio(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoading) ? _c('div', {
      staticClass: "loader spinner"
    }) : _vm._e(), _vm._v("\n                Сгенерировать аудио\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicSpeaker),
        expression: "tmp.dynamicTmp[index].dynamicSpeaker"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicSpeaker", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.speakerList), function(speaker) {
      return _c('option', [_vm._v("\n                    " + _vm._s(speaker.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "select is-primary"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tmp.dynamicTmp[index].dynamicEmotion),
        expression: "tmp.dynamicTmp[index].dynamicEmotion"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tmp.dynamicTmp[index], "dynamicEmotion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.emotionList), function(emotion) {
      return _c('option', [_vm._v("\n                    " + _vm._s(emotion.value) + "\n                  ")])
    }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
      attrs: {
        "size": "small",
        "value": _vm.tmp.dynamicTmp[index].dynamicSpeed,
        "min": 0.1,
        "step": 0.1,
        "max": 3
      },
      on: {
        "change": function($event) {
          _vm.tmp.dynamicTmp[index].dynamicSpeed = $event
        }
      }
    }), _vm._v("\n                Скорость: " + _vm._s(_vm.tmp.dynamicTmp[index].dynamicSpeed) + "\n              ")], 1), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicGeneratedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!parameter.generationState) ? _c('div', [_c('p', {
      staticClass: "control"
    }), _c('div', {
      staticClass: "control"
    }, [_c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Загрузить из файла"
      },
      on: {
        "click": function($event) {
          return _vm.clickLoadAudio(parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      ref: ("load-audio-" + (parameter.key)),
      refInFor: true,
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "name": "load-audio",
        "type": "file",
        "accept": ".wav,.mp3"
      },
      on: {
        "input": function($event) {
          return _vm.loadAudio(index, parameter.key)
        }
      }
    }), _vm._v(" "), _c('input', {
      staticClass: "button is-info",
      attrs: {
        "type": "button",
        "value": "Записать с микрофона"
      },
      on: {
        "click": function($event) {
          return _vm.openModal(index, parameter.key, '', '')
        }
      }
    }), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio', {
      ref: ("audio-" + (parameter.key)),
      refInFor: true
    }, [_c('source', {
      attrs: {
        "src": parameter.audio
      }
    }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.dynamicTmp[index].dynamicLoadedAudio) ? _c('audio-player', {
      attrs: {
        "file": parameter.audio
      }
    }) : _vm._e(), _vm._v(" "), (index !== 0) ? _c('button', {
      staticClass: "button is-link delete-button",
      on: {
        "click": function($event) {
          return _vm.deleteParameter(index)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])]) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "button-center"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined add-new",
    on: {
      "click": _vm.addNewParameter
    }
  }, [_vm._v("+")])])], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main",
    style: ([_vm.hiddenSidebarStyle])
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('levelbar'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('name')
      }
    }
  }, [_vm._v("Наименование" + _vm._s(_vm.sortIcon('name')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('thead', [_vm._l((_vm.sortedClients), function(client) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/users/client/' + client.id
      }
    }, [_vm._v(_vm._s(client.name))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.canDelete(_vm.permissionKey)
      },
      on: {
        "click": function($event) {
          return _vm.removeClient(client)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), (_vm.canCreate(_vm.permissionKey)) ? _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newClient.name),
      expression: "newClient.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите наименование клиента"
    },
    domProps: {
      "value": (_vm.newClient.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newClient, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.addClient
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Добавить клиента")])])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [(_vm.canCreate(_vm.permissionKey)) ? _c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#/users/new"
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Создать пользователя")])]) : _vm._e()]), _vm._v(" "), (_vm.canSelectUser(_vm.permissionKey)) ? _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.addUserByIdToMain
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Подобрать пользователя по идентификатору")])])]) : _vm._e(), _vm._v(" "), (_vm.canSelectUser(_vm.permissionKey)) ? _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependedUserId),
      expression: "dependedUserId"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Идентификатор"
    },
    domProps: {
      "value": (_vm.dependedUserId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dependedUserId = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('username')
      }
    }
  }, [_vm._v("E-mail" + _vm._s(_vm.sortIcon('username')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('id')
      }
    }
  }, [_vm._v("Идентификатор" + _vm._s(_vm.sortIcon('id')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('roleString')
      }
    }
  }, [_vm._v("Роль" + _vm._s(_vm.sortIcon('roleString')))]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        return _vm.sort('state')
      }
    }
  }, [_vm._v("Статус" + _vm._s(_vm.sortIcon('state')))])])]), _vm._v(" "), _c('thead', _vm._l((_vm.sortedUsers), function(user) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/users/' + user.id
      }
    }, [_vm._v(_vm._s(user.username))])]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(user.id) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(user.roleString) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(user.state) + "\n              ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to first page"
    },
    on: {
      "click": _vm.onClickFirstPage
    }
  }, [_vm._v("\n              Первая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInFirstPage,
      "aria-label": "Go to previous page"
    },
    on: {
      "click": _vm.onClickPreviousPage
    }
  }, [_vm._v("\n              Предыдущая\n            ")])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "pagination-item"
    }, [_c('button', {
      class: {
        activepage: _vm.isPageActive(page.name)
      },
      attrs: {
        "type": "button",
        "disabled": page.isDisabled,
        "aria-label": ("Go to page number " + (page.name))
      },
      on: {
        "click": function($event) {
          return _vm.onClickPage(page.name)
        }
      }
    }, [_vm._v("\n              " + _vm._s(page.name) + "\n            ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to next page"
    },
    on: {
      "click": _vm.onClickNextPage
    }
  }, [_vm._v("\n              Следующая\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "pagination-item"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isInLastPage,
      "aria-label": "Go to last page"
    },
    on: {
      "click": _vm.onClickLastPage
    }
  }, [_vm._v("\n              Последняя\n            ")])])], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
}]}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "Параметры рассылки"
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Название")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.namePostfix),
      expression: "campaign.namePostfix"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название рассылки",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.namePostfix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "namePostfix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Дата прозвона")]), _vm._v(" "), _c('datepicker', {
    staticClass: "date",
    attrs: {
      "disabled": !_vm.canEdit() && !_vm.canContinue(),
      "placeholder": "Введите дату",
      "config": {
        wrap: true,
        dateFormat: 'd.m.Y',
        locale: _vm.l10n
      }
    },
    model: {
      value: (_vm.campaign.date),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "date", $$v)
      },
      expression: "campaign.date"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "data-toggle": "",
      "disabled": !_vm.canEdit() && !_vm.canContinue()
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "data-clear": "",
      "disabled": !_vm.canEdit() && !_vm.canContinue()
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Часовой пояс (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.zoneOffset),
      expression: "campaign.zoneOffset"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "zoneOffset", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Время прозвона")]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_vm._v("\n            С"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.timeStart),
      expression: "campaign.timeStart"
    }],
    staticClass: "time",
    attrs: {
      "type": "text",
      "pattern": "(([0,1][0-9])|(2[0-3])):[0-5][0-9]",
      "placeholder": "XX:XX",
      "value": "10:00",
      "readonly": !_vm.canEdit() && !_vm.canContinue(),
      "onblur": _vm.transformTimeStart()
    },
    domProps: {
      "value": (_vm.campaign.timeStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "timeStart", $event.target.value)
      }
    }
  }), _vm._v("\n              До"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.timeEnd),
      expression: "campaign.timeEnd"
    }],
    staticClass: "time",
    attrs: {
      "type": "text",
      "pattern": "(([0,1][0-9])|(2[0-3])):[0-5][0-9]",
      "placeholder": "XX:XX",
      "value": "18:00",
      "readonly": !_vm.canEdit() && !_vm.canContinue(),
      "onblur": _vm.transformTimeEnd()
    },
    domProps: {
      "value": (_vm.campaign.timeEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "timeEnd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Количество попыток дозвониться")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingAttempts),
      expression: "campaign.postponingAttempts"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "postponingAttempts", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Интервал между потворными звонками (минуты)")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingIntervalMin),
      expression: "campaign.postponingIntervalMin"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "postponingIntervalMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("30")]), _vm._v(" "), _c('option', [_vm._v("60")]), _vm._v(" "), _c('option', [_vm._v("120")]), _vm._v(" "), _c('option', [_vm._v("240")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Сценарий")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.scenario),
      expression: "campaign.scenario"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.getScenarioReadyState,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "scenario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.scenarios), function(scenario) {
    return _c('option', {
      domProps: {
        "value": scenario.id
      }
    }, [_vm._v("\n                " + _vm._s(scenario.name) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.campaign.scenario) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.gotoScenario
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('span', [_vm._v("Открыть сценарий")])]) : _vm._e(), _vm._v(" "), (_vm.isReadyScenario) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v("Сценарий подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v("Сценарий не подготовлен")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("База")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit(),
      "type": "button",
      "id": "uploadFile",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('uploadPhones')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadPhones",
      "name": "load-phones",
      "type": "file",
      "accept": ".txt,.csv,.xls,.xlsx"
    },
    on: {
      "input": function($event) {
        return _vm.uploadPhones('uploadPhones')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.openModalClipboard
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]), _vm._v(" "), _c('span', [_vm._v("Загрузить из буфера обмена")])]), _vm._v(" "), (_vm.tasksCount > 0) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewCallTasks
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })]), _vm._v(" "), _c('span', [_vm._v("Просмотреть базу")])]) : _vm._e(), _vm._v(" "), (_vm.tasksCountPerformed == 0 && _vm.tasksCount > 0 && !_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-light delete-button",
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.openModalDelete
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить базу")])]) : _vm._e(), _vm._v(" "), (_vm.canContinue()) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.getReadyCallTasksCSV
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v("Необработанные номера")])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("Загружено номеров: " + _vm._s(_vm.tasksCount))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Тестовый звонок")]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.campaign.archiveStatus
    },
    on: {
      "click": function($event) {
        return _vm.callTest(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-volume-control-phone"
  })]), _vm._v(" "), _c('span', [_vm._v("Позвонить на номер")])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testPhone),
      expression: "testPhone"
    }],
    staticClass: "input",
    attrs: {
      "disabled": _vm.campaign.archiveStatus,
      "type": "text",
      "placeholder": "Введите номер"
    },
    domProps: {
      "value": (_vm.testPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewTestCallTasks
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })]), _vm._v(" "), _c('span', [_vm._v("Просмотреть результаты тестов")])])])]), _vm._v(" "), (!_vm.campaign.archiveStatus) ? _c('div', {
    staticClass: "control"
  }, [_c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    attrs: {
      "title": "Параметры тестового звонка"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.testPhoneParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTestPhoneParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addTestPhoneParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Добавить")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('tab-pane', {
    attrs: {
      "label": "Дополнительные параметры"
    }
  }, [(_vm.loggedRole == 1) ? _c('label', {
    staticClass: "label"
  }, [_vm._v("FS Gateway")]) : _vm._e(), _vm._v(" "), (_vm.loggedRole == 1) ? _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.gateway),
      expression: "campaign.gateway"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "gateway", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.fsGateways), function(fsGateway) {
    return _c('option', {
      domProps: {
        "value": fsGateway.name
      }
    }, [_vm._v("\n                " + _vm._s(fsGateway.name) + "\n              ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Приоритет")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.priority),
      expression: "campaign.priority"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Приоритет рассылки",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.priority)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "priority", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Record Host")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.recordHost),
      expression: "campaign.recordHost"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.recordHost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "recordHost", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Postponing Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingStrategy),
      expression: "campaign.postponingStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.postponingStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "postponingStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Schedule Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.scheduleStrategy),
      expression: "campaign.scheduleStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.scheduleStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "scheduleStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Tel Error Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.telErrorStrategy),
      expression: "campaign.telErrorStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.telErrorStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "telErrorStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Dialplan Context")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.dialplanContext),
      expression: "campaign.dialplanContext"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.dialplanContext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "dialplanContext", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Dialplan Extension")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.dialplanExtension),
      expression: "campaign.dialplanExtension"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.dialplanExtension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "dialplanExtension", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Target Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.targetStrategy),
      expression: "campaign.targetStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.targetStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "targetStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Phone Preprocessing Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.phonePreprocessingStrategy),
      expression: "campaign.phonePreprocessingStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.phonePreprocessingStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "phonePreprocessingStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.phonePreprocessingParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.canEdit()
      },
      on: {
        "click": function($event) {
          return _vm.deletePhonePreprocessingParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.addPhonePreprocessingParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Добавить")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canEdit() || _vm.canContinue()) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), (_vm.canSetReadyStatus() && !_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit(),
      "disabled": _vm.appconfig.disableCampaignSetReadyState
    },
    on: {
      "click": _vm.openModalReady
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Подвтердить готовность")])]) : _vm._e(), _vm._v(" "), (_vm.campaign.state == 'Завершена') ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.getReportCSV
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Загрузить отчет CSV")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), (!_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewMonitor
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v("Мониторинг рассылки")])]) : _vm._e()]), _vm._v(" "), (_vm.loggedUser == _vm.campaign.client) ? _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.makePayment
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Оплатить рассылку на сумму")])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sumPayment),
      expression: "sumPayment"
    }],
    staticClass: "input",
    attrs: {
      "type": "",
      "placeholder": "Введите сумму оплаты",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.sumPayment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sumPayment = $event.target.value
      }
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title,
      "confirmation": _vm.confirmation,
      "clipboard": !_vm.confirmation
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tv"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })])
}]}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("по рассылке " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('div', {
    staticClass: "jump-target"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.calltasks), function(calltask) {
    return _c('tr', [_c('td', [(calltask.testing) ? _c('strong', [_vm._v(_vm._s(calltask.phone))]) : _vm._e(), _vm._v(" "), (!calltask.testing) ? _c('div', [_vm._v(_vm._s(calltask.phone))]) : _vm._e()]), _vm._v(" "), _c('td', [(calltask.testing) ? _c('strong', [_vm._v(_vm._s(_vm.getCallTaskState(calltask.state)))]) : _vm._e(), _vm._v(" "), (!calltask.testing) ? _c('div', [_vm._v(_vm._s(_vm.getCallTaskState(calltask.state)))]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "target": ".jump-target"
    }
  }, [_c('button', {
    staticClass: "button"
  }, [_vm._v("Наверх")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Телефон")]), _vm._v(" "), _c('th', [_vm._v("Состояние")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.loadedScenario))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Название сценария")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Введите название сценария"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 1")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstGenerationState),
      expression: "scenario.parameters.questionFirstGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionFirstGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionFirstGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionFirstGenerationState', 'questionFirstAudio', 'questionFirstGeneratedAudio', 'questionFirstLoadedAudio', 'onQuestionFirst')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionFirstText),
      expression: "scenario.parameters.questionFirstText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionFirstText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionFirstText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionFirstId', 'questionFirstAudio', 'currentSpeakerFirst', 'questionFirstGeneratedAudio', 'questionFirstText', 'questionFirstLoading', 'First question', 'currentEmotionFirst', 'currentSpeedFirst')
      }
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.tmp.questionFirstLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n              Сгенерировать аудио\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerFirst),
      expression: "tmp.currentSpeakerFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                  " + _vm._s(speaker.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionFirst),
      expression: "tmp.currentEmotionFirst"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionFirst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                  " + _vm._s(emotion.value) + "\n                ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedFirst,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedFirst = $event
      }
    }
  }), _vm._v("\n              Скорость: " + _vm._s(_vm.tmp.currentSpeedFirst) + "\n            ")], 1), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionFirstGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionFirstLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionFirstLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionFirstLoadedAudio', 'questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question', 'onQuestionFirst')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'First question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio', {
    ref: 'onQuestionFirst'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionFirstAudio
    }
  }), _vm._v("\n              Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionFirstLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionFirstAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionFirstId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionFirstId', 'questionFirstAudio', 'questionFirstLoadedAudio', 'questionFirstGeneratedAudio')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer positive-scenario"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение (При ответе Да на Вопрос 1)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesGenerationState),
      expression: "scenario.parameters.questionSecondYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesGenerationState', 'questionSecondYesAudio', 'questionSecondYesGeneratedAudio', 'questionSecondYesLoadedAudio', 'onQuestionSecondYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesText),
      expression: "scenario.parameters.questionSecondYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesId', 'questionSecondYesAudio', 'currentSpeakerSecondYes', 'questionSecondYesGeneratedAudio', 'questionSecondYesText', 'questionSecondYesLoading', 'Second yes question', 'currentEmotionSecondYes', 'currentSpeedSecondYes')
      }
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.tmp.questionSecondYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYes),
      expression: "tmp.currentSpeakerSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                     " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYes),
      expression: "tmp.currentEmotionSecondYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesLoadedAudio', 'questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question', 'onQuestionSecondYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'Second yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesId', 'questionSecondYesAudio', 'questionSecondYesLoadedAudio', 'questionSecondYesGeneratedAudio')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.questionSecondYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesSMSText),
      expression: "scenario.parameters.questionSecondYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesSMSText", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesGenerationState),
      expression: "scenario.parameters.questionSecondYesYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesGenerationState),
      expression: "scenario.parameters.questionSecondYesYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesYesGenerationState', 'questionSecondYesYesAudio', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesLoadedAudio', 'onQuestionSecondYesYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesText),
      expression: "scenario.parameters.questionSecondYesYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'currentSpeakerSecondYesYes', 'questionSecondYesYesGeneratedAudio', 'questionSecondYesYesText', 'questionSecondYesYesLoading', 'Second yes yes question', 'currentEmotionSecondYesYes', 'currentSpeedSecondYesYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYesYes),
      expression: "tmp.currentSpeakerSecondYesYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYesYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                       " + _vm._s(speaker.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYesYes),
      expression: "tmp.currentEmotionSecondYesYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYesYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                        " + _vm._s(emotion.value) + "\n                      ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYesYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYesYes = $event
      }
    }
  }), _vm._v("\n                    Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYesYes) + "\n                  ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesYesLoadedAudio', 'questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question', 'onQuestionSecondYesYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'Second yes yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesYesId', 'questionSecondYesYesAudio', 'questionSecondYesYesLoadedAudio', 'questionSecondYesYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('collapse', [_c('collapse-item', {
    staticClass: "positive-scenario",
    attrs: {
      "title": "Отправить СМС",
      "selected": _vm.scenario.parameters.questionSecondYesYesSMSText != ''
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesYesSMSText),
      expression: "scenario.parameters.questionSecondYesYesSMSText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesYesSMSText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesYesSMSText", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondYesNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoGenerationState),
      expression: "scenario.parameters.questionSecondYesNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoGenerationState),
      expression: "scenario.parameters.questionSecondYesNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondYesNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondYesNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondYesNoGenerationState', 'questionSecondYesNoAudio', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoLoadedAudio', 'onQuestionSecondYesNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondYesNoText),
      expression: "scenario.parameters.questionSecondYesNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondYesNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondYesNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'currentSpeakerSecondYesNo', 'questionSecondYesNoGeneratedAudio', 'questionSecondYesNoText', 'questionSecondYesNoLoading', 'Second yes no question', 'currentEmotionSecondYesNo', 'currentSpeedSecondYesNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondYesNo),
      expression: "tmp.currentSpeakerSecondYesNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondYesNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondYesNo),
      expression: "tmp.currentEmotionSecondYesNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondYesNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondYesNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondYesNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondYesNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondYesNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondYesNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondYesNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondYesNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondYesNoLoadedAudio', 'questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question', 'onQuestionSecondYesNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'Second yes no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondYesNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondYesNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondYesNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondYesNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondYesNoId', 'questionSecondYesNoAudio', 'questionSecondYesNoLoadedAudio', 'questionSecondYesNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])])], 1)], 1)], 1)]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "10px"
    }
  }), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "second-layer negative-scenario"
  }, [_c('div', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Вопрос 2 / Сообщение (При ответе Нет на Вопрос 1)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoGenerationState),
      expression: "scenario.parameters.questionSecondNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoGenerationState', 'questionSecondNoAudio', 'questionSecondNoGeneratedAudio', 'questionSecondNoLoadedAudio', 'onQuestionSecondNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoText),
      expression: "scenario.parameters.questionSecondNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoId', 'questionSecondNoAudio', 'currentSpeakerSecondNo', 'questionSecondNoGeneratedAudio', 'questionSecondNoText', 'questionSecondNoLoading', 'Second no question', 'currentEmotionSecondNo', 'currentSpeedSecondNo')
      }
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.tmp.questionSecondNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNo),
      expression: "tmp.currentSpeakerSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNo),
      expression: "tmp.currentEmotionSecondNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoLoadedAudio', 'questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question', 'onQuestionSecondNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'Second no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoId', 'questionSecondNoAudio', 'questionSecondNoLoadedAudio', 'questionSecondNoGeneratedAudio')
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "block is-flex"
  }, [_c('collapse', [_c('collapse-item', {
    staticClass: "second-layer positive-scenario",
    attrs: {
      "title": "Сообщение при ответе Да на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoYesId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesGenerationState),
      expression: "scenario.parameters.questionSecondNoYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoYesGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoYesGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesGenerationState),
      expression: "scenario.parameters.questionSecondNoYesGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoYesGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoYesGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoYesGenerationState', 'questionSecondNoYesAudio', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesLoadedAudio', 'onQuestionSecondNoYes')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoYesText),
      expression: "scenario.parameters.questionSecondNoYesText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoYesText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoYesText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'currentSpeakerSecondNoYes', 'questionSecondNoYesGeneratedAudio', 'questionSecondNoYesText', 'questionSecondNoYesLoading', 'Second no yes question', 'currentEmotionSecondNoYes', 'currentSpeedSecondNoYes')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNoYes),
      expression: "tmp.currentSpeakerSecondNoYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNoYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNoYes),
      expression: "tmp.currentEmotionSecondNoYes"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNoYes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNoYes,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNoYes = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNoYes) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoYesGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoYesGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoYesGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoYesLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoYesLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoYesLoadedAudio', 'questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question', 'onQuestionSecondNoYes')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'Second no yes question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoYes'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoYesLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoYesAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoYesId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoYesId', 'questionSecondNoYesAudio', 'questionSecondNoYesLoadedAudio', 'questionSecondNoYesGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])]), _vm._v(" "), _c('collapse-item', {
    staticClass: "second-layer negative-scenario",
    attrs: {
      "title": "Сообщение при ответе Нет на Вопрос 2",
      "selected": _vm.scenario.parameters.questionSecondNoNoId != ''
    }
  }, [_c('div', [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoGenerationState),
      expression: "scenario.parameters.questionSecondNoNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoNoGenerationState, false)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoNoGenerationState", false)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Загрузить аудио")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoGenerationState),
      expression: "scenario.parameters.questionSecondNoNoGenerationState"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.scenario.parameters.questionSecondNoNoGenerationState, true)
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.scenario.parameters, "questionSecondNoNoGenerationState", true)
      }, function($event) {
        return _vm.onChangeGenerationState('questionSecondNoNoGenerationState', 'questionSecondNoNoAudio', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoLoadedAudio', 'onQuestionSecondNoNo')
      }]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Сгенерировать аудио")])]), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.parameters.questionSecondNoNoText),
      expression: "scenario.parameters.questionSecondNoNoText"
    }],
    staticClass: "textarea",
    domProps: {
      "value": (_vm.scenario.parameters.questionSecondNoNoText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario.parameters, "questionSecondNoNoText", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.genAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'currentSpeakerSecondNoNo', 'questionSecondNoNoGeneratedAudio', 'questionSecondNoNoText', 'questionSecondNoNoLoading', 'Second no no question', 'currentEmotionSecondNoNo', 'currentSpeedSecondNoNo')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })]), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoading) ? _c('div', {
    staticClass: "loader spinner"
  }) : _vm._e(), _vm._v("\n                  Сгенерировать аудио\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentSpeakerSecondNoNo),
      expression: "tmp.currentSpeakerSecondNoNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentSpeakerSecondNoNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.speakerList), function(speaker) {
    return _c('option', [_vm._v("\n                      " + _vm._s(speaker.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.currentEmotionSecondNoNo),
      expression: "tmp.currentEmotionSecondNoNo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "currentEmotionSecondNoNo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.emotionList), function(emotion) {
    return _c('option', [_vm._v("\n                      " + _vm._s(emotion.value) + "\n                    ")])
  }), 0)]), _vm._v(" "), _c('p', [_c('slider', {
    attrs: {
      "size": "small",
      "value": _vm.tmp.currentSpeedSecondNoNo,
      "min": 0.1,
      "step": 0.1,
      "max": 3
    },
    on: {
      "change": function($event) {
        _vm.tmp.currentSpeedSecondNoNo = $event
      }
    }
  }), _vm._v("\n                  Скорость: " + _vm._s(_vm.tmp.currentSpeedSecondNoNo) + "\n                ")], 1), _vm._v(" "), (_vm.tmp.questionSecondNoNoGeneratedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }), _vm._v("\n                  Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoNoGeneratedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (!_vm.scenario.parameters.questionSecondNoNoGenerationState) ? _c('div', [_c('p', {
    staticClass: "control"
  }), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Загрузить из файла"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('questionSecondNoNoLoadedAudio')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "questionSecondNoNoLoadedAudio",
      "name": "load-audio",
      "type": "file",
      "accept": ".wav,.mp3"
    },
    on: {
      "input": function($event) {
        return _vm.loadAudio('questionSecondNoNoLoadedAudio', 'questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question', 'onQuestionSecondNoNo')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "Записать с микрофона"
    },
    on: {
      "click": function($event) {
        return _vm.openModal('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'Second no no question')
      }
    }
  }), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoadedAudio) ? _c('audio', {
    ref: 'onQuestionSecondNoNo'
  }, [_c('source', {
    attrs: {
      "src": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }), _vm._v("\n               Ваш браузер не поддерживает html5 audio. Попробуйте chrome.\n              ")]) : _vm._e(), _vm._v(" "), (_vm.tmp.questionSecondNoNoLoadedAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenario.parameters.questionSecondNoNoAudio
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('p')]) : _vm._e(), _vm._v(" "), (_vm.scenario.parameters.questionSecondNoNoId != '') ? _c('div', [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-link delete-button",
    on: {
      "click": function($event) {
        return _vm.deleteAudio('questionSecondNoNoId', 'questionSecondNoNoAudio', 'questionSecondNoNoLoadedAudio', 'questionSecondNoNoGeneratedAudio')
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Удалить аудио")])])])]) : _vm._e()])])], 1)], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(6), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', [_vm._v("Закрыть")])]), _vm._v(" "), _vm._m(8), _vm._v(" "), (_vm.scenario.isReady) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(9), _vm._v(" "), _c('span', [_vm._v("Подготовлен")])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_vm._m(10), _vm._v(" "), _c('span', [_vm._v("Не подготовлен")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button is-primary"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('span', [_vm._v("Рассчитать стоимость")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })])
}]}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jump"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("по клиенту " + _vm._s(_vm.client.name))]), _vm._v(" "), _c('tabs', {
    attrs: {
      "type": "boxed"
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": "Пользователи"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "href": '#/users/' + user.id
      }
    }, [_vm._v(_vm._s(user.username))])])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])]), _vm._v(" "), (_vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('tab-pane', {
    attrs: {
      "label": "Client Config"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ключ")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.clientConfigArray), function(param, index) {
    return _c('tr', [(param[0] != 'activeScenarioTemplates' && param[0] != 'defaultPhonePreprocessingStrategyParameters') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (param[0] != 'activeScenarioTemplates' && param[0] != 'defaultPhonePreprocessingStrategyParameters') ? _c('td', [(param[1] != null) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (param[1] == null) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "placeholder": "Параметр не указан",
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    }) : _vm._e()]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Phone Preprocessing Parameters")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.phonePreprocessingParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deletePhonePreprocessingParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v("Удалить")])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addPhonePreprocessingParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Добавить")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Active Scenario Templates")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Scenario Template")]), _vm._v(" "), _c('th', [_vm._v("Activity")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.activeScenarioTemplatesArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": ""
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.canEdit()) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('span', [_vm._v("Сохранить")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])]) : _vm._e()], 1)], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), (_vm.clipboard) ? _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clipboardArea),
      expression: "clipboardArea"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "Вставьте базу из буфера обмена"
    },
    domProps: {
      "value": (_vm.clipboardArea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clipboardArea = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.confirmation) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("Да")]) : _vm._e(), _vm._v(" "), (_vm.confirmation) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Нет")]) : _vm._e(), _vm._v(" "), (_vm.clipboard) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm', _vm.clipboardArea)
      }
    }
  }, [_vm._v("ОК")]) : _vm._e(), _vm._v(" "), (_vm.clipboard) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Отмена")]) : _vm._e()])])])])])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.realValue),
      expression: "realValue"
    }],
    class: _vm.classObject,
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "name": _vm.name,
      "orient": _vm.vertical && 'vertical',
      "disabled": _vm.disabled,
      "number": ""
    },
    domProps: {
      "value": (_vm.realValue)
    },
    on: {
      "__r": function($event) {
        _vm.realValue = $event.target.value
      }
    }
  })
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("Да")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Нет")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', [_vm._v(_vm._s(_vm.campaign.name))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Статистика задач")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("В очереди")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.ready))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Вызов")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.dialing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Идет разговор")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.ongoing))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Выполнена")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.performed))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Недозвон")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.failed))])])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Метрики прозвона")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Скорость выполнения")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.campaignProgress.performingSpeed))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v("Закрыть")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Состояние")]), _vm._v(" "), _c('th', [_vm._v("Количество")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Метрика")]), _vm._v(" "), _c('th', [_vm._v("Значение")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}

/***/ }),
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */
/***/ (function(module, exports) {

module.exports = {"name":"vue-admin","version":"0.1.12","description":"Vue Admin Panel Framework","repository":"vue-bulma/vue-admin","homepage":"https://admin.vuebulma.com","license":"MIT","author":{"name":"Fangdun Cai","email":"cfddream@gmail.com","url":"fundon.me"},"keywords":["admin","bulma","dashboard","data","visualization","vue"],"engines":{"node":">=4","npm":">=3"},"scripts":{"build":"cross-env NODE_ENV=production node build/build.js","clean":"rm -rf dist","dev":"cross-env NODE_ENV=development node build/dev-server.js","electron":"cross-env NODE_ELECTRON=true npm run build && electron electronIndex.js","gh":"npm run build && gh-pages -d dist","lint":"eslint --ext .js .vue client/*","lint:fix":"eslint --fix --ext .js .vue electron.js client/* build/* config/*","test":"echo lol"},"dependencies":{"@websanova/vue-auth":"^2.8.2-beta","animate.css":"3.5.2","animejs":"^2.0.1","axios":"^0.15.3","bulma":"^0.3.2","font-awesome":"4.7.0","mdi":"^1.8.36","plotly.js":"^1.24.2","vue":"^2.2.2","vue-audio":"0.0.11","vue-axios":"^2.0.1","vue-bulma-brace":"^0.1.0","vue-bulma-breadcrumb":"^1.0.1","vue-bulma-card":"^1.0.2","vue-bulma-chartist":"^1.1.0","vue-bulma-chartjs":"^1.0.4","vue-bulma-collapse":"1.0.3","vue-bulma-datepicker":"^1.3.0","vue-bulma-emoji":"^0.0.2","vue-bulma-expanding":"^0.0.1","vue-bulma-jump":"^0.0.2","vue-bulma-message":"^1.1.1","vue-bulma-modal":"1.0.1","vue-bulma-notification":"^1.1.1","vue-bulma-progress-bar":"^1.0.2","vue-bulma-progress-tracker":"0.0.4","vue-bulma-quill":"0.0.1","vue-bulma-rating":"^1.0.1","vue-bulma-slider":"^1.0.2","vue-bulma-switch":"^1.0.4","vue-bulma-tabs":"^1.1.3","vue-bulma-tooltip":"^1.0.3","vue-cleave":"1.1.1","vue-howler":"^0.7.0","vue-js-toggle-button":"^1.2.3","vue-lory":"0.0.4","vue-nprogress":"0.1.5","vue-peity":"0.5.0","vue-router":"^2.3.0","vuex":"^2.2.1","vuex-router-sync":"^4.1.2","wysiwyg.css":"0.0.2"},"devDependencies":{"autoprefixer":"^6.7.7","babel-core":"^6.21.0","babel-eslint":"^7.1.1","babel-loader":"^6.4.0","babel-plugin-transform-export-extensions":"^6.8.0","babel-preset-es2015":"^6.14.0","babel-preset-stage-2":"^6.17.0","connect-history-api-fallback":"^1.3.0","cross-env":"^3.1.3","css-loader":"^0.27.1","electron-devtools-installer":"^2.0.1","eslint":"^3.17.1","eslint-config-standard":"^7.0.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.6.1","eslint-plugin-html":"^2.0.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^2.1.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^2.0.0-beta.4","file-loader":"^0.10.1","html-webpack-plugin":"^2.25.0","http-proxy-middleware":"^0.17.4","imports-loader":"^0.7.0","node-sass":"^4.1.1","opn":"^4.0.2","ora":"^1.1.0","postcss-loader":"^1.3.3","progress-bar-webpack-plugin":"^1.9.1","sass-loader":"^6.0.3","serve-favicon":"^2.4.1","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^3.0.1","url-loader":"^0.5.7","vue-html-loader":"^1.2.3","vue-loader":"^11.1.4","vue-template-compiler":"^2.2.2","webpack":"^2.2.1","webpack-dev-middleware":"^1.9.0","webpack-hot-middleware":"^2.14.0","webpack-merge":"^4.0.0"}}

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(193);


/***/ })
],[480]);


// WEBPACK FOOTER //
// assets/js/app.0536a0f9430cae9cdb6e.js